import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
};

export type ApplyInvoicesResponse = {
  __typename?: 'ApplyInvoicesResponse';
  companies?: Maybe<Array<Maybe<InvoiceLog>>>;
  cruxyId?: Maybe<Scalars['String']['output']>;
};

export type BatchApplyFormulasResult = {
  __typename?: 'BatchApplyFormulasResult';
  formulaId?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type BestMatches = {
  __typename?: 'BestMatches';
  externalId: Scalars['String']['output'];
  externalName: Scalars['String']['output'];
  internalId: Scalars['String']['output'];
  internalName: Scalars['String']['output'];
  score: Scalars['Float']['output'];
};

export type CrmPipelinesResponse = {
  __typename?: 'CRMPipelinesResponse';
  displayOrder: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CrmTables = {
  __typename?: 'CRMTables';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
};

export type Change = {
  __typename?: 'Change';
  from?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

export type Changes = {
  __typename?: 'Changes';
  country?: Maybe<Change>;
  industry?: Maybe<Change>;
  name?: Maybe<Change>;
  sql?: Maybe<Scalars['String']['output']>;
};

export type ClientsFilter = {
  cruxyId?: InputMaybe<Scalars['String']['input']>;
};

export type ClientsResponse = {
  __typename?: 'ClientsResponse';
  cruxyId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Column = {
  __typename?: 'Column';
  isNumeric: Scalars['Boolean']['output'];
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
};

export type CompaniesFilter = {
  country?: InputMaybe<Scalars['String']['input']>;
  cruxyId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CompaniesResponse = {
  __typename?: 'CompaniesResponse';
  edges: Array<Company>;
  totalCount: Scalars['String']['output'];
};

export type Company = {
  __typename?: 'Company';
  annualRevenue?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createDate?: Maybe<Scalars['String']['output']>;
  createdById?: Maybe<Scalars['String']['output']>;
  cruxyId: Scalars['String']['output'];
  customProperties?: Maybe<Scalars['JSONObject']['output']>;
  id: Scalars['String']['output'];
  industry?: Maybe<Scalars['String']['output']>;
  mainIndustry?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  parentCompanyId?: Maybe<Scalars['String']['output']>;
  territory?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Contact = {
  __typename?: 'Contact';
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export type ConversionRatesResponse = {
  __typename?: 'ConversionRatesResponse';
  conversionRate: Scalars['Float']['output'];
  instanceId: Scalars['String']['output'];
  numberOfDeals: Scalars['Int']['output'];
  stageId: Scalars['String']['output'];
};

export type CreateViewPayload = {
  cubeId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
  datasetName: Scalars['String']['input'];
  outputViewName: Scalars['String']['input'];
};

export type CubesFilter = {
  cubeId?: InputMaybe<Scalars['String']['input']>;
};

export type CubesResponse = {
  __typename?: 'CubesResponse';
  cubeId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CurrentUser = {
  __typename?: 'CurrentUser';
  azure_sas_token?: Maybe<Scalars['String']['output']>;
  cruxyId: Scalars['String']['output'];
  email: Scalars['String']['output'];
  exp?: Maybe<Scalars['Int']['output']>;
  iat?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  role?: Maybe<UserRole>;
};

export type CustomColumn = {
  __typename?: 'CustomColumn';
  columnId?: Maybe<Scalars['ID']['output']>;
  columnName?: Maybe<Scalars['String']['output']>;
  cruxyId?: Maybe<Scalars['String']['output']>;
  tableId?: Maybe<Scalars['String']['output']>;
};

export type CustomColumnFilters = {
  cruxyId: Scalars['String']['input'];
  tableId?: InputMaybe<Scalars['String']['input']>;
};

export type DataFromTablesResponse = {
  __typename?: 'DataFromTablesResponse';
  columnNames: Array<Scalars['String']['output']>;
  uniqueFilenames: Array<Scalars['String']['output']>;
};

export type DatasetFilter = {
  cubeId?: InputMaybe<Scalars['String']['input']>;
  datasetId?: InputMaybe<Scalars['String']['input']>;
};

export type DatasetPreviewFilter = {
  cubeName: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
};

export type DatasetPreviewResponse = {
  __typename?: 'DatasetPreviewResponse';
  dataset: Array<Scalars['JSON']['output']>;
  totalCount: Scalars['Int']['output'];
};

export type DatasetResponse = {
  __typename?: 'DatasetResponse';
  cubeId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Deal = {
  __typename?: 'Deal';
  acv?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['String']['output']>;
  amountInHomeCurrency?: Maybe<Scalars['String']['output']>;
  analyticsLatestSource?: Maybe<Scalars['String']['output']>;
  arr?: Maybe<Scalars['String']['output']>;
  arrWeighted?: Maybe<Scalars['String']['output']>;
  associatedCompany: Array<Maybe<Company>>;
  associatedContact: Array<Maybe<Contact>>;
  closeDate?: Maybe<Scalars['String']['output']>;
  createDate?: Maybe<Scalars['String']['output']>;
  createdById?: Maybe<Scalars['String']['output']>;
  cruxyId: Scalars['String']['output'];
  customProperties?: Maybe<Scalars['JSONObject']['output']>;
  dealCurrencyCode?: Maybe<Scalars['String']['output']>;
  dealName?: Maybe<Scalars['String']['output']>;
  dealOwnerId?: Maybe<Scalars['String']['output']>;
  dealStage?: Maybe<Scalars['String']['output']>;
  fiscalYear?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  pipeline?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type DealsFilter = {
  cruxyId: Scalars['String']['input'];
  dealName?: InputMaybe<Scalars['String']['input']>;
  fiscalYear?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type DealsResponse = {
  __typename?: 'DealsResponse';
  edges: Array<Deal>;
  totalCount: Scalars['String']['output'];
};

export type DeleteHeadroomProjectResponse = {
  __typename?: 'DeleteHeadroomProjectResponse';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeleteInvoicesFilter = {
  cruxyId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  processed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeleteTableResponse = {
  __typename?: 'DeleteTableResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteViewResponse = {
  __typename?: 'DeleteViewResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeletedCubeResponse = {
  __typename?: 'DeletedCubeResponse';
  success: Scalars['Boolean']['output'];
};

export type DriverMetrics = {
  __typename?: 'DriverMetrics';
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  percentile25?: Maybe<Scalars['Float']['output']>;
  percentile50?: Maybe<Scalars['Float']['output']>;
  percentile75?: Maybe<Scalars['Float']['output']>;
};

export type DriverMetricsDataResponse = {
  __typename?: 'DriverMetricsDataResponse';
  edges: Array<DriverMetricsResponse>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
};

export type DriverMetricsResponse = {
  __typename?: 'DriverMetricsResponse';
  FxUniqueRowUuid: Scalars['String']['output'];
  driver1Avg?: Maybe<Scalars['Float']['output']>;
  driver1Denominator?: Maybe<Scalars['Float']['output']>;
  driver1Median?: Maybe<Scalars['Float']['output']>;
  driver1Percentile?: Maybe<Scalars['Float']['output']>;
  driver2Avg?: Maybe<Scalars['Float']['output']>;
  driver2Denominator?: Maybe<Scalars['Float']['output']>;
  driver2Median?: Maybe<Scalars['Float']['output']>;
  driver2Percentile?: Maybe<Scalars['Float']['output']>;
  rangeLower?: Maybe<Scalars['Float']['output']>;
  rangeUpper?: Maybe<Scalars['Float']['output']>;
  segment: Scalars['String']['output'];
  segmentRange?: Maybe<Scalars['String']['output']>;
  segmentValue: Scalars['String']['output'];
};

export type DriverMetricsResponseInput = {
  current?: InputMaybe<Scalars['Float']['input']>;
  driver1Denominator?: InputMaybe<Scalars['Float']['input']>;
  driver1Percentile?: InputMaybe<Scalars['Float']['input']>;
  driver2Denominator?: InputMaybe<Scalars['Float']['input']>;
  driver2Percentile?: InputMaybe<Scalars['Float']['input']>;
  mean?: InputMaybe<Scalars['Float']['input']>;
  segment: Scalars['String']['input'];
  segmentRange?: InputMaybe<Scalars['String']['input']>;
  segmentValue: Scalars['String']['input'];
};

export enum DriverMode {
  Column = 'COLUMN',
  Percentage = 'PERCENTAGE'
}

export type Duplicate = {
  __typename?: 'Duplicate';
  COUNT: Scalars['Int']['output'];
  FX_UNIQUE_ID: Scalars['String']['output'];
  NAME: Scalars['String']['output'];
};

export type Duration = {
  __typename?: 'Duration';
  conversionRate?: Maybe<Scalars['Float']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  numberOfDeals?: Maybe<Scalars['Int']['output']>;
  pipelineInstanceId?: Maybe<Scalars['ID']['output']>;
  stageId?: Maybe<Scalars['ID']['output']>;
};

export type DurationsInput = {
  conversionRate: Scalars['Float']['input'];
  duration: Scalars['Int']['input'];
  numberOfDeals: Scalars['Int']['input'];
  pipelineInstanceOrderNumber: Scalars['Int']['input'];
  stageOrderNumber: Scalars['Int']['input'];
};

export type DynamicDataResponse = {
  __typename?: 'DynamicDataResponse';
  cubeId: Scalars['String']['output'];
  data: Array<TableData>;
  datasetId: Scalars['String']['output'];
  originalFileName?: Maybe<Scalars['String']['output']>;
};

export type EditCompanyFields = {
  annualRevenue?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  createDate?: InputMaybe<Scalars['String']['input']>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentCompanyId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type EditDealFields = {
  acv?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['String']['input']>;
  amountInHomeCurrency?: InputMaybe<Scalars['String']['input']>;
  analyticsLatestSource?: InputMaybe<Scalars['String']['input']>;
  arr?: InputMaybe<Scalars['String']['input']>;
  arrWeighted?: InputMaybe<Scalars['String']['input']>;
  closeDate?: InputMaybe<Scalars['String']['input']>;
  createDate?: InputMaybe<Scalars['String']['input']>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  dealCurrencyCode?: InputMaybe<Scalars['String']['input']>;
  dealName?: InputMaybe<Scalars['String']['input']>;
  dealOwnerId?: InputMaybe<Scalars['String']['input']>;
  dealStage?: InputMaybe<Scalars['String']['input']>;
  fiscalYear?: InputMaybe<Scalars['String']['input']>;
  pipeline?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type FinishMatchResponse = {
  __typename?: 'FinishMatchResponse';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Formula = {
  __typename?: 'Formula';
  columnId: Scalars['String']['output'];
  conditionFormula: Scalars['JSONObject']['output'];
  cruxyId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  valueFormula: Scalars['String']['output'];
};

export type GenericTablesDataHeadroomFinalResult = {
  __typename?: 'GenericTablesDataHeadroomFinalResult';
  edges: Array<HeadroomFinalResponse>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
};

export type GenericTablesDataHeadroomResult = {
  __typename?: 'GenericTablesDataHeadroomResult';
  edges: Array<HeadroomResult>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
};

export type GetAllHeadroomProjectsResponse = {
  __typename?: 'GetAllHeadroomProjectsResponse';
  edges: Array<ProjectNameResponse>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
};

export type GetApplyInvoicesPlanResponse = {
  __typename?: 'GetApplyInvoicesPlanResponse';
  companies?: Maybe<Array<Maybe<InvoiceLog>>>;
  cruxyId?: Maybe<Scalars['String']['output']>;
};

export type GroupedCount = {
  __typename?: 'GroupedCount';
  count: Scalars['Int']['output'];
  groupValue: Scalars['String']['output'];
};

export type GroupedCountsInput = {
  columnName: Scalars['String']['input'];
  segments?: InputMaybe<Array<SegmentInput>>;
  tableName: Scalars['String']['input'];
};

export type GroupedCountsResponse = {
  __typename?: 'GroupedCountsResponse';
  groupCounts: Array<GroupedCount>;
};

export type HeadroomFinalResponse = {
  __typename?: 'HeadroomFinalResponse';
  FxUniqueRowUuid: Scalars['String']['output'];
  driverFinal?: Maybe<Scalars['Float']['output']>;
  driverInitial?: Maybe<Scalars['Float']['output']>;
  headroom?: Maybe<Scalars['Float']['output']>;
  headroomPercent?: Maybe<Scalars['Float']['output']>;
  increasedPenetration?: Maybe<Scalars['Float']['output']>;
  penetration?: Maybe<Scalars['Float']['output']>;
  segment: Scalars['String']['output'];
  segmentRange?: Maybe<Scalars['String']['output']>;
  segmentValue: Scalars['String']['output'];
  totalCustomers: Scalars['Int']['output'];
  totalCustomersAfter: Scalars['Float']['output'];
  totalDriverFinal?: Maybe<Scalars['Float']['output']>;
  totalDriverInitial?: Maybe<Scalars['Float']['output']>;
  totalHeadroom?: Maybe<Scalars['Float']['output']>;
  totalProspects: Scalars['Int']['output'];
};

export type HeadroomFinalResponseInput = {
  driverFinal?: InputMaybe<Scalars['Float']['input']>;
  driverInitial?: InputMaybe<Scalars['Float']['input']>;
  headroom?: InputMaybe<Scalars['Float']['input']>;
  headroomPercent?: InputMaybe<Scalars['Float']['input']>;
  penetration: Scalars['Float']['input'];
  segment: Scalars['String']['input'];
  segment2?: InputMaybe<Scalars['String']['input']>;
  segment2Name?: InputMaybe<Scalars['String']['input']>;
  segmentValue: Scalars['String']['input'];
  totalCustomers: Scalars['Int']['input'];
  totalCustomersAfter: Scalars['Float']['input'];
  totalDriverFinal?: InputMaybe<Scalars['Float']['input']>;
  totalDriverInitial?: InputMaybe<Scalars['Float']['input']>;
  totalHeadroom?: InputMaybe<Scalars['Float']['input']>;
  totalProspects: Scalars['Int']['input'];
};

export type HeadroomFinalResultsWithTotals = {
  __typename?: 'HeadroomFinalResultsWithTotals';
  edges: Array<HeadroomFinalResponse>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
  totals: HeadroomTotals;
};

export type HeadroomResult = {
  __typename?: 'HeadroomResult';
  FxUniqueRowUuid: Scalars['String']['output'];
  HEADROOM?: Maybe<Scalars['Float']['output']>;
  HEADROOM_DRIVER_FINAL?: Maybe<Scalars['Float']['output']>;
  HEADROOM_DRIVER_INITIAL?: Maybe<Scalars['Float']['output']>;
  HEADROOM_PERCENT?: Maybe<Scalars['Float']['output']>;
  SEGMENT: Scalars['String']['output'];
  SEGMENT_RANGE?: Maybe<Scalars['String']['output']>;
  SEGMENT_VALUE: Scalars['String']['output'];
  TOTAL_HEADROOM?: Maybe<Scalars['Float']['output']>;
  TOTAL_HEADROOM_DRIVER_FINAL?: Maybe<Scalars['Float']['output']>;
  TOTAL_HEADROOM_DRIVER_INITIAL?: Maybe<Scalars['Float']['output']>;
};

export type HeadroomTotals = {
  __typename?: 'HeadroomTotals';
  driverFinal: Scalars['Float']['output'];
  driverInitial: Scalars['Float']['output'];
  headroom: Scalars['Float']['output'];
  headroomPercent: Scalars['Float']['output'];
  increasedPenetration: Scalars['Float']['output'];
  penetration: Scalars['Float']['output'];
  totalCustomers: Scalars['Int']['output'];
  totalCustomersAfter: Scalars['Float']['output'];
  totalDriverFinal: Scalars['Float']['output'];
  totalDriverInitial: Scalars['Float']['output'];
  totalHeadroom: Scalars['Float']['output'];
  totalProspects: Scalars['Int']['output'];
};

export type InitMatcherDataPipelineResponse = {
  __typename?: 'InitMatcherDataPipelineResponse';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type InstancesResponse = {
  __typename?: 'InstancesResponse';
  averageAmount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type Invoice = {
  __typename?: 'Invoice';
  accountId?: Maybe<Scalars['String']['output']>;
  accountLegalName?: Maybe<Scalars['String']['output']>;
  accountName?: Maybe<Scalars['String']['output']>;
  accountStatus?: Maybe<Scalars['String']['output']>;
  annualisedConverted?: Maybe<Scalars['String']['output']>;
  annualisedValue?: Maybe<Scalars['String']['output']>;
  check?: Maybe<Scalars['String']['output']>;
  contractType?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  creditGbp?: Maybe<Scalars['String']['output']>;
  cruxyId: Scalars['String']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  currentMonth?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  debitGbp?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  exchangeRate?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  industry?: Maybe<Scalars['String']['output']>;
  industryPrimarySegment?: Maybe<Scalars['String']['output']>;
  industrySubsegment?: Maybe<Scalars['String']['output']>;
  invoiceLengthMonths?: Maybe<Scalars['String']['output']>;
  invoiceNumber: Scalars['String']['output'];
  keyStakeholderTitleOrPosition?: Maybe<Scalars['String']['output']>;
  mrr?: Maybe<Scalars['String']['output']>;
  productSold?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  salesLastYear?: Maybe<Scalars['String']['output']>;
  sourceOfInvoiceData?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
};

export type InvoiceLog = {
  __typename?: 'InvoiceLog';
  changes?: Maybe<Changes>;
  idsOfDealsHidden?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  insertedNow?: Maybe<Scalars['Boolean']['output']>;
  invoiceName?: Maybe<Scalars['String']['output']>;
  matchId?: Maybe<Scalars['String']['output']>;
  matchName?: Maybe<Scalars['String']['output']>;
  newDealID?: Maybe<Scalars['String']['output']>;
  numberOfDealsHidden?: Maybe<Scalars['Int']['output']>;
  similiarity?: Maybe<Scalars['Float']['output']>;
};

export type InvoiceLogsResponse = {
  __typename?: 'InvoiceLogsResponse';
  companies?: Maybe<Array<Maybe<InvoiceLog>>>;
  cruxyId?: Maybe<Scalars['String']['output']>;
};

export type InvoicesFilter = {
  cruxyId: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  processed?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type InvoicesResponse = {
  __typename?: 'InvoicesResponse';
  edges: Array<Maybe<Invoice>>;
  totalCount: Scalars['String']['output'];
};

export type MatcherTableFilter = {
  companyName?: InputMaybe<Scalars['String']['input']>;
};

export type MergeDatasetInput = {
  columnName: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
  datasetName: Scalars['String']['input'];
  joinWith: Scalars['String']['input'];
  joinWithColumn: Scalars['String']['input'];
  selectedColumns: Array<Scalars['String']['input']>;
};

export type MergeDatasetsPayload = {
  cubeId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
  isReplacingView: Scalars['Boolean']['input'];
  mergeInputs: Array<MergeDatasetInput>;
  outputTableName: Scalars['String']['input'];
  tableOrder: Array<Scalars['String']['input']>;
};

export type MergeDatasetsResponse = {
  __typename?: 'MergeDatasetsResponse';
  error?: Maybe<Scalars['String']['output']>;
  mergedTablePath?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  applyFormula?: Maybe<Scalars['String']['output']>;
  applyFormulasForColumn?: Maybe<Array<Maybe<BatchApplyFormulasResult>>>;
  applyInvoices?: Maybe<ApplyInvoicesResponse>;
  calculateWhereAmI?: Maybe<Scalars['Int']['output']>;
  createClient: NewClientResponse;
  createCube: NewCubeResponse;
  createDataset: NewDatasetResponse;
  createViewFromDataset: MergeDatasetsResponse;
  deleteAllRecords: Scalars['Int']['output'];
  deleteClient: Scalars['Int']['output'];
  deleteColumn?: Maybe<Scalars['Boolean']['output']>;
  deleteCrmRecords: Scalars['Int']['output'];
  deleteCube: NewCubeResponse;
  deleteDataset: NewDatasetResponse;
  deleteDatasetsBySourceFileID: NewDatasetResponse;
  deleteFormula?: Maybe<Scalars['String']['output']>;
  deleteHeadroomProject: DeleteHeadroomProjectResponse;
  deleteInvoices: Scalars['Int']['output'];
  deleteMergedView: DeleteViewResponse;
  deletePipelineTag?: Maybe<Scalars['Boolean']['output']>;
  deleteProcessedTable: DeleteTableResponse;
  editCompany?: Maybe<Company>;
  editDeal?: Maybe<Deal>;
  externalDataFuzzyMatching: Array<Maybe<BestMatches>>;
  finishMatch: FinishMatchResponse;
  forceIngestTable: Scalars['Boolean']['output'];
  forceIngestTableForMatcherData: Scalars['Boolean']['output'];
  garbageCollect: Scalars['Int']['output'];
  initMatcherDataPipeline: InitMatcherDataPipelineResponse;
  initTableForAzure: Scalars['Boolean']['output'];
  initTableForMatcherData: Scalars['Boolean']['output'];
  matchPhase: MatchPhaseResponse;
  mergeDatasets: MergeDatasetsResponse;
  mergeProcessed: MergeProcessedResponse;
  mergeRecords: MergeRecordsResponse;
  recalculateExpectations?: Maybe<Array<Maybe<Projection>>>;
  refreshReality?: Maybe<Array<Maybe<Projection>>>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  removeMatcherView: DeleteViewResponse;
  removeViews: Scalars['Int']['output'];
  saveHeadroomDriverMetrics: SaveHeadroomDriverMetricsResponse;
  saveHeadroomFinalData: SaveHeadroomFinalDataResponse;
  saveHeadroomProject: SaveProjectResponse;
  saveHeadroomSegmentationData: SaveHeadroomSegmentationDataResponse;
  signIn?: Maybe<Scalars['String']['output']>;
  signOut?: Maybe<CurrentUser>;
  signUp?: Maybe<Scalars['String']['output']>;
  unmatchProcessed: UnmatchProcessedResponse;
  unmatchRecords: MergeRecordsResponse;
  upsertColumn?: Maybe<Scalars['String']['output']>;
  upsertFormula?: Maybe<Formula>;
  upsertPipeline?: Maybe<Pipeline>;
  upsertPipelineTag?: Maybe<Scalars['String']['output']>;
};


export type MutationApplyFormulaArgs = {
  id: Scalars['String']['input'];
};


export type MutationApplyFormulasForColumnArgs = {
  columnId: Scalars['String']['input'];
};


export type MutationApplyInvoicesArgs = {
  cruxyId: Scalars['String']['input'];
};


export type MutationCreateClientArgs = {
  cruxyId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateCubeArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateDatasetArgs = {
  cubeId: Scalars['String']['input'];
  dataSetName: Scalars['String']['input'];
};


export type MutationCreateViewFromDatasetArgs = {
  payload: CreateViewPayload;
};


export type MutationDeleteAllRecordsArgs = {
  cruxyId: Scalars['String']['input'];
};


export type MutationDeleteClientArgs = {
  cruxyId: Scalars['String']['input'];
};


export type MutationDeleteColumnArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteCrmRecordsArgs = {
  cruxyId: Scalars['String']['input'];
};


export type MutationDeleteCubeArgs = {
  cubeId: Scalars['String']['input'];
};


export type MutationDeleteDatasetArgs = {
  cubeName: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
};


export type MutationDeleteDatasetsBySourceFileIdArgs = {
  cubeName: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
  sourceFileID: Scalars['String']['input'];
};


export type MutationDeleteFormulaArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteHeadroomProjectArgs = {
  projectName: Scalars['String']['input'];
};


export type MutationDeleteInvoicesArgs = {
  filter: DeleteInvoicesFilter;
};


export type MutationDeleteMergedViewArgs = {
  cubeId: Scalars['String']['input'];
  viewName: Scalars['String']['input'];
};


export type MutationDeletePipelineTagArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteProcessedTableArgs = {
  tableName: Scalars['String']['input'];
};


export type MutationEditCompanyArgs = {
  fields: EditCompanyFields;
  id: Scalars['String']['input'];
};


export type MutationEditDealArgs = {
  fields: EditDealFields;
  id: Scalars['String']['input'];
};


export type MutationExternalDataFuzzyMatchingArgs = {
  cruxyId: Scalars['String']['input'];
};


export type MutationFinishMatchArgs = {
  cubeId: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
  matcherTableName: Scalars['String']['input'];
  outputViewName: Scalars['String']['input'];
  tableName: Scalars['String']['input'];
};


export type MutationForceIngestTableArgs = {
  cubeId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  tableUuid: Scalars['String']['input'];
};


export type MutationForceIngestTableForMatcherDataArgs = {
  cubeId: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  tableUuid: Scalars['String']['input'];
  viewName: Scalars['String']['input'];
};


export type MutationInitTableForAzureArgs = {
  cubeName: Scalars['String']['input'];
  headers: Array<Scalars['String']['input']>;
};


export type MutationInitTableForMatcherDataArgs = {
  headers: Array<Scalars['String']['input']>;
};


export type MutationMatchPhaseArgs = {
  cubeId: Scalars['String']['input'];
  headers: Array<Array<Scalars['String']['input']>>;
  identifier: Scalars['String']['input'];
  matcherTable: Scalars['String']['input'];
  phase: Scalars['Int']['input'];
  tableName: Scalars['String']['input'];
};


export type MutationMergeDatasetsArgs = {
  payload: MergeDatasetsPayload;
};


export type MutationMergeProcessedArgs = {
  fxId: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
  score: Scalars['Float']['input'];
  tableName: Scalars['String']['input'];
  value: Scalars['String']['input'];
};


export type MutationMergeRecordsArgs = {
  cubeId: Scalars['String']['input'];
  fxId: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
  score: Scalars['Float']['input'];
  tableName: Scalars['String']['input'];
  value: Scalars['String']['input'];
};


export type MutationRecalculateExpectationsArgs = {
  cruxyId: Scalars['String']['input'];
  input: Scalars['JSONObject']['input'];
  pipelineId: Scalars['String']['input'];
};


export type MutationRefreshRealityArgs = {
  cruxyId: Scalars['String']['input'];
  pipelineId: Scalars['String']['input'];
  untilDate: Scalars['String']['input'];
};


export type MutationRemoveMatcherViewArgs = {
  viewName: Scalars['String']['input'];
};


export type MutationRemoveViewsArgs = {
  cubeId: Scalars['String']['input'];
  tableName: Scalars['String']['input'];
};


export type MutationSaveHeadroomDriverMetricsArgs = {
  input: SaveHeadroomDriverMetricsInput;
};


export type MutationSaveHeadroomFinalDataArgs = {
  input: SaveHeadroomFinalDataInput;
};


export type MutationSaveHeadroomProjectArgs = {
  input: SaveProjectInput;
};


export type MutationSaveHeadroomSegmentationDataArgs = {
  input: SaveHeadroomSegmentationDataInput;
};


export type MutationSignInArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationSignUpArgs = {
  cruxyId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  role: UserRole;
};


export type MutationUnmatchProcessedArgs = {
  identifier: Scalars['String']['input'];
  ids: Array<Scalars['String']['input']>;
  tableName: Scalars['String']['input'];
};


export type MutationUnmatchRecordsArgs = {
  cubeId: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
  ids: Array<Scalars['String']['input']>;
  tableName: Scalars['String']['input'];
};


export type MutationUpsertColumnArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input: UpsertColumnInput;
};


export type MutationUpsertFormulaArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  input: UpsertFormulaInput;
};


export type MutationUpsertPipelineArgs = {
  basePipelineId: Scalars['String']['input'];
  columnId: Scalars['String']['input'];
  input: UpsertPipelineInput;
  pipelineId: Scalars['String']['input'];
};


export type MutationUpsertPipelineTagArgs = {
  cruxyId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type NewClientResponse = {
  __typename?: 'NewClientResponse';
  success: Scalars['Boolean']['output'];
};

export type NewCubeResponse = {
  __typename?: 'NewCubeResponse';
  success: Scalars['Boolean']['output'];
};

export type NewDatasetResponse = {
  __typename?: 'NewDatasetResponse';
  id?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Operators = {
  __typename?: 'Operators';
  symbol?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export enum Percentile {
  Max = 'MAX',
  Min = 'MIN',
  P25 = 'P25',
  P50 = 'P50',
  P75 = 'P75'
}

export type PhaseStatistics = {
  __typename?: 'PhaseStatistics';
  cubeId: Scalars['String']['output'];
  duplicateCount: Scalars['Int']['output'];
  duplicates?: Maybe<Array<Maybe<Duplicate>>>;
  identifier: Scalars['String']['output'];
  matchedCount: Scalars['Int']['output'];
  phase: Scalars['Int']['output'];
  tableName: Scalars['String']['output'];
  totalRecords: Scalars['Int']['output'];
};

export type Pipeline = {
  __typename?: 'Pipeline';
  basePipelineId: Scalars['String']['output'];
  columnId: Scalars['String']['output'];
  durations?: Maybe<Array<Maybe<Duration>>>;
  schema?: Maybe<Schema>;
};

export type PipelineInstance = {
  __typename?: 'PipelineInstance';
  averageAmount?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numberOfClosedWons?: Maybe<Scalars['Int']['output']>;
  orderNumber?: Maybe<Scalars['Int']['output']>;
};

export type PipelineInstanceInput = {
  averageAmount: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  orderNumber: Scalars['Int']['input'];
};

export type PipelinesResponse = {
  __typename?: 'PipelinesResponse';
  data?: Maybe<Pipeline>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ProcessedDataPreviewFilter = {
  cubeId: Scalars['String']['input'];
  tableName: Scalars['String']['input'];
};

export type ProcessedDataPreviewResponse = {
  __typename?: 'ProcessedDataPreviewResponse';
  data: Array<Scalars['JSON']['output']>;
  totalCount: Scalars['Int']['output'];
};

export type ProcessedDataResponse = {
  __typename?: 'ProcessedDataResponse';
  edges: Array<Scalars['JSON']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
};

export type ProcessedDataTableHeadersResponse = {
  __typename?: 'ProcessedDataTableHeadersResponse';
  columns: Array<Column>;
};

export type ProcessedDataViewsResponse = {
  __typename?: 'ProcessedDataViewsResponse';
  edges: Array<ViewsResponse>;
  error?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
};

export type Project = {
  __typename?: 'Project';
  count1Column?: Maybe<Scalars['String']['output']>;
  count2Column?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  cubeId?: Maybe<Scalars['String']['output']>;
  customerColumn?: Maybe<Scalars['String']['output']>;
  driver1Mode?: Maybe<DriverMode>;
  driver1NumeratorType?: Maybe<Scalars['String']['output']>;
  driver1Percentile?: Maybe<Percentile>;
  driver1Type?: Maybe<Scalars['String']['output']>;
  driver2Mode?: Maybe<DriverMode>;
  driver2NumeratorType?: Maybe<Scalars['String']['output']>;
  driver2Percentile?: Maybe<Percentile>;
  driver2Type?: Maybe<Scalars['String']['output']>;
  headroomDriver?: Maybe<Scalars['String']['output']>;
  headroomPercentile?: Maybe<Scalars['Int']['output']>;
  projectName: Scalars['String']['output'];
  segmentGroups: Array<SegmentGroup>;
  tableName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type ProjectNameResponse = {
  __typename?: 'ProjectNameResponse';
  name?: Maybe<Scalars['String']['output']>;
};

export type Projection = {
  __typename?: 'Projection';
  amount: Scalars['Int']['output'];
  amountConverted: Scalars['Int']['output'];
  cruxyId: Scalars['String']['output'];
  dateOfCalculation: Scalars['String']['output'];
  dateOfProjection: Scalars['String']['output'];
  instanceName: Scalars['String']['output'];
  minimumStage: Scalars['Int']['output'];
  numberOfDeals: Scalars['Int']['output'];
  numberOfDealsConverted: Scalars['Int']['output'];
  pipelineId: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  clients: Array<Maybe<ClientsResponse>>;
  companies: CompaniesResponse;
  conversionRates: Array<Maybe<ConversionRatesResponse>>;
  crmColumns: Array<Maybe<Scalars['String']['output']>>;
  crmPipelines: Array<Maybe<CrmPipelinesResponse>>;
  crmTables: Array<Maybe<CrmTables>>;
  cubes: Array<Maybe<CubesResponse>>;
  currentClient: ClientsResponse;
  currentCube: CubesResponse;
  customColumns: Array<Maybe<CustomColumn>>;
  dataFromTablesByDatasetId: DataFromTablesResponse;
  datasetById: DatasetResponse;
  datasetPreview: DatasetPreviewResponse;
  datasets: Array<Maybe<DatasetResponse>>;
  datasetsByCubeId: Array<Maybe<DatasetResponse>>;
  deals: DealsResponse;
  expectations?: Maybe<Array<Maybe<Projection>>>;
  formulas?: Maybe<Array<Maybe<Formula>>>;
  getAllHeadroomProjects: GetAllHeadroomProjectsResponse;
  getApplyInvoicesPlan?: Maybe<GetApplyInvoicesPlanResponse>;
  getHeadroomFinalResults: HeadroomFinalResultsWithTotals;
  getHeadroomProjectByName?: Maybe<Project>;
  groupedCountsByColumn: GroupedCountsResponse;
  instances: Array<Maybe<InstancesResponse>>;
  invoiceLogDates: Array<Maybe<Scalars['String']['output']>>;
  invoiceLogs?: Maybe<InvoiceLogsResponse>;
  invoices: InvoicesResponse;
  matcherTableData: TablesData;
  matcherTableHeaders: Array<Scalars['String']['output']>;
  matcherTables: TablesData;
  me?: Maybe<CurrentUser>;
  myViews: ViewsData;
  operators: Array<Operators>;
  pipeline?: Maybe<Pipeline>;
  pipelines?: Maybe<Array<Maybe<PipelinesResponse>>>;
  processedDataAndCountPreview: ProcessedDataPreviewResponse;
  processedDataTableHeaders: ProcessedDataTableHeadersResponse;
  queryMatchedViewsPhaseData: ProcessedDataResponse;
  queryProcessedDataViews: ProcessedDataViewsResponse;
  queryProcessedTableMatcherTableName: QueryProcessedTableNameResult;
  queryProcessedViewsData: ProcessedDataResponse;
  reality?: Maybe<Array<Maybe<Projection>>>;
  roles?: Maybe<Array<Maybe<UserRole>>>;
  segmentedData: SegmentedDataResponse;
  segmentedDriverMetrics: DriverMetricsDataResponse;
  stages: Array<Maybe<StagesResponse>>;
  test: Scalars['Boolean']['output'];
  user?: Maybe<User>;
  users?: Maybe<Array<Maybe<User>>>;
  viewData: ViewsData;
  viewHeaders: Array<Scalars['String']['output']>;
  views: ViewsData;
};


export type QueryClientsArgs = {
  filter?: InputMaybe<ClientsFilter>;
};


export type QueryCompaniesArgs = {
  filter: CompaniesFilter;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryConversionRatesArgs = {
  pipelineId: Scalars['String']['input'];
};


export type QueryCrmColumnsArgs = {
  id: Scalars['String']['input'];
};


export type QueryCrmPipelinesArgs = {
  cruxyId: Scalars['String']['input'];
};


export type QueryCubesArgs = {
  filter?: InputMaybe<CubesFilter>;
};


export type QueryCustomColumnsArgs = {
  filter: CustomColumnFilters;
};


export type QueryDataFromTablesByDatasetIdArgs = {
  cubeName: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
  includeAlreadyMerged: Scalars['Boolean']['input'];
};


export type QueryDatasetByIdArgs = {
  datasetId: Scalars['String']['input'];
};


export type QueryDatasetPreviewArgs = {
  filter?: InputMaybe<DatasetPreviewFilter>;
};


export type QueryDatasetsByCubeIdArgs = {
  cubeId: Scalars['String']['input'];
  includeAlreadyMerged: Scalars['Boolean']['input'];
};


export type QueryDealsArgs = {
  filter: DealsFilter;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryExpectationsArgs = {
  cruxyId: Scalars['String']['input'];
  pipelineId: Scalars['String']['input'];
};


export type QueryFormulasArgs = {
  columnId: Scalars['String']['input'];
};


export type QueryGetAllHeadroomProjectsArgs = {
  cubeId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetApplyInvoicesPlanArgs = {
  cruxyId: Scalars['String']['input'];
};


export type QueryGetHeadroomFinalResultsArgs = {
  customerColumn: Scalars['String']['input'];
  driverDenominatorColumn: Scalars['String']['input'];
  driverMode: DriverMode;
  driverNumeratorColumn?: InputMaybe<Scalars['String']['input']>;
  increasedPenetration?: InputMaybe<Scalars['Float']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  projectName: Scalars['String']['input'];
  segmentGroups: Array<SegmentGroupInput>;
  tableName: Scalars['String']['input'];
};


export type QueryGetHeadroomProjectByNameArgs = {
  cubeId: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
};


export type QueryGroupedCountsByColumnArgs = {
  input: GroupedCountsInput;
};


export type QueryInstancesArgs = {
  columnId: Scalars['String']['input'];
};


export type QueryInvoiceLogDatesArgs = {
  cruxyId: Scalars['String']['input'];
};


export type QueryInvoiceLogsArgs = {
  cruxyId: Scalars['String']['input'];
  date: Scalars['String']['input'];
};


export type QueryInvoicesArgs = {
  filter: InvoicesFilter;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMatcherTableDataArgs = {
  columnName?: InputMaybe<Scalars['String']['input']>;
  cubeId: Scalars['String']['input'];
  filter?: InputMaybe<MatcherTableFilter>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  tableName: Scalars['String']['input'];
};


export type QueryMatcherTableHeadersArgs = {
  cubeId: Scalars['String']['input'];
  tableName: Scalars['String']['input'];
};


export type QueryMatcherTablesArgs = {
  cubeId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyViewsArgs = {
  cubeId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPipelineArgs = {
  id: Scalars['String']['input'];
};


export type QueryPipelinesArgs = {
  cruxyId: Scalars['String']['input'];
};


export type QueryProcessedDataAndCountPreviewArgs = {
  filter?: InputMaybe<ProcessedDataPreviewFilter>;
};


export type QueryProcessedDataTableHeadersArgs = {
  tableName: Scalars['String']['input'];
};


export type QueryQueryMatchedViewsPhaseDataArgs = {
  cubeName: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  phase: Scalars['Int']['input'];
  viewName: Scalars['String']['input'];
};


export type QueryQueryProcessedDataViewsArgs = {
  cubeId: Scalars['String']['input'];
  includeHeadroomData?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryQueryProcessedTableMatcherTableNameArgs = {
  tableName: Scalars['String']['input'];
};


export type QueryQueryProcessedViewsDataArgs = {
  cubeId: Scalars['String']['input'];
  filter: ViewDataFilter;
  identifier?: InputMaybe<Scalars['String']['input']>;
  includeMatched?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRealityArgs = {
  cruxyId: Scalars['String']['input'];
  pipelineId: Scalars['String']['input'];
};


export type QuerySegmentedDataArgs = {
  count1Column: Scalars['String']['input'];
  count2Column?: InputMaybe<Scalars['String']['input']>;
  driver1DenominatorColumn: Scalars['String']['input'];
  driver1Mode: DriverMode;
  driver1NumeratorColumn?: InputMaybe<Scalars['String']['input']>;
  driver2DenominatorColumn: Scalars['String']['input'];
  driver2Mode: DriverMode;
  driver2NumeratorColumn?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  segmentGroups: Array<SegmentGroupInput>;
  tableName: Scalars['String']['input'];
};


export type QuerySegmentedDriverMetricsArgs = {
  customerColumn: Scalars['String']['input'];
  driver1DenominatorColumn?: InputMaybe<Scalars['String']['input']>;
  driver1Mode?: InputMaybe<DriverMode>;
  driver1NumeratorColumn?: InputMaybe<Scalars['String']['input']>;
  driver1Percentile?: InputMaybe<Scalars['Int']['input']>;
  driver2DenominatorColumn?: InputMaybe<Scalars['String']['input']>;
  driver2Mode?: InputMaybe<DriverMode>;
  driver2NumeratorColumn?: InputMaybe<Scalars['String']['input']>;
  driver2Percentile?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  segmentGroups: Array<SegmentGroupInput>;
  tableName: Scalars['String']['input'];
};


export type QueryStagesArgs = {
  pipelineId: Scalars['String']['input'];
};


export type QueryTestArgs = {
  bool: Scalars['Boolean']['input'];
};


export type QueryUserArgs = {
  id: Scalars['String']['input'];
};


export type QueryUsersArgs = {
  filter?: InputMaybe<UsersFilter>;
};


export type QueryViewDataArgs = {
  cubeId: Scalars['String']['input'];
  filter: ViewDataFilter;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryViewHeadersArgs = {
  cubeId: Scalars['String']['input'];
  viewName: Scalars['String']['input'];
};


export type QueryViewsArgs = {
  filter: ViewsFilter;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryProcessedTableNameResult = {
  __typename?: 'QueryProcessedTableNameResult';
  error?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  matcherTable?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SaveHeadroomDriverMetricsInput = {
  edges: Array<DriverMetricsResponseInput>;
  projectName: Scalars['String']['input'];
};

export type SaveHeadroomDriverMetricsResponse = {
  __typename?: 'SaveHeadroomDriverMetricsResponse';
  errorMessage?: Maybe<Scalars['String']['output']>;
  isUpdate?: Maybe<Scalars['Boolean']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SaveHeadroomFinalDataInput = {
  edges: Array<HeadroomFinalResponseInput>;
  increasedPenetration: Scalars['Float']['input'];
  projectName: Scalars['String']['input'];
};

export type SaveHeadroomFinalDataResponse = {
  __typename?: 'SaveHeadroomFinalDataResponse';
  errorMessage?: Maybe<Scalars['String']['output']>;
  isUpdate?: Maybe<Scalars['Boolean']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SaveHeadroomSegmentationDataInput = {
  edges: Array<SegmentResponseInput>;
  projectName: Scalars['String']['input'];
};

export type SaveHeadroomSegmentationDataResponse = {
  __typename?: 'SaveHeadroomSegmentationDataResponse';
  errorMessage?: Maybe<Scalars['String']['output']>;
  isUpdate?: Maybe<Scalars['Boolean']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SaveProjectInput = {
  count1Column?: InputMaybe<Scalars['String']['input']>;
  count2Column?: InputMaybe<Scalars['String']['input']>;
  cubeId: Scalars['String']['input'];
  customerColumn?: InputMaybe<Scalars['String']['input']>;
  driver1Mode?: InputMaybe<DriverMode>;
  driver1NumeratorType?: InputMaybe<Scalars['String']['input']>;
  driver1Percentile?: InputMaybe<Percentile>;
  driver1Type?: InputMaybe<Scalars['String']['input']>;
  driver2Mode?: InputMaybe<DriverMode>;
  driver2NumeratorType?: InputMaybe<Scalars['String']['input']>;
  driver2Percentile?: InputMaybe<Percentile>;
  driver2Type?: InputMaybe<Scalars['String']['input']>;
  headroomDriver?: InputMaybe<Scalars['String']['input']>;
  headroomPercentile?: InputMaybe<Scalars['Int']['input']>;
  projectName: Scalars['String']['input'];
  segmentGroups?: InputMaybe<Array<SegmentGroupInput>>;
  tableName?: InputMaybe<Scalars['String']['input']>;
};

export type SaveProjectResponse = {
  __typename?: 'SaveProjectResponse';
  errorMessage?: Maybe<Scalars['String']['output']>;
  isUpdate?: Maybe<Scalars['Boolean']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Schema = {
  __typename?: 'Schema';
  pipelineInstances?: Maybe<Array<Maybe<PipelineInstance>>>;
  stages?: Maybe<Array<Maybe<Stage>>>;
};

export type SchemaInput = {
  pipelineInstances: Array<PipelineInstanceInput>;
  stages: Array<StageInput>;
};

export type Segment = {
  __typename?: 'Segment';
  id: Scalars['Int']['output'];
  maxValue: Scalars['Float']['output'];
  minValue: Scalars['Float']['output'];
};

export type SegmentGroup = {
  __typename?: 'SegmentGroup';
  index: Scalars['Int']['output'];
  method: SegmentationMethod;
  rangeColumn?: Maybe<Scalars['String']['output']>;
  segments: Array<Segment>;
  type: Scalars['String']['output'];
};

export type SegmentGroupInput = {
  index?: InputMaybe<Scalars['Int']['input']>;
  method: SegmentationMethod;
  rangeColumn?: InputMaybe<Scalars['String']['input']>;
  segments?: InputMaybe<Array<SegmentInput>>;
  type: Scalars['String']['input'];
};

export type SegmentInput = {
  id: Scalars['Int']['input'];
  maxValue: Scalars['Float']['input'];
  minValue: Scalars['Float']['input'];
};

export type SegmentResponse = {
  __typename?: 'SegmentResponse';
  FxUniqueRowUuid: Scalars['String']['output'];
  count1: Scalars['Int']['output'];
  count2: Scalars['Int']['output'];
  driver1Metrics?: Maybe<DriverMetrics>;
  driver2Metrics?: Maybe<DriverMetrics>;
  numerator?: Maybe<Scalars['Float']['output']>;
  segment: Scalars['String']['output'];
  segmentRange?: Maybe<Scalars['String']['output']>;
  segmentValue: Scalars['String']['output'];
  total: Scalars['Int']['output'];
};

export type SegmentResponseInput = {
  count1: Scalars['Int']['input'];
  count2: Scalars['Int']['input'];
  numerator?: InputMaybe<Scalars['Float']['input']>;
  segment: Scalars['String']['input'];
  segmentRange?: InputMaybe<Scalars['String']['input']>;
  segmentValue: Scalars['String']['input'];
};

export enum SegmentationMethod {
  Data = 'DATA',
  Manual = 'MANUAL'
}

export type SegmentedDataResponse = {
  __typename?: 'SegmentedDataResponse';
  edges: Array<SegmentResponse>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
};

export type Stage = {
  __typename?: 'Stage';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  orderNumber?: Maybe<Scalars['Int']['output']>;
};

export type StageInput = {
  name: Scalars['String']['input'];
  orderNumber: Scalars['Int']['input'];
};

export type StagesResponse = {
  __typename?: 'StagesResponse';
  displayOrder: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type TableData = {
  __typename?: 'TableData';
  column: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type TableDataFilter = {
  tableName: Scalars['String']['input'];
};

export type TablesData = {
  __typename?: 'TablesData';
  edges: Array<Scalars['JSON']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
};

export type TablesResponse = {
  __typename?: 'TablesResponse';
  createdAt?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type UpsertColumnInput = {
  columnName?: InputMaybe<Scalars['String']['input']>;
  cruxyId?: InputMaybe<Scalars['String']['input']>;
  tableId?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertFormulaInput = {
  columnId?: InputMaybe<Scalars['String']['input']>;
  conditionFormula?: InputMaybe<Scalars['JSONObject']['input']>;
  cruxyId?: InputMaybe<Scalars['String']['input']>;
  valueFormula?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertPipelineInput = {
  durations: Array<DurationsInput>;
  schema: SchemaInput;
};

export type User = {
  __typename?: 'User';
  azure_sas_token?: Maybe<Scalars['String']['output']>;
  cruxyId: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  role: UserRole;
};

export enum UserRole {
  ClientAdmin = 'ClientAdmin',
  ClientUser = 'ClientUser',
  CruxyAdmin = 'CruxyAdmin',
  CruxyUser = 'CruxyUser'
}

export type UsersFilter = {
  cruxyId?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRole>;
};

export type ViewDataFilter = {
  viewName: Scalars['String']['input'];
};

export type ViewsData = {
  __typename?: 'ViewsData';
  edges: Array<Scalars['JSON']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
};

export type ViewsFilter = {
  cubeId: Scalars['String']['input'];
};

export type ViewsResponse = {
  __typename?: 'ViewsResponse';
  createdAt?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type MatchPhaseResponse = {
  __typename?: 'matchPhaseResponse';
  error?: Maybe<Scalars['String']['output']>;
  statistics?: Maybe<PhaseStatistics>;
  success: Scalars['Boolean']['output'];
};

export type MergeProcessedResponse = {
  __typename?: 'mergeProcessedResponse';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type MergeRecordsResponse = {
  __typename?: 'mergeRecordsResponse';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UnmatchProcessedResponse = {
  __typename?: 'unmatchProcessedResponse';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UnmatchRecordsResponse = {
  __typename?: 'unmatchRecordsResponse';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ApplyFormulaMutationVariables = Exact<{
  applyFormulaId: Scalars['String']['input'];
}>;


export type ApplyFormulaMutation = { __typename?: 'Mutation', applyFormula?: string | null };

export type ApplyFormulasForColumnMutationVariables = Exact<{
  columnId: Scalars['String']['input'];
}>;


export type ApplyFormulasForColumnMutation = { __typename?: 'Mutation', applyFormulasForColumn?: Array<{ __typename?: 'BatchApplyFormulasResult', formulaId?: string | null, message?: string | null } | null> | null };

export type ApplyInvoicesMutationVariables = Exact<{
  cruxyId: Scalars['String']['input'];
}>;


export type ApplyInvoicesMutation = { __typename?: 'Mutation', applyInvoices?: { __typename?: 'ApplyInvoicesResponse', cruxyId?: string | null, companies?: Array<{ __typename?: 'InvoiceLog', invoiceName?: string | null, matchName?: string | null, matchId?: string | null, numberOfDealsHidden?: number | null, idsOfDealsHidden?: Array<string | null> | null, newDealID?: string | null, insertedNow?: boolean | null, changes?: { __typename?: 'Changes', name?: { __typename?: 'Change', from?: string | null, to?: string | null } | null, country?: { __typename?: 'Change', from?: string | null, to?: string | null } | null, industry?: { __typename?: 'Change', from?: string | null, to?: string | null } | null } | null } | null> | null } | null };

export type CreateClientMutationVariables = Exact<{
  cruxyId: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type CreateClientMutation = { __typename?: 'Mutation', createClient: { __typename?: 'NewClientResponse', success: boolean } };

export type CreateCubeMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateCubeMutation = { __typename?: 'Mutation', createCube: { __typename?: 'NewCubeResponse', success: boolean } };

export type CreateDatasetMutationVariables = Exact<{
  cubeId: Scalars['String']['input'];
  dataSetName: Scalars['String']['input'];
}>;


export type CreateDatasetMutation = { __typename?: 'Mutation', createDataset: { __typename?: 'NewDatasetResponse', success: boolean, id?: string | null } };

export type CreateViewFromDatasetMutationVariables = Exact<{
  payload: CreateViewPayload;
}>;


export type CreateViewFromDatasetMutation = { __typename?: 'Mutation', createViewFromDataset: { __typename?: 'MergeDatasetsResponse', success: boolean, mergedTablePath?: string | null, error?: string | null } };

export type DeleteColumnMutationVariables = Exact<{
  deleteColumnId: Scalars['String']['input'];
}>;


export type DeleteColumnMutation = { __typename?: 'Mutation', deleteColumn?: boolean | null };

export type DeleteCubeMutationVariables = Exact<{
  cubeId: Scalars['String']['input'];
}>;


export type DeleteCubeMutation = { __typename?: 'Mutation', deleteCube: { __typename?: 'NewCubeResponse', success: boolean } };

export type DeleteDatasetMutationVariables = Exact<{
  datasetId: Scalars['String']['input'];
  cubeName: Scalars['String']['input'];
}>;


export type DeleteDatasetMutation = { __typename?: 'Mutation', deleteDataset: { __typename?: 'NewDatasetResponse', id?: string | null, success: boolean } };

export type DeleteDatasetsBySourceFileIdMutationVariables = Exact<{
  sourceFileId: Scalars['String']['input'];
  cubeName: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
}>;


export type DeleteDatasetsBySourceFileIdMutation = { __typename?: 'Mutation', deleteDatasetsBySourceFileID: { __typename?: 'NewDatasetResponse', id?: string | null, success: boolean } };

export type DeleteFormulaMutationVariables = Exact<{
  deleteFormulaId: Scalars['String']['input'];
}>;


export type DeleteFormulaMutation = { __typename?: 'Mutation', deleteFormula?: string | null };

export type DeleteHeadroomProjectMutationVariables = Exact<{
  projectName: Scalars['String']['input'];
}>;


export type DeleteHeadroomProjectMutation = { __typename?: 'Mutation', deleteHeadroomProject: { __typename?: 'DeleteHeadroomProjectResponse', success: boolean, errorMessage?: string | null } };

export type DeleteMergedViewMutationVariables = Exact<{
  cubeId: Scalars['String']['input'];
  viewName: Scalars['String']['input'];
}>;


export type DeleteMergedViewMutation = { __typename?: 'Mutation', deleteMergedView: { __typename?: 'DeleteViewResponse', message: string, success: boolean } };

export type DeletePipelineTagMutationVariables = Exact<{
  deletePipelineTagId: Scalars['String']['input'];
}>;


export type DeletePipelineTagMutation = { __typename?: 'Mutation', deletePipelineTag?: boolean | null };

export type DeleteProcessedTableMutationVariables = Exact<{
  tableName: Scalars['String']['input'];
}>;


export type DeleteProcessedTableMutation = { __typename?: 'Mutation', deleteProcessedTable: { __typename?: 'DeleteTableResponse', success: boolean, message: string } };

export type EditCompanyMutationVariables = Exact<{
  fields: EditCompanyFields;
  editCompanyId: Scalars['String']['input'];
}>;


export type EditCompanyMutation = { __typename?: 'Mutation', editCompany?: { __typename?: 'Company', id: string, name: string, parentCompanyId?: string | null, type?: string | null, cruxyId: string, createdById?: string | null, createDate?: string | null, country?: string | null, annualRevenue?: string | null, industry?: string | null, customProperties?: any | null } | null };

export type EditDealMutationVariables = Exact<{
  fields: EditDealFields;
  editDealId: Scalars['String']['input'];
}>;


export type EditDealMutation = { __typename?: 'Mutation', editDeal?: { __typename?: 'Deal', id: string, dealName?: string | null, dealStage?: string | null, createDate?: string | null, closeDate?: string | null, dealOwnerId?: string | null, amount?: string | null, analyticsLatestSource?: string | null, pipeline?: string | null, fiscalYear?: string | null, type?: string | null, dealCurrencyCode?: string | null, createdById?: string | null, arr?: string | null, amountInHomeCurrency?: string | null, acv?: string | null, customProperties?: any | null, associatedCompany: Array<{ __typename?: 'Company', id: string, name: string, createDate?: string | null, createdById?: string | null, country?: string | null } | null>, associatedContact: Array<{ __typename?: 'Contact', id: string, firstName: string, lastName: string } | null> } | null };

export type FinishMatchMutationVariables = Exact<{
  cubeId: Scalars['String']['input'];
  tableName: Scalars['String']['input'];
  outputViewName: Scalars['String']['input'];
  matcherTableName: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
}>;


export type FinishMatchMutation = { __typename?: 'Mutation', finishMatch: { __typename?: 'FinishMatchResponse', success: boolean, error?: string | null } };

export type MatchPhaseMutationVariables = Exact<{
  cubeId: Scalars['String']['input'];
  phase: Scalars['Int']['input'];
  tableName: Scalars['String']['input'];
  matcherTable: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
  headers: Array<Array<Scalars['String']['input']> | Scalars['String']['input']> | Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type MatchPhaseMutation = { __typename?: 'Mutation', matchPhase: { __typename?: 'matchPhaseResponse', success: boolean, error?: string | null, statistics?: { __typename?: 'PhaseStatistics', cubeId: string, phase: number, tableName: string, identifier: string, totalRecords: number, matchedCount: number, duplicateCount: number, duplicates?: Array<{ __typename?: 'Duplicate', FX_UNIQUE_ID: string, NAME: string, COUNT: number } | null> | null } | null } };

export type UnmatchRecordsMutationVariables = Exact<{
  cubeId: Scalars['String']['input'];
  tableName: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UnmatchRecordsMutation = { __typename?: 'Mutation', unmatchRecords: { __typename?: 'mergeRecordsResponse', success: boolean, error?: string | null } };

export type MergeRecordsMutationVariables = Exact<{
  cubeId: Scalars['String']['input'];
  tableName: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
  fxId: Scalars['String']['input'];
  value: Scalars['String']['input'];
  score: Scalars['Float']['input'];
}>;


export type MergeRecordsMutation = { __typename?: 'Mutation', mergeRecords: { __typename?: 'mergeRecordsResponse', success: boolean, error?: string | null } };

export type MergeDatasetsMutationVariables = Exact<{
  payload: MergeDatasetsPayload;
}>;


export type MergeDatasetsMutation = { __typename?: 'Mutation', mergeDatasets: { __typename?: 'MergeDatasetsResponse', success: boolean, mergedTablePath?: string | null, error?: string | null } };

export type MergeProcessedMutationVariables = Exact<{
  tableName: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
  fxId: Scalars['String']['input'];
  value: Scalars['String']['input'];
  score: Scalars['Float']['input'];
}>;


export type MergeProcessedMutation = { __typename?: 'Mutation', mergeProcessed: { __typename?: 'mergeProcessedResponse', success: boolean, error?: string | null } };

export type RecalculateExpectationsMutationVariables = Exact<{
  cruxyId: Scalars['String']['input'];
  pipelineId: Scalars['String']['input'];
  input: Scalars['JSONObject']['input'];
}>;


export type RecalculateExpectationsMutation = { __typename?: 'Mutation', recalculateExpectations?: Array<{ __typename?: 'Projection', cruxyId: string, pipelineId: string, instanceName: string, minimumStage: number, numberOfDeals: number, numberOfDealsConverted: number, amount: number, amountConverted: number, dateOfCalculation: string, dateOfProjection: string } | null> | null };

export type RefreshRealityMutationVariables = Exact<{
  cruxyId: Scalars['String']['input'];
  pipelineId: Scalars['String']['input'];
  untilDate: Scalars['String']['input'];
}>;


export type RefreshRealityMutation = { __typename?: 'Mutation', refreshReality?: Array<{ __typename?: 'Projection', amount: number, amountConverted: number, cruxyId: string, dateOfCalculation: string, dateOfProjection: string, instanceName: string, minimumStage: number, numberOfDeals: number, numberOfDealsConverted: number, pipelineId: string } | null> | null };

export type RefreshTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type RefreshTokenMutation = { __typename?: 'Mutation', refreshToken?: string | null };

export type RemoveMatcherViewMutationVariables = Exact<{
  viewName: Scalars['String']['input'];
}>;


export type RemoveMatcherViewMutation = { __typename?: 'Mutation', removeMatcherView: { __typename?: 'DeleteViewResponse', success: boolean, message: string } };

export type SaveHeadroomDriverMetricsMutationVariables = Exact<{
  input: SaveHeadroomDriverMetricsInput;
}>;


export type SaveHeadroomDriverMetricsMutation = { __typename?: 'Mutation', saveHeadroomDriverMetrics: { __typename?: 'SaveHeadroomDriverMetricsResponse', success: boolean, errorMessage?: string | null, isUpdate?: boolean | null } };

export type SaveHeadroomFinalDataMutationVariables = Exact<{
  input: SaveHeadroomFinalDataInput;
}>;


export type SaveHeadroomFinalDataMutation = { __typename?: 'Mutation', saveHeadroomFinalData: { __typename?: 'SaveHeadroomFinalDataResponse', success: boolean, errorMessage?: string | null, isUpdate?: boolean | null } };

export type SaveHeadroomProjectMutationVariables = Exact<{
  input: SaveProjectInput;
}>;


export type SaveHeadroomProjectMutation = { __typename?: 'Mutation', saveHeadroomProject: { __typename?: 'SaveProjectResponse', success: boolean, errorMessage?: string | null, isUpdate?: boolean | null } };

export type SaveHeadroomSegmentationDataMutationVariables = Exact<{
  input: SaveHeadroomSegmentationDataInput;
}>;


export type SaveHeadroomSegmentationDataMutation = { __typename?: 'Mutation', saveHeadroomSegmentationData: { __typename?: 'SaveHeadroomSegmentationDataResponse', success: boolean, errorMessage?: string | null, isUpdate?: boolean | null } };

export type SignInMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type SignInMutation = { __typename?: 'Mutation', signIn?: string | null };

export type SignOutMutationVariables = Exact<{ [key: string]: never; }>;


export type SignOutMutation = { __typename?: 'Mutation', signOut?: { __typename?: 'CurrentUser', id: string, cruxyId: string, email: string, role?: UserRole | null, iat?: number | null, exp?: number | null } | null };

export type SignUpMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  role: UserRole;
  cruxyId: Scalars['String']['input'];
}>;


export type SignUpMutation = { __typename?: 'Mutation', signUp?: string | null };

export type InitTableForAzureMutationVariables = Exact<{
  cubeName: Scalars['String']['input'];
  headers: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type InitTableForAzureMutation = { __typename?: 'Mutation', initTableForAzure: boolean };

export type ForceIngestTableMutationVariables = Exact<{
  datasetId: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  tableUuid: Scalars['String']['input'];
  cubeId: Scalars['String']['input'];
}>;


export type ForceIngestTableMutation = { __typename?: 'Mutation', forceIngestTable: boolean };

export type ForceIngestTableForMatcherDataMutationVariables = Exact<{
  fileName: Scalars['String']['input'];
  tableUuid: Scalars['String']['input'];
  viewName: Scalars['String']['input'];
  cubeId: Scalars['String']['input'];
}>;


export type ForceIngestTableForMatcherDataMutation = { __typename?: 'Mutation', forceIngestTableForMatcherData: boolean };

export type InitTableForMatcherDataMutationVariables = Exact<{
  headers: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type InitTableForMatcherDataMutation = { __typename?: 'Mutation', initTableForMatcherData: boolean };

export type UnmatchProcessedMutationVariables = Exact<{
  tableName: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UnmatchProcessedMutation = { __typename?: 'Mutation', unmatchProcessed: { __typename?: 'unmatchProcessedResponse', success: boolean, error?: string | null } };

export type UpsertPipelineTagMutationVariables = Exact<{
  upsertPipelineTagId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  cruxyId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpsertPipelineTagMutation = { __typename?: 'Mutation', upsertPipelineTag?: string | null };

export type UpsertColumnMutationVariables = Exact<{
  input: UpsertColumnInput;
  upsertColumnId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpsertColumnMutation = { __typename?: 'Mutation', upsertColumn?: string | null };

export type UpsertFormulaMutationVariables = Exact<{
  input: UpsertFormulaInput;
  upsertFormulaId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpsertFormulaMutation = { __typename?: 'Mutation', upsertFormula?: { __typename?: 'Formula', columnId: string, conditionFormula: any, id: string, valueFormula: string, cruxyId: string } | null };

export type UpsertPipelineMutationVariables = Exact<{
  input: UpsertPipelineInput;
  pipelineId: Scalars['String']['input'];
  columnId: Scalars['String']['input'];
  basePipelineId: Scalars['String']['input'];
}>;


export type UpsertPipelineMutation = { __typename?: 'Mutation', upsertPipeline?: { __typename?: 'Pipeline', basePipelineId: string, columnId: string, schema?: { __typename?: 'Schema', stages?: Array<{ __typename?: 'Stage', id?: string | null, name?: string | null, orderNumber?: number | null } | null> | null, pipelineInstances?: Array<{ __typename?: 'PipelineInstance', id?: string | null, name?: string | null, averageAmount?: number | null, orderNumber?: number | null, numberOfClosedWons?: number | null } | null> | null } | null, durations?: Array<{ __typename?: 'Duration', pipelineInstanceId?: string | null, stageId?: string | null, duration?: number | null, conversionRate?: number | null, numberOfDeals?: number | null } | null> | null } | null };

export type InstancesQueryVariables = Exact<{
  columnId: Scalars['String']['input'];
}>;


export type InstancesQuery = { __typename?: 'Query', instances: Array<{ __typename?: 'InstancesResponse', name: string, averageAmount: number } | null> };

export type ClientsQueryVariables = Exact<{
  filter?: InputMaybe<ClientsFilter>;
}>;


export type ClientsQuery = { __typename?: 'Query', clients: Array<{ __typename?: 'ClientsResponse', cruxyId?: string | null, name?: string | null } | null> };

export type CustomColumnsQueryVariables = Exact<{
  filter: CustomColumnFilters;
}>;


export type CustomColumnsQuery = { __typename?: 'Query', customColumns: Array<{ __typename?: 'CustomColumn', columnId?: string | null, columnName?: string | null, cruxyId?: string | null, tableId?: string | null } | null> };

export type CompaniesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  filter: CompaniesFilter;
}>;


export type CompaniesQuery = { __typename?: 'Query', companies: { __typename?: 'CompaniesResponse', totalCount: string, edges: Array<{ __typename?: 'Company', id: string, name: string, parentCompanyId?: string | null, type?: string | null, cruxyId: string, createdById?: string | null, createDate?: string | null, country?: string | null, annualRevenue?: string | null, industry?: string | null, customProperties?: any | null }> } };

export type ConversionRatesQueryVariables = Exact<{
  pipelineId: Scalars['String']['input'];
}>;


export type ConversionRatesQuery = { __typename?: 'Query', conversionRates: Array<{ __typename?: 'ConversionRatesResponse', conversionRate: number, numberOfDeals: number, stageId: string, instanceId: string } | null> };

export type CrmColumnsQueryVariables = Exact<{
  crmColumnsId: Scalars['String']['input'];
}>;


export type CrmColumnsQuery = { __typename?: 'Query', crmColumns: Array<string | null> };

export type CrmPipelinesQueryVariables = Exact<{
  cruxyId: Scalars['String']['input'];
}>;


export type CrmPipelinesQuery = { __typename?: 'Query', crmPipelines: Array<{ __typename?: 'CRMPipelinesResponse', id: string, name: string, displayOrder: number } | null> };

export type CubesQueryVariables = Exact<{
  filter?: InputMaybe<CubesFilter>;
}>;


export type CubesQuery = { __typename?: 'Query', cubes: Array<{ __typename?: 'CubesResponse', cubeId?: string | null, name?: string | null } | null> };

export type CurrentCubeQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentCubeQuery = { __typename?: 'Query', currentCube: { __typename?: 'CubesResponse', cubeId?: string | null, name?: string | null } };

export type DealsQueryVariables = Exact<{
  filter: DealsFilter;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DealsQuery = { __typename?: 'Query', deals: { __typename?: 'DealsResponse', totalCount: string, edges: Array<{ __typename?: 'Deal', id: string, dealName?: string | null, dealStage?: string | null, createDate?: string | null, closeDate?: string | null, dealOwnerId?: string | null, amount?: string | null, analyticsLatestSource?: string | null, pipeline?: string | null, fiscalYear?: string | null, type?: string | null, dealCurrencyCode?: string | null, createdById?: string | null, arr?: string | null, amountInHomeCurrency?: string | null, acv?: string | null, customProperties?: any | null, associatedCompany: Array<{ __typename?: 'Company', id: string, name: string, createDate?: string | null, createdById?: string | null, country?: string | null } | null>, associatedContact: Array<{ __typename?: 'Contact', id: string, firstName: string, lastName: string } | null> }> } };

export type ExpectationQueryVariables = Exact<{
  cruxyId: Scalars['String']['input'];
  pipelineId: Scalars['String']['input'];
}>;


export type ExpectationQuery = { __typename?: 'Query', expectations?: Array<{ __typename?: 'Projection', amount: number, amountConverted: number, cruxyId: string, dateOfCalculation: string, dateOfProjection: string, instanceName: string, minimumStage: number, numberOfDeals: number, numberOfDealsConverted: number, pipelineId: string } | null> | null };

export type FormulasQueryVariables = Exact<{
  columnId: Scalars['String']['input'];
}>;


export type FormulasQuery = { __typename?: 'Query', formulas?: Array<{ __typename?: 'Formula', id: string, columnId: string, conditionFormula: any, valueFormula: string } | null> | null };

export type GetAllHeadroomProjectsQueryVariables = Exact<{
  cubeId: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetAllHeadroomProjectsQuery = { __typename?: 'Query', getAllHeadroomProjects: { __typename?: 'GetAllHeadroomProjectsResponse', totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean, edges: Array<{ __typename?: 'ProjectNameResponse', name?: string | null }> } };

export type DataFromTablesByDatasetIdQueryVariables = Exact<{
  cubeName: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
  includeAlreadyMerged: Scalars['Boolean']['input'];
}>;


export type DataFromTablesByDatasetIdQuery = { __typename?: 'Query', dataFromTablesByDatasetId: { __typename?: 'DataFromTablesResponse', uniqueFilenames: Array<string>, columnNames: Array<string> } };

export type DatasetsByCubeIdQueryVariables = Exact<{
  cubeId: Scalars['String']['input'];
  includeAlreadyMerged: Scalars['Boolean']['input'];
}>;


export type DatasetsByCubeIdQuery = { __typename?: 'Query', datasetsByCubeId: Array<{ __typename?: 'DatasetResponse', id?: string | null, name?: string | null, cubeId?: string | null } | null> };

export type GetHeadroomFinalResultsQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  tableName: Scalars['String']['input'];
  segmentGroups: Array<SegmentGroupInput> | SegmentGroupInput;
  customerColumn: Scalars['String']['input'];
  driverDenominatorColumn: Scalars['String']['input'];
  driverMode: DriverMode;
  driverNumeratorColumn?: InputMaybe<Scalars['String']['input']>;
  increasedPenetration?: InputMaybe<Scalars['Float']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetHeadroomFinalResultsQuery = { __typename?: 'Query', getHeadroomFinalResults: { __typename?: 'HeadroomFinalResultsWithTotals', totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean, edges: Array<{ __typename?: 'HeadroomFinalResponse', segment: string, segmentValue: string, segmentRange?: string | null, totalCustomers: number, totalProspects: number, penetration?: number | null, driverInitial?: number | null, driverFinal?: number | null, headroom?: number | null, increasedPenetration?: number | null, totalCustomersAfter: number, totalDriverInitial?: number | null, totalDriverFinal?: number | null, totalHeadroom?: number | null, headroomPercent?: number | null, FxUniqueRowUuid: string }>, totals: { __typename?: 'HeadroomTotals', totalCustomers: number, totalProspects: number, driverInitial: number, driverFinal: number, headroom: number, totalCustomersAfter: number, totalDriverInitial: number, totalDriverFinal: number, totalHeadroom: number, penetration: number, headroomPercent: number, increasedPenetration: number } } };

export type GetHeadroomProjectByNameQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  cubeId: Scalars['String']['input'];
}>;


export type GetHeadroomProjectByNameQuery = { __typename?: 'Query', getHeadroomProjectByName?: { __typename?: 'Project', projectName: string, tableName?: string | null, driver1Type?: string | null, driver2Type?: string | null, driver1NumeratorType?: string | null, driver2NumeratorType?: string | null, driver1Mode?: DriverMode | null, driver2Mode?: DriverMode | null, count1Column?: string | null, count2Column?: string | null, customerColumn?: string | null, driver1Percentile?: Percentile | null, driver2Percentile?: Percentile | null, headroomDriver?: string | null, headroomPercentile?: number | null, cubeId?: string | null, createdAt: string, updatedAt?: string | null, segmentGroups: Array<{ __typename?: 'SegmentGroup', index: number, type: string, method: SegmentationMethod, rangeColumn?: string | null, segments: Array<{ __typename?: 'Segment', id: number, minValue: number, maxValue: number }> }> } | null };

export type SegmentedDataQueryVariables = Exact<{
  tableName: Scalars['String']['input'];
  segmentGroups: Array<SegmentGroupInput> | SegmentGroupInput;
  count1Column: Scalars['String']['input'];
  count2Column?: InputMaybe<Scalars['String']['input']>;
  driver1DenominatorColumn: Scalars['String']['input'];
  driver1Mode: DriverMode;
  driver2DenominatorColumn: Scalars['String']['input'];
  driver2Mode: DriverMode;
  driver1NumeratorColumn?: InputMaybe<Scalars['String']['input']>;
  driver2NumeratorColumn?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SegmentedDataQuery = { __typename?: 'Query', segmentedData: { __typename?: 'SegmentedDataResponse', totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean, edges: Array<{ __typename?: 'SegmentResponse', segment: string, segmentValue: string, segmentRange?: string | null, count1: number, count2: number, total: number, numerator?: number | null, FxUniqueRowUuid: string, driver1Metrics?: { __typename?: 'DriverMetrics', min?: number | null, percentile25?: number | null, percentile50?: number | null, percentile75?: number | null, max?: number | null } | null, driver2Metrics?: { __typename?: 'DriverMetrics', min?: number | null, percentile25?: number | null, percentile50?: number | null, percentile75?: number | null, max?: number | null } | null }> } };

export type SegmentedDriverMetricsQueryVariables = Exact<{
  tableName: Scalars['String']['input'];
  segmentGroups: Array<SegmentGroupInput> | SegmentGroupInput;
  customerColumn: Scalars['String']['input'];
  driver1NumeratorColumn?: InputMaybe<Scalars['String']['input']>;
  driver1DenominatorColumn?: InputMaybe<Scalars['String']['input']>;
  driver1Mode?: InputMaybe<DriverMode>;
  driver1Percentile?: InputMaybe<Scalars['Int']['input']>;
  driver2NumeratorColumn?: InputMaybe<Scalars['String']['input']>;
  driver2DenominatorColumn?: InputMaybe<Scalars['String']['input']>;
  driver2Mode?: InputMaybe<DriverMode>;
  driver2Percentile?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SegmentedDriverMetricsQuery = { __typename?: 'Query', segmentedDriverMetrics: { __typename?: 'DriverMetricsDataResponse', totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean, edges: Array<{ __typename?: 'DriverMetricsResponse', segment: string, segmentValue: string, segmentRange?: string | null, rangeLower?: number | null, rangeUpper?: number | null, driver1Median?: number | null, driver1Avg?: number | null, driver1Percentile?: number | null, driver1Denominator?: number | null, driver2Median?: number | null, driver2Avg?: number | null, driver2Percentile?: number | null, driver2Denominator?: number | null, FxUniqueRowUuid: string }> } };

export type ProcessedDataTableHeadersQueryVariables = Exact<{
  tableName: Scalars['String']['input'];
}>;


export type ProcessedDataTableHeadersQuery = { __typename?: 'Query', processedDataTableHeaders: { __typename?: 'ProcessedDataTableHeadersResponse', columns: Array<{ __typename?: 'Column', name: string, isNumeric: boolean, min?: number | null, max?: number | null }> } };

export type InvoiceLogDatesQueryVariables = Exact<{
  cruxyId: Scalars['String']['input'];
}>;


export type InvoiceLogDatesQuery = { __typename?: 'Query', invoiceLogDates: Array<string | null> };

export type InvoiceLogsQueryVariables = Exact<{
  cruxyId: Scalars['String']['input'];
  date: Scalars['String']['input'];
}>;


export type InvoiceLogsQuery = { __typename?: 'Query', invoiceLogs?: { __typename?: 'InvoiceLogsResponse', cruxyId?: string | null, companies?: Array<{ __typename?: 'InvoiceLog', invoiceName?: string | null, matchName?: string | null, matchId?: string | null, numberOfDealsHidden?: number | null, idsOfDealsHidden?: Array<string | null> | null, newDealID?: string | null, insertedNow?: boolean | null, changes?: { __typename?: 'Changes', name?: { __typename?: 'Change', from?: string | null, to?: string | null } | null, country?: { __typename?: 'Change', from?: string | null, to?: string | null } | null, industry?: { __typename?: 'Change', from?: string | null, to?: string | null } | null } | null } | null> | null } | null };

export type InvoicesQueryVariables = Exact<{
  filter: InvoicesFilter;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type InvoicesQuery = { __typename?: 'Query', invoices: { __typename?: 'InvoicesResponse', totalCount: string, edges: Array<{ __typename?: 'Invoice', invoiceNumber: string, accountName?: string | null, accountLegalName?: string | null, accountStatus?: string | null, accountId?: string | null, check?: string | null, annualisedConverted?: string | null, annualisedValue?: string | null, contractType?: string | null, creditGbp?: string | null, cruxyId: string, currency?: string | null, currentMonth?: string | null, date?: string | null, debitGbp?: string | null, description?: string | null, endDate?: string | null, exchangeRate?: string | null, id: string, industry?: string | null, industryPrimarySegment?: string | null, industrySubsegment?: string | null, invoiceLengthMonths?: string | null, keyStakeholderTitleOrPosition?: string | null, mrr?: string | null, productSold?: string | null, reference?: string | null, salesLastYear?: string | null, sourceOfInvoiceData?: string | null, startDate?: string | null, country?: string | null } | null> } };

export type GetApplyInvoicesPlanQueryVariables = Exact<{
  cruxyId: Scalars['String']['input'];
}>;


export type GetApplyInvoicesPlanQuery = { __typename?: 'Query', getApplyInvoicesPlan?: { __typename?: 'GetApplyInvoicesPlanResponse', cruxyId?: string | null, companies?: Array<{ __typename?: 'InvoiceLog', invoiceName?: string | null, matchName?: string | null, matchId?: string | null, idsOfDealsHidden?: Array<string | null> | null, numberOfDealsHidden?: number | null, newDealID?: string | null, insertedNow?: boolean | null, changes?: { __typename?: 'Changes', name?: { __typename?: 'Change', from?: string | null, to?: string | null } | null, country?: { __typename?: 'Change', from?: string | null, to?: string | null } | null, industry?: { __typename?: 'Change', from?: string | null, to?: string | null } | null } | null } | null> | null } | null };

export type UserQueryVariables = Exact<{ [key: string]: never; }>;


export type UserQuery = { __typename?: 'Query', me?: { __typename?: 'CurrentUser', cruxyId: string, id: string, role?: UserRole | null, azure_sas_token?: string | null } | null };

export type MyViewsQueryVariables = Exact<{
  cubeId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MyViewsQuery = { __typename?: 'Query', myViews: { __typename?: 'ViewsData', edges: Array<any>, totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean } };

export type OperatorsQueryVariables = Exact<{ [key: string]: never; }>;


export type OperatorsQuery = { __typename?: 'Query', operators: Array<{ __typename?: 'Operators', symbol?: string | null, text?: string | null }> };

export type PipelinesQueryVariables = Exact<{
  cruxyId: Scalars['String']['input'];
}>;


export type PipelinesQuery = { __typename?: 'Query', pipelines?: Array<{ __typename?: 'PipelinesResponse', id: string, name: string, data?: { __typename?: 'Pipeline', basePipelineId: string, columnId: string, durations?: Array<{ __typename?: 'Duration', duration?: number | null, pipelineInstanceId?: string | null, stageId?: string | null, conversionRate?: number | null, numberOfDeals?: number | null } | null> | null, schema?: { __typename?: 'Schema', pipelineInstances?: Array<{ __typename?: 'PipelineInstance', averageAmount?: number | null, id?: string | null, name?: string | null, orderNumber?: number | null, numberOfClosedWons?: number | null } | null> | null, stages?: Array<{ __typename?: 'Stage', id?: string | null, name?: string | null, orderNumber?: number | null } | null> | null } | null } | null } | null> | null };

export type DatasetPreviewQueryVariables = Exact<{
  filter?: InputMaybe<DatasetPreviewFilter>;
}>;


export type DatasetPreviewQuery = { __typename?: 'Query', datasetPreview: { __typename?: 'DatasetPreviewResponse', dataset: Array<any>, totalCount: number } };

export type ProcessedDataAndCountPreviewQueryVariables = Exact<{
  filter?: InputMaybe<ProcessedDataPreviewFilter>;
}>;


export type ProcessedDataAndCountPreviewQuery = { __typename?: 'Query', processedDataAndCountPreview: { __typename?: 'ProcessedDataPreviewResponse', data: Array<any>, totalCount: number } };

export type QueryProcessedDataViewsQueryVariables = Exact<{
  cubeId: Scalars['String']['input'];
  includeHeadroomData?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type QueryProcessedDataViewsQuery = { __typename?: 'Query', queryProcessedDataViews: { __typename?: 'ProcessedDataViewsResponse', totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean, success: boolean, error?: string | null, edges: Array<{ __typename?: 'ViewsResponse', name?: string | null, createdAt?: string | null }> } };

export type QueryProcessedViewsDataQueryVariables = Exact<{
  cubeId: Scalars['String']['input'];
  filter: ViewDataFilter;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  includeMatched?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type QueryProcessedViewsDataQuery = { __typename?: 'Query', queryProcessedViewsData: { __typename?: 'ProcessedDataResponse', edges: Array<any>, totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean, success: boolean, error?: string | null } };

export type QueryMatchedViewsPhaseDataQueryVariables = Exact<{
  cubeName: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
  phase: Scalars['Int']['input'];
  viewName: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type QueryMatchedViewsPhaseDataQuery = { __typename?: 'Query', queryMatchedViewsPhaseData: { __typename?: 'ProcessedDataResponse', edges: Array<any>, totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean, success: boolean, error?: string | null } };

export type QueryProcessedTableMatcherTableNameQueryVariables = Exact<{
  tableName: Scalars['String']['input'];
}>;


export type QueryProcessedTableMatcherTableNameQuery = { __typename?: 'Query', queryProcessedTableMatcherTableName: { __typename?: 'QueryProcessedTableNameResult', success: boolean, matcherTable?: string | null, identifier?: string | null, error?: string | null } };

export type RealityQueryVariables = Exact<{
  cruxyId: Scalars['String']['input'];
  pipelineId: Scalars['String']['input'];
}>;


export type RealityQuery = { __typename?: 'Query', reality?: Array<{ __typename?: 'Projection', cruxyId: string, pipelineId: string, instanceName: string, minimumStage: number, numberOfDeals: number, numberOfDealsConverted: number, amount: number, amountConverted: number, dateOfCalculation: string, dateOfProjection: string } | null> | null };

export type RolesQueryVariables = Exact<{ [key: string]: never; }>;


export type RolesQuery = { __typename?: 'Query', roles?: Array<UserRole | null> | null };

export type GroupedCountsByColumnQueryVariables = Exact<{
  input: GroupedCountsInput;
}>;


export type GroupedCountsByColumnQuery = { __typename?: 'Query', groupedCountsByColumn: { __typename?: 'GroupedCountsResponse', groupCounts: Array<{ __typename?: 'GroupedCount', groupValue: string, count: number }> } };

export type StagesQueryVariables = Exact<{
  pipelineId: Scalars['String']['input'];
}>;


export type StagesQuery = { __typename?: 'Query', stages: Array<{ __typename?: 'StagesResponse', id: string, label: string, displayOrder: number } | null> };

export type CrmTablesQueryVariables = Exact<{ [key: string]: never; }>;


export type CrmTablesQuery = { __typename?: 'Query', crmTables: Array<{ __typename?: 'CRMTables', id?: string | null, name?: string | null, path?: string | null } | null> };

export type MatcherTablesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  cubeId: Scalars['String']['input'];
}>;


export type MatcherTablesQuery = { __typename?: 'Query', matcherTables: { __typename?: 'TablesData', edges: Array<any>, totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean } };

export type MatcherTableHeadersQueryVariables = Exact<{
  tableName: Scalars['String']['input'];
  cubeId: Scalars['String']['input'];
}>;


export type MatcherTableHeadersQuery = { __typename?: 'Query', matcherTableHeaders: Array<string> };

export type MatcherTableDataQueryVariables = Exact<{
  tableName: Scalars['String']['input'];
  cubeId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  columnName?: InputMaybe<Scalars['String']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<MatcherTableFilter>;
}>;


export type MatcherTableDataQuery = { __typename?: 'Query', matcherTableData: { __typename?: 'TablesData', edges: Array<any>, totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean } };

export type UsersQueryVariables = Exact<{
  filter?: InputMaybe<UsersFilter>;
}>;


export type UsersQuery = { __typename?: 'Query', users?: Array<{ __typename?: 'User', id: string, role: UserRole, email: string, cruxyId: string, azure_sas_token?: string | null } | null> | null };

export type ViewsQueryVariables = Exact<{
  filter: ViewsFilter;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ViewsQuery = { __typename?: 'Query', views: { __typename?: 'ViewsData', edges: Array<any>, totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean } };

export type ViewHeadersQueryVariables = Exact<{
  cubeId: Scalars['String']['input'];
  viewName: Scalars['String']['input'];
}>;


export type ViewHeadersQuery = { __typename?: 'Query', viewHeaders: Array<string> };

export type ViewDataQueryVariables = Exact<{
  cubeId: Scalars['String']['input'];
  filter: ViewDataFilter;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ViewDataQuery = { __typename?: 'Query', viewData: { __typename?: 'ViewsData', edges: Array<any>, totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean } };


export const ApplyFormulaDocument = gql`
    mutation ApplyFormula($applyFormulaId: String!) {
  applyFormula(id: $applyFormulaId)
}
    `;
export type ApplyFormulaMutationFn = Apollo.MutationFunction<ApplyFormulaMutation, ApplyFormulaMutationVariables>;

/**
 * __useApplyFormulaMutation__
 *
 * To run a mutation, you first call `useApplyFormulaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyFormulaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyFormulaMutation, { data, loading, error }] = useApplyFormulaMutation({
 *   variables: {
 *      applyFormulaId: // value for 'applyFormulaId'
 *   },
 * });
 */
export function useApplyFormulaMutation(baseOptions?: Apollo.MutationHookOptions<ApplyFormulaMutation, ApplyFormulaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyFormulaMutation, ApplyFormulaMutationVariables>(ApplyFormulaDocument, options);
      }
export type ApplyFormulaMutationHookResult = ReturnType<typeof useApplyFormulaMutation>;
export type ApplyFormulaMutationResult = Apollo.MutationResult<ApplyFormulaMutation>;
export type ApplyFormulaMutationOptions = Apollo.BaseMutationOptions<ApplyFormulaMutation, ApplyFormulaMutationVariables>;
export const ApplyFormulasForColumnDocument = gql`
    mutation ApplyFormulasForColumn($columnId: String!) {
  applyFormulasForColumn(columnId: $columnId) {
    formulaId
    message
  }
}
    `;
export type ApplyFormulasForColumnMutationFn = Apollo.MutationFunction<ApplyFormulasForColumnMutation, ApplyFormulasForColumnMutationVariables>;

/**
 * __useApplyFormulasForColumnMutation__
 *
 * To run a mutation, you first call `useApplyFormulasForColumnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyFormulasForColumnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyFormulasForColumnMutation, { data, loading, error }] = useApplyFormulasForColumnMutation({
 *   variables: {
 *      columnId: // value for 'columnId'
 *   },
 * });
 */
export function useApplyFormulasForColumnMutation(baseOptions?: Apollo.MutationHookOptions<ApplyFormulasForColumnMutation, ApplyFormulasForColumnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyFormulasForColumnMutation, ApplyFormulasForColumnMutationVariables>(ApplyFormulasForColumnDocument, options);
      }
export type ApplyFormulasForColumnMutationHookResult = ReturnType<typeof useApplyFormulasForColumnMutation>;
export type ApplyFormulasForColumnMutationResult = Apollo.MutationResult<ApplyFormulasForColumnMutation>;
export type ApplyFormulasForColumnMutationOptions = Apollo.BaseMutationOptions<ApplyFormulasForColumnMutation, ApplyFormulasForColumnMutationVariables>;
export const ApplyInvoicesDocument = gql`
    mutation ApplyInvoices($cruxyId: String!) {
  applyInvoices(cruxyId: $cruxyId) {
    cruxyId
    companies {
      invoiceName
      matchName
      matchId
      changes {
        name {
          from
          to
        }
        country {
          from
          to
        }
        industry {
          from
          to
        }
      }
      numberOfDealsHidden
      idsOfDealsHidden
      newDealID
      insertedNow
    }
  }
}
    `;
export type ApplyInvoicesMutationFn = Apollo.MutationFunction<ApplyInvoicesMutation, ApplyInvoicesMutationVariables>;

/**
 * __useApplyInvoicesMutation__
 *
 * To run a mutation, you first call `useApplyInvoicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyInvoicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyInvoicesMutation, { data, loading, error }] = useApplyInvoicesMutation({
 *   variables: {
 *      cruxyId: // value for 'cruxyId'
 *   },
 * });
 */
export function useApplyInvoicesMutation(baseOptions?: Apollo.MutationHookOptions<ApplyInvoicesMutation, ApplyInvoicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyInvoicesMutation, ApplyInvoicesMutationVariables>(ApplyInvoicesDocument, options);
      }
export type ApplyInvoicesMutationHookResult = ReturnType<typeof useApplyInvoicesMutation>;
export type ApplyInvoicesMutationResult = Apollo.MutationResult<ApplyInvoicesMutation>;
export type ApplyInvoicesMutationOptions = Apollo.BaseMutationOptions<ApplyInvoicesMutation, ApplyInvoicesMutationVariables>;
export const CreateClientDocument = gql`
    mutation CreateClient($cruxyId: String!, $name: String!) {
  createClient(cruxyId: $cruxyId, name: $name) {
    success
  }
}
    `;
export type CreateClientMutationFn = Apollo.MutationFunction<CreateClientMutation, CreateClientMutationVariables>;

/**
 * __useCreateClientMutation__
 *
 * To run a mutation, you first call `useCreateClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientMutation, { data, loading, error }] = useCreateClientMutation({
 *   variables: {
 *      cruxyId: // value for 'cruxyId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateClientMutation(baseOptions?: Apollo.MutationHookOptions<CreateClientMutation, CreateClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClientMutation, CreateClientMutationVariables>(CreateClientDocument, options);
      }
export type CreateClientMutationHookResult = ReturnType<typeof useCreateClientMutation>;
export type CreateClientMutationResult = Apollo.MutationResult<CreateClientMutation>;
export type CreateClientMutationOptions = Apollo.BaseMutationOptions<CreateClientMutation, CreateClientMutationVariables>;
export const CreateCubeDocument = gql`
    mutation CreateCube($name: String!) {
  createCube(name: $name) {
    success
  }
}
    `;
export type CreateCubeMutationFn = Apollo.MutationFunction<CreateCubeMutation, CreateCubeMutationVariables>;

/**
 * __useCreateCubeMutation__
 *
 * To run a mutation, you first call `useCreateCubeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCubeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCubeMutation, { data, loading, error }] = useCreateCubeMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateCubeMutation(baseOptions?: Apollo.MutationHookOptions<CreateCubeMutation, CreateCubeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCubeMutation, CreateCubeMutationVariables>(CreateCubeDocument, options);
      }
export type CreateCubeMutationHookResult = ReturnType<typeof useCreateCubeMutation>;
export type CreateCubeMutationResult = Apollo.MutationResult<CreateCubeMutation>;
export type CreateCubeMutationOptions = Apollo.BaseMutationOptions<CreateCubeMutation, CreateCubeMutationVariables>;
export const CreateDatasetDocument = gql`
    mutation CreateDataset($cubeId: String!, $dataSetName: String!) {
  createDataset(cubeId: $cubeId, dataSetName: $dataSetName) {
    success
    id
  }
}
    `;
export type CreateDatasetMutationFn = Apollo.MutationFunction<CreateDatasetMutation, CreateDatasetMutationVariables>;

/**
 * __useCreateDatasetMutation__
 *
 * To run a mutation, you first call `useCreateDatasetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDatasetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDatasetMutation, { data, loading, error }] = useCreateDatasetMutation({
 *   variables: {
 *      cubeId: // value for 'cubeId'
 *      dataSetName: // value for 'dataSetName'
 *   },
 * });
 */
export function useCreateDatasetMutation(baseOptions?: Apollo.MutationHookOptions<CreateDatasetMutation, CreateDatasetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDatasetMutation, CreateDatasetMutationVariables>(CreateDatasetDocument, options);
      }
export type CreateDatasetMutationHookResult = ReturnType<typeof useCreateDatasetMutation>;
export type CreateDatasetMutationResult = Apollo.MutationResult<CreateDatasetMutation>;
export type CreateDatasetMutationOptions = Apollo.BaseMutationOptions<CreateDatasetMutation, CreateDatasetMutationVariables>;
export const CreateViewFromDatasetDocument = gql`
    mutation CreateViewFromDataset($payload: CreateViewPayload!) {
  createViewFromDataset(payload: $payload) {
    success
    mergedTablePath
    error
  }
}
    `;
export type CreateViewFromDatasetMutationFn = Apollo.MutationFunction<CreateViewFromDatasetMutation, CreateViewFromDatasetMutationVariables>;

/**
 * __useCreateViewFromDatasetMutation__
 *
 * To run a mutation, you first call `useCreateViewFromDatasetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateViewFromDatasetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createViewFromDatasetMutation, { data, loading, error }] = useCreateViewFromDatasetMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateViewFromDatasetMutation(baseOptions?: Apollo.MutationHookOptions<CreateViewFromDatasetMutation, CreateViewFromDatasetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateViewFromDatasetMutation, CreateViewFromDatasetMutationVariables>(CreateViewFromDatasetDocument, options);
      }
export type CreateViewFromDatasetMutationHookResult = ReturnType<typeof useCreateViewFromDatasetMutation>;
export type CreateViewFromDatasetMutationResult = Apollo.MutationResult<CreateViewFromDatasetMutation>;
export type CreateViewFromDatasetMutationOptions = Apollo.BaseMutationOptions<CreateViewFromDatasetMutation, CreateViewFromDatasetMutationVariables>;
export const DeleteColumnDocument = gql`
    mutation DeleteColumn($deleteColumnId: String!) {
  deleteColumn(id: $deleteColumnId)
}
    `;
export type DeleteColumnMutationFn = Apollo.MutationFunction<DeleteColumnMutation, DeleteColumnMutationVariables>;

/**
 * __useDeleteColumnMutation__
 *
 * To run a mutation, you first call `useDeleteColumnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteColumnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteColumnMutation, { data, loading, error }] = useDeleteColumnMutation({
 *   variables: {
 *      deleteColumnId: // value for 'deleteColumnId'
 *   },
 * });
 */
export function useDeleteColumnMutation(baseOptions?: Apollo.MutationHookOptions<DeleteColumnMutation, DeleteColumnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteColumnMutation, DeleteColumnMutationVariables>(DeleteColumnDocument, options);
      }
export type DeleteColumnMutationHookResult = ReturnType<typeof useDeleteColumnMutation>;
export type DeleteColumnMutationResult = Apollo.MutationResult<DeleteColumnMutation>;
export type DeleteColumnMutationOptions = Apollo.BaseMutationOptions<DeleteColumnMutation, DeleteColumnMutationVariables>;
export const DeleteCubeDocument = gql`
    mutation DeleteCube($cubeId: String!) {
  deleteCube(cubeId: $cubeId) {
    success
  }
}
    `;
export type DeleteCubeMutationFn = Apollo.MutationFunction<DeleteCubeMutation, DeleteCubeMutationVariables>;

/**
 * __useDeleteCubeMutation__
 *
 * To run a mutation, you first call `useDeleteCubeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCubeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCubeMutation, { data, loading, error }] = useDeleteCubeMutation({
 *   variables: {
 *      cubeId: // value for 'cubeId'
 *   },
 * });
 */
export function useDeleteCubeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCubeMutation, DeleteCubeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCubeMutation, DeleteCubeMutationVariables>(DeleteCubeDocument, options);
      }
export type DeleteCubeMutationHookResult = ReturnType<typeof useDeleteCubeMutation>;
export type DeleteCubeMutationResult = Apollo.MutationResult<DeleteCubeMutation>;
export type DeleteCubeMutationOptions = Apollo.BaseMutationOptions<DeleteCubeMutation, DeleteCubeMutationVariables>;
export const DeleteDatasetDocument = gql`
    mutation DeleteDataset($datasetId: String!, $cubeName: String!) {
  deleteDataset(datasetId: $datasetId, cubeName: $cubeName) {
    id
    success
  }
}
    `;
export type DeleteDatasetMutationFn = Apollo.MutationFunction<DeleteDatasetMutation, DeleteDatasetMutationVariables>;

/**
 * __useDeleteDatasetMutation__
 *
 * To run a mutation, you first call `useDeleteDatasetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDatasetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDatasetMutation, { data, loading, error }] = useDeleteDatasetMutation({
 *   variables: {
 *      datasetId: // value for 'datasetId'
 *      cubeName: // value for 'cubeName'
 *   },
 * });
 */
export function useDeleteDatasetMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDatasetMutation, DeleteDatasetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDatasetMutation, DeleteDatasetMutationVariables>(DeleteDatasetDocument, options);
      }
export type DeleteDatasetMutationHookResult = ReturnType<typeof useDeleteDatasetMutation>;
export type DeleteDatasetMutationResult = Apollo.MutationResult<DeleteDatasetMutation>;
export type DeleteDatasetMutationOptions = Apollo.BaseMutationOptions<DeleteDatasetMutation, DeleteDatasetMutationVariables>;
export const DeleteDatasetsBySourceFileIdDocument = gql`
    mutation DeleteDatasetsBySourceFileID($sourceFileId: String!, $cubeName: String!, $datasetId: String!) {
  deleteDatasetsBySourceFileID(
    sourceFileID: $sourceFileId
    cubeName: $cubeName
    datasetId: $datasetId
  ) {
    id
    success
  }
}
    `;
export type DeleteDatasetsBySourceFileIdMutationFn = Apollo.MutationFunction<DeleteDatasetsBySourceFileIdMutation, DeleteDatasetsBySourceFileIdMutationVariables>;

/**
 * __useDeleteDatasetsBySourceFileIdMutation__
 *
 * To run a mutation, you first call `useDeleteDatasetsBySourceFileIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDatasetsBySourceFileIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDatasetsBySourceFileIdMutation, { data, loading, error }] = useDeleteDatasetsBySourceFileIdMutation({
 *   variables: {
 *      sourceFileId: // value for 'sourceFileId'
 *      cubeName: // value for 'cubeName'
 *      datasetId: // value for 'datasetId'
 *   },
 * });
 */
export function useDeleteDatasetsBySourceFileIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDatasetsBySourceFileIdMutation, DeleteDatasetsBySourceFileIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDatasetsBySourceFileIdMutation, DeleteDatasetsBySourceFileIdMutationVariables>(DeleteDatasetsBySourceFileIdDocument, options);
      }
export type DeleteDatasetsBySourceFileIdMutationHookResult = ReturnType<typeof useDeleteDatasetsBySourceFileIdMutation>;
export type DeleteDatasetsBySourceFileIdMutationResult = Apollo.MutationResult<DeleteDatasetsBySourceFileIdMutation>;
export type DeleteDatasetsBySourceFileIdMutationOptions = Apollo.BaseMutationOptions<DeleteDatasetsBySourceFileIdMutation, DeleteDatasetsBySourceFileIdMutationVariables>;
export const DeleteFormulaDocument = gql`
    mutation DeleteFormula($deleteFormulaId: String!) {
  deleteFormula(id: $deleteFormulaId)
}
    `;
export type DeleteFormulaMutationFn = Apollo.MutationFunction<DeleteFormulaMutation, DeleteFormulaMutationVariables>;

/**
 * __useDeleteFormulaMutation__
 *
 * To run a mutation, you first call `useDeleteFormulaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFormulaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFormulaMutation, { data, loading, error }] = useDeleteFormulaMutation({
 *   variables: {
 *      deleteFormulaId: // value for 'deleteFormulaId'
 *   },
 * });
 */
export function useDeleteFormulaMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFormulaMutation, DeleteFormulaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFormulaMutation, DeleteFormulaMutationVariables>(DeleteFormulaDocument, options);
      }
export type DeleteFormulaMutationHookResult = ReturnType<typeof useDeleteFormulaMutation>;
export type DeleteFormulaMutationResult = Apollo.MutationResult<DeleteFormulaMutation>;
export type DeleteFormulaMutationOptions = Apollo.BaseMutationOptions<DeleteFormulaMutation, DeleteFormulaMutationVariables>;
export const DeleteHeadroomProjectDocument = gql`
    mutation DeleteHeadroomProject($projectName: String!) {
  deleteHeadroomProject(projectName: $projectName) {
    success
    errorMessage
  }
}
    `;
export type DeleteHeadroomProjectMutationFn = Apollo.MutationFunction<DeleteHeadroomProjectMutation, DeleteHeadroomProjectMutationVariables>;

/**
 * __useDeleteHeadroomProjectMutation__
 *
 * To run a mutation, you first call `useDeleteHeadroomProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHeadroomProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteHeadroomProjectMutation, { data, loading, error }] = useDeleteHeadroomProjectMutation({
 *   variables: {
 *      projectName: // value for 'projectName'
 *   },
 * });
 */
export function useDeleteHeadroomProjectMutation(baseOptions?: Apollo.MutationHookOptions<DeleteHeadroomProjectMutation, DeleteHeadroomProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteHeadroomProjectMutation, DeleteHeadroomProjectMutationVariables>(DeleteHeadroomProjectDocument, options);
      }
export type DeleteHeadroomProjectMutationHookResult = ReturnType<typeof useDeleteHeadroomProjectMutation>;
export type DeleteHeadroomProjectMutationResult = Apollo.MutationResult<DeleteHeadroomProjectMutation>;
export type DeleteHeadroomProjectMutationOptions = Apollo.BaseMutationOptions<DeleteHeadroomProjectMutation, DeleteHeadroomProjectMutationVariables>;
export const DeleteMergedViewDocument = gql`
    mutation DeleteMergedView($cubeId: String!, $viewName: String!) {
  deleteMergedView(cubeId: $cubeId, viewName: $viewName) {
    message
    success
  }
}
    `;
export type DeleteMergedViewMutationFn = Apollo.MutationFunction<DeleteMergedViewMutation, DeleteMergedViewMutationVariables>;

/**
 * __useDeleteMergedViewMutation__
 *
 * To run a mutation, you first call `useDeleteMergedViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMergedViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMergedViewMutation, { data, loading, error }] = useDeleteMergedViewMutation({
 *   variables: {
 *      cubeId: // value for 'cubeId'
 *      viewName: // value for 'viewName'
 *   },
 * });
 */
export function useDeleteMergedViewMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMergedViewMutation, DeleteMergedViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMergedViewMutation, DeleteMergedViewMutationVariables>(DeleteMergedViewDocument, options);
      }
export type DeleteMergedViewMutationHookResult = ReturnType<typeof useDeleteMergedViewMutation>;
export type DeleteMergedViewMutationResult = Apollo.MutationResult<DeleteMergedViewMutation>;
export type DeleteMergedViewMutationOptions = Apollo.BaseMutationOptions<DeleteMergedViewMutation, DeleteMergedViewMutationVariables>;
export const DeletePipelineTagDocument = gql`
    mutation DeletePipelineTag($deletePipelineTagId: String!) {
  deletePipelineTag(id: $deletePipelineTagId)
}
    `;
export type DeletePipelineTagMutationFn = Apollo.MutationFunction<DeletePipelineTagMutation, DeletePipelineTagMutationVariables>;

/**
 * __useDeletePipelineTagMutation__
 *
 * To run a mutation, you first call `useDeletePipelineTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePipelineTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePipelineTagMutation, { data, loading, error }] = useDeletePipelineTagMutation({
 *   variables: {
 *      deletePipelineTagId: // value for 'deletePipelineTagId'
 *   },
 * });
 */
export function useDeletePipelineTagMutation(baseOptions?: Apollo.MutationHookOptions<DeletePipelineTagMutation, DeletePipelineTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePipelineTagMutation, DeletePipelineTagMutationVariables>(DeletePipelineTagDocument, options);
      }
export type DeletePipelineTagMutationHookResult = ReturnType<typeof useDeletePipelineTagMutation>;
export type DeletePipelineTagMutationResult = Apollo.MutationResult<DeletePipelineTagMutation>;
export type DeletePipelineTagMutationOptions = Apollo.BaseMutationOptions<DeletePipelineTagMutation, DeletePipelineTagMutationVariables>;
export const DeleteProcessedTableDocument = gql`
    mutation DeleteProcessedTable($tableName: String!) {
  deleteProcessedTable(tableName: $tableName) {
    success
    message
  }
}
    `;
export type DeleteProcessedTableMutationFn = Apollo.MutationFunction<DeleteProcessedTableMutation, DeleteProcessedTableMutationVariables>;

/**
 * __useDeleteProcessedTableMutation__
 *
 * To run a mutation, you first call `useDeleteProcessedTableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProcessedTableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProcessedTableMutation, { data, loading, error }] = useDeleteProcessedTableMutation({
 *   variables: {
 *      tableName: // value for 'tableName'
 *   },
 * });
 */
export function useDeleteProcessedTableMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProcessedTableMutation, DeleteProcessedTableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProcessedTableMutation, DeleteProcessedTableMutationVariables>(DeleteProcessedTableDocument, options);
      }
export type DeleteProcessedTableMutationHookResult = ReturnType<typeof useDeleteProcessedTableMutation>;
export type DeleteProcessedTableMutationResult = Apollo.MutationResult<DeleteProcessedTableMutation>;
export type DeleteProcessedTableMutationOptions = Apollo.BaseMutationOptions<DeleteProcessedTableMutation, DeleteProcessedTableMutationVariables>;
export const EditCompanyDocument = gql`
    mutation EditCompany($fields: EditCompanyFields!, $editCompanyId: String!) {
  editCompany(fields: $fields, id: $editCompanyId) {
    id
    name
    parentCompanyId
    type
    cruxyId
    createdById
    createDate
    country
    annualRevenue
    industry
    customProperties
  }
}
    `;
export type EditCompanyMutationFn = Apollo.MutationFunction<EditCompanyMutation, EditCompanyMutationVariables>;

/**
 * __useEditCompanyMutation__
 *
 * To run a mutation, you first call `useEditCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCompanyMutation, { data, loading, error }] = useEditCompanyMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *      editCompanyId: // value for 'editCompanyId'
 *   },
 * });
 */
export function useEditCompanyMutation(baseOptions?: Apollo.MutationHookOptions<EditCompanyMutation, EditCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCompanyMutation, EditCompanyMutationVariables>(EditCompanyDocument, options);
      }
export type EditCompanyMutationHookResult = ReturnType<typeof useEditCompanyMutation>;
export type EditCompanyMutationResult = Apollo.MutationResult<EditCompanyMutation>;
export type EditCompanyMutationOptions = Apollo.BaseMutationOptions<EditCompanyMutation, EditCompanyMutationVariables>;
export const EditDealDocument = gql`
    mutation EditDeal($fields: EditDealFields!, $editDealId: String!) {
  editDeal(fields: $fields, id: $editDealId) {
    id
    dealName
    dealStage
    createDate
    closeDate
    dealOwnerId
    amount
    analyticsLatestSource
    associatedCompany {
      id
      name
      createDate
      createdById
      country
    }
    pipeline
    associatedContact {
      id
      firstName
      lastName
    }
    fiscalYear
    type
    dealCurrencyCode
    createdById
    arr
    amountInHomeCurrency
    acv
    customProperties
  }
}
    `;
export type EditDealMutationFn = Apollo.MutationFunction<EditDealMutation, EditDealMutationVariables>;

/**
 * __useEditDealMutation__
 *
 * To run a mutation, you first call `useEditDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editDealMutation, { data, loading, error }] = useEditDealMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *      editDealId: // value for 'editDealId'
 *   },
 * });
 */
export function useEditDealMutation(baseOptions?: Apollo.MutationHookOptions<EditDealMutation, EditDealMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditDealMutation, EditDealMutationVariables>(EditDealDocument, options);
      }
export type EditDealMutationHookResult = ReturnType<typeof useEditDealMutation>;
export type EditDealMutationResult = Apollo.MutationResult<EditDealMutation>;
export type EditDealMutationOptions = Apollo.BaseMutationOptions<EditDealMutation, EditDealMutationVariables>;
export const FinishMatchDocument = gql`
    mutation FinishMatch($cubeId: String!, $tableName: String!, $outputViewName: String!, $matcherTableName: String!, $identifier: String!) {
  finishMatch(
    cubeId: $cubeId
    tableName: $tableName
    outputViewName: $outputViewName
    matcherTableName: $matcherTableName
    identifier: $identifier
  ) {
    success
    error
  }
}
    `;
export type FinishMatchMutationFn = Apollo.MutationFunction<FinishMatchMutation, FinishMatchMutationVariables>;

/**
 * __useFinishMatchMutation__
 *
 * To run a mutation, you first call `useFinishMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishMatchMutation, { data, loading, error }] = useFinishMatchMutation({
 *   variables: {
 *      cubeId: // value for 'cubeId'
 *      tableName: // value for 'tableName'
 *      outputViewName: // value for 'outputViewName'
 *      matcherTableName: // value for 'matcherTableName'
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useFinishMatchMutation(baseOptions?: Apollo.MutationHookOptions<FinishMatchMutation, FinishMatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinishMatchMutation, FinishMatchMutationVariables>(FinishMatchDocument, options);
      }
export type FinishMatchMutationHookResult = ReturnType<typeof useFinishMatchMutation>;
export type FinishMatchMutationResult = Apollo.MutationResult<FinishMatchMutation>;
export type FinishMatchMutationOptions = Apollo.BaseMutationOptions<FinishMatchMutation, FinishMatchMutationVariables>;
export const MatchPhaseDocument = gql`
    mutation MatchPhase($cubeId: String!, $phase: Int!, $tableName: String!, $matcherTable: String!, $identifier: String!, $headers: [[String!]!]!) {
  matchPhase(
    cubeId: $cubeId
    phase: $phase
    tableName: $tableName
    matcherTable: $matcherTable
    identifier: $identifier
    headers: $headers
  ) {
    success
    statistics {
      cubeId
      phase
      tableName
      identifier
      totalRecords
      matchedCount
      duplicateCount
      duplicates {
        FX_UNIQUE_ID
        NAME
        COUNT
      }
    }
    error
  }
}
    `;
export type MatchPhaseMutationFn = Apollo.MutationFunction<MatchPhaseMutation, MatchPhaseMutationVariables>;

/**
 * __useMatchPhaseMutation__
 *
 * To run a mutation, you first call `useMatchPhaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMatchPhaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [matchPhaseMutation, { data, loading, error }] = useMatchPhaseMutation({
 *   variables: {
 *      cubeId: // value for 'cubeId'
 *      phase: // value for 'phase'
 *      tableName: // value for 'tableName'
 *      matcherTable: // value for 'matcherTable'
 *      identifier: // value for 'identifier'
 *      headers: // value for 'headers'
 *   },
 * });
 */
export function useMatchPhaseMutation(baseOptions?: Apollo.MutationHookOptions<MatchPhaseMutation, MatchPhaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MatchPhaseMutation, MatchPhaseMutationVariables>(MatchPhaseDocument, options);
      }
export type MatchPhaseMutationHookResult = ReturnType<typeof useMatchPhaseMutation>;
export type MatchPhaseMutationResult = Apollo.MutationResult<MatchPhaseMutation>;
export type MatchPhaseMutationOptions = Apollo.BaseMutationOptions<MatchPhaseMutation, MatchPhaseMutationVariables>;
export const UnmatchRecordsDocument = gql`
    mutation UnmatchRecords($cubeId: String!, $tableName: String!, $identifier: String!, $ids: [String!]!) {
  unmatchRecords(
    cubeId: $cubeId
    tableName: $tableName
    identifier: $identifier
    ids: $ids
  ) {
    success
    error
  }
}
    `;
export type UnmatchRecordsMutationFn = Apollo.MutationFunction<UnmatchRecordsMutation, UnmatchRecordsMutationVariables>;

/**
 * __useUnmatchRecordsMutation__
 *
 * To run a mutation, you first call `useUnmatchRecordsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnmatchRecordsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unmatchRecordsMutation, { data, loading, error }] = useUnmatchRecordsMutation({
 *   variables: {
 *      cubeId: // value for 'cubeId'
 *      tableName: // value for 'tableName'
 *      identifier: // value for 'identifier'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useUnmatchRecordsMutation(baseOptions?: Apollo.MutationHookOptions<UnmatchRecordsMutation, UnmatchRecordsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnmatchRecordsMutation, UnmatchRecordsMutationVariables>(UnmatchRecordsDocument, options);
      }
export type UnmatchRecordsMutationHookResult = ReturnType<typeof useUnmatchRecordsMutation>;
export type UnmatchRecordsMutationResult = Apollo.MutationResult<UnmatchRecordsMutation>;
export type UnmatchRecordsMutationOptions = Apollo.BaseMutationOptions<UnmatchRecordsMutation, UnmatchRecordsMutationVariables>;
export const MergeRecordsDocument = gql`
    mutation MergeRecords($cubeId: String!, $tableName: String!, $identifier: String!, $fxId: String!, $value: String!, $score: Float!) {
  mergeRecords(
    cubeId: $cubeId
    tableName: $tableName
    identifier: $identifier
    fxId: $fxId
    value: $value
    score: $score
  ) {
    success
    error
  }
}
    `;
export type MergeRecordsMutationFn = Apollo.MutationFunction<MergeRecordsMutation, MergeRecordsMutationVariables>;

/**
 * __useMergeRecordsMutation__
 *
 * To run a mutation, you first call `useMergeRecordsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeRecordsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeRecordsMutation, { data, loading, error }] = useMergeRecordsMutation({
 *   variables: {
 *      cubeId: // value for 'cubeId'
 *      tableName: // value for 'tableName'
 *      identifier: // value for 'identifier'
 *      fxId: // value for 'fxId'
 *      value: // value for 'value'
 *      score: // value for 'score'
 *   },
 * });
 */
export function useMergeRecordsMutation(baseOptions?: Apollo.MutationHookOptions<MergeRecordsMutation, MergeRecordsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MergeRecordsMutation, MergeRecordsMutationVariables>(MergeRecordsDocument, options);
      }
export type MergeRecordsMutationHookResult = ReturnType<typeof useMergeRecordsMutation>;
export type MergeRecordsMutationResult = Apollo.MutationResult<MergeRecordsMutation>;
export type MergeRecordsMutationOptions = Apollo.BaseMutationOptions<MergeRecordsMutation, MergeRecordsMutationVariables>;
export const MergeDatasetsDocument = gql`
    mutation MergeDatasets($payload: MergeDatasetsPayload!) {
  mergeDatasets(payload: $payload) {
    success
    mergedTablePath
    error
  }
}
    `;
export type MergeDatasetsMutationFn = Apollo.MutationFunction<MergeDatasetsMutation, MergeDatasetsMutationVariables>;

/**
 * __useMergeDatasetsMutation__
 *
 * To run a mutation, you first call `useMergeDatasetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeDatasetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeDatasetsMutation, { data, loading, error }] = useMergeDatasetsMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useMergeDatasetsMutation(baseOptions?: Apollo.MutationHookOptions<MergeDatasetsMutation, MergeDatasetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MergeDatasetsMutation, MergeDatasetsMutationVariables>(MergeDatasetsDocument, options);
      }
export type MergeDatasetsMutationHookResult = ReturnType<typeof useMergeDatasetsMutation>;
export type MergeDatasetsMutationResult = Apollo.MutationResult<MergeDatasetsMutation>;
export type MergeDatasetsMutationOptions = Apollo.BaseMutationOptions<MergeDatasetsMutation, MergeDatasetsMutationVariables>;
export const MergeProcessedDocument = gql`
    mutation MergeProcessed($tableName: String!, $identifier: String!, $fxId: String!, $value: String!, $score: Float!) {
  mergeProcessed(
    tableName: $tableName
    identifier: $identifier
    fxId: $fxId
    value: $value
    score: $score
  ) {
    success
    error
  }
}
    `;
export type MergeProcessedMutationFn = Apollo.MutationFunction<MergeProcessedMutation, MergeProcessedMutationVariables>;

/**
 * __useMergeProcessedMutation__
 *
 * To run a mutation, you first call `useMergeProcessedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeProcessedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeProcessedMutation, { data, loading, error }] = useMergeProcessedMutation({
 *   variables: {
 *      tableName: // value for 'tableName'
 *      identifier: // value for 'identifier'
 *      fxId: // value for 'fxId'
 *      value: // value for 'value'
 *      score: // value for 'score'
 *   },
 * });
 */
export function useMergeProcessedMutation(baseOptions?: Apollo.MutationHookOptions<MergeProcessedMutation, MergeProcessedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MergeProcessedMutation, MergeProcessedMutationVariables>(MergeProcessedDocument, options);
      }
export type MergeProcessedMutationHookResult = ReturnType<typeof useMergeProcessedMutation>;
export type MergeProcessedMutationResult = Apollo.MutationResult<MergeProcessedMutation>;
export type MergeProcessedMutationOptions = Apollo.BaseMutationOptions<MergeProcessedMutation, MergeProcessedMutationVariables>;
export const RecalculateExpectationsDocument = gql`
    mutation RecalculateExpectations($cruxyId: String!, $pipelineId: String!, $input: JSONObject!) {
  recalculateExpectations(
    cruxyId: $cruxyId
    pipelineId: $pipelineId
    input: $input
  ) {
    cruxyId
    pipelineId
    instanceName
    minimumStage
    numberOfDeals
    numberOfDealsConverted
    amount
    amountConverted
    dateOfCalculation
    dateOfProjection
  }
}
    `;
export type RecalculateExpectationsMutationFn = Apollo.MutationFunction<RecalculateExpectationsMutation, RecalculateExpectationsMutationVariables>;

/**
 * __useRecalculateExpectationsMutation__
 *
 * To run a mutation, you first call `useRecalculateExpectationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecalculateExpectationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recalculateExpectationsMutation, { data, loading, error }] = useRecalculateExpectationsMutation({
 *   variables: {
 *      cruxyId: // value for 'cruxyId'
 *      pipelineId: // value for 'pipelineId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecalculateExpectationsMutation(baseOptions?: Apollo.MutationHookOptions<RecalculateExpectationsMutation, RecalculateExpectationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecalculateExpectationsMutation, RecalculateExpectationsMutationVariables>(RecalculateExpectationsDocument, options);
      }
export type RecalculateExpectationsMutationHookResult = ReturnType<typeof useRecalculateExpectationsMutation>;
export type RecalculateExpectationsMutationResult = Apollo.MutationResult<RecalculateExpectationsMutation>;
export type RecalculateExpectationsMutationOptions = Apollo.BaseMutationOptions<RecalculateExpectationsMutation, RecalculateExpectationsMutationVariables>;
export const RefreshRealityDocument = gql`
    mutation RefreshReality($cruxyId: String!, $pipelineId: String!, $untilDate: String!) {
  refreshReality(
    cruxyId: $cruxyId
    pipelineId: $pipelineId
    untilDate: $untilDate
  ) {
    amount
    amountConverted
    cruxyId
    dateOfCalculation
    dateOfProjection
    instanceName
    minimumStage
    numberOfDeals
    numberOfDealsConverted
    pipelineId
  }
}
    `;
export type RefreshRealityMutationFn = Apollo.MutationFunction<RefreshRealityMutation, RefreshRealityMutationVariables>;

/**
 * __useRefreshRealityMutation__
 *
 * To run a mutation, you first call `useRefreshRealityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshRealityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshRealityMutation, { data, loading, error }] = useRefreshRealityMutation({
 *   variables: {
 *      cruxyId: // value for 'cruxyId'
 *      pipelineId: // value for 'pipelineId'
 *      untilDate: // value for 'untilDate'
 *   },
 * });
 */
export function useRefreshRealityMutation(baseOptions?: Apollo.MutationHookOptions<RefreshRealityMutation, RefreshRealityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshRealityMutation, RefreshRealityMutationVariables>(RefreshRealityDocument, options);
      }
export type RefreshRealityMutationHookResult = ReturnType<typeof useRefreshRealityMutation>;
export type RefreshRealityMutationResult = Apollo.MutationResult<RefreshRealityMutation>;
export type RefreshRealityMutationOptions = Apollo.BaseMutationOptions<RefreshRealityMutation, RefreshRealityMutationVariables>;
export const RefreshTokenDocument = gql`
    mutation RefreshToken {
  refreshToken
}
    `;
export type RefreshTokenMutationFn = Apollo.MutationFunction<RefreshTokenMutation, RefreshTokenMutationVariables>;

/**
 * __useRefreshTokenMutation__
 *
 * To run a mutation, you first call `useRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokenMutation, { data, loading, error }] = useRefreshTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useRefreshTokenMutation(baseOptions?: Apollo.MutationHookOptions<RefreshTokenMutation, RefreshTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshTokenMutation, RefreshTokenMutationVariables>(RefreshTokenDocument, options);
      }
export type RefreshTokenMutationHookResult = ReturnType<typeof useRefreshTokenMutation>;
export type RefreshTokenMutationResult = Apollo.MutationResult<RefreshTokenMutation>;
export type RefreshTokenMutationOptions = Apollo.BaseMutationOptions<RefreshTokenMutation, RefreshTokenMutationVariables>;
export const RemoveMatcherViewDocument = gql`
    mutation RemoveMatcherView($viewName: String!) {
  removeMatcherView(viewName: $viewName) {
    success
    message
  }
}
    `;
export type RemoveMatcherViewMutationFn = Apollo.MutationFunction<RemoveMatcherViewMutation, RemoveMatcherViewMutationVariables>;

/**
 * __useRemoveMatcherViewMutation__
 *
 * To run a mutation, you first call `useRemoveMatcherViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMatcherViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMatcherViewMutation, { data, loading, error }] = useRemoveMatcherViewMutation({
 *   variables: {
 *      viewName: // value for 'viewName'
 *   },
 * });
 */
export function useRemoveMatcherViewMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMatcherViewMutation, RemoveMatcherViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMatcherViewMutation, RemoveMatcherViewMutationVariables>(RemoveMatcherViewDocument, options);
      }
export type RemoveMatcherViewMutationHookResult = ReturnType<typeof useRemoveMatcherViewMutation>;
export type RemoveMatcherViewMutationResult = Apollo.MutationResult<RemoveMatcherViewMutation>;
export type RemoveMatcherViewMutationOptions = Apollo.BaseMutationOptions<RemoveMatcherViewMutation, RemoveMatcherViewMutationVariables>;
export const SaveHeadroomDriverMetricsDocument = gql`
    mutation SaveHeadroomDriverMetrics($input: SaveHeadroomDriverMetricsInput!) {
  saveHeadroomDriverMetrics(input: $input) {
    success
    errorMessage
    isUpdate
  }
}
    `;
export type SaveHeadroomDriverMetricsMutationFn = Apollo.MutationFunction<SaveHeadroomDriverMetricsMutation, SaveHeadroomDriverMetricsMutationVariables>;

/**
 * __useSaveHeadroomDriverMetricsMutation__
 *
 * To run a mutation, you first call `useSaveHeadroomDriverMetricsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveHeadroomDriverMetricsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveHeadroomDriverMetricsMutation, { data, loading, error }] = useSaveHeadroomDriverMetricsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveHeadroomDriverMetricsMutation(baseOptions?: Apollo.MutationHookOptions<SaveHeadroomDriverMetricsMutation, SaveHeadroomDriverMetricsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveHeadroomDriverMetricsMutation, SaveHeadroomDriverMetricsMutationVariables>(SaveHeadroomDriverMetricsDocument, options);
      }
export type SaveHeadroomDriverMetricsMutationHookResult = ReturnType<typeof useSaveHeadroomDriverMetricsMutation>;
export type SaveHeadroomDriverMetricsMutationResult = Apollo.MutationResult<SaveHeadroomDriverMetricsMutation>;
export type SaveHeadroomDriverMetricsMutationOptions = Apollo.BaseMutationOptions<SaveHeadroomDriverMetricsMutation, SaveHeadroomDriverMetricsMutationVariables>;
export const SaveHeadroomFinalDataDocument = gql`
    mutation SaveHeadroomFinalData($input: SaveHeadroomFinalDataInput!) {
  saveHeadroomFinalData(input: $input) {
    success
    errorMessage
    isUpdate
  }
}
    `;
export type SaveHeadroomFinalDataMutationFn = Apollo.MutationFunction<SaveHeadroomFinalDataMutation, SaveHeadroomFinalDataMutationVariables>;

/**
 * __useSaveHeadroomFinalDataMutation__
 *
 * To run a mutation, you first call `useSaveHeadroomFinalDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveHeadroomFinalDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveHeadroomFinalDataMutation, { data, loading, error }] = useSaveHeadroomFinalDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveHeadroomFinalDataMutation(baseOptions?: Apollo.MutationHookOptions<SaveHeadroomFinalDataMutation, SaveHeadroomFinalDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveHeadroomFinalDataMutation, SaveHeadroomFinalDataMutationVariables>(SaveHeadroomFinalDataDocument, options);
      }
export type SaveHeadroomFinalDataMutationHookResult = ReturnType<typeof useSaveHeadroomFinalDataMutation>;
export type SaveHeadroomFinalDataMutationResult = Apollo.MutationResult<SaveHeadroomFinalDataMutation>;
export type SaveHeadroomFinalDataMutationOptions = Apollo.BaseMutationOptions<SaveHeadroomFinalDataMutation, SaveHeadroomFinalDataMutationVariables>;
export const SaveHeadroomProjectDocument = gql`
    mutation SaveHeadroomProject($input: SaveProjectInput!) {
  saveHeadroomProject(input: $input) {
    success
    errorMessage
    isUpdate
  }
}
    `;
export type SaveHeadroomProjectMutationFn = Apollo.MutationFunction<SaveHeadroomProjectMutation, SaveHeadroomProjectMutationVariables>;

/**
 * __useSaveHeadroomProjectMutation__
 *
 * To run a mutation, you first call `useSaveHeadroomProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveHeadroomProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveHeadroomProjectMutation, { data, loading, error }] = useSaveHeadroomProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveHeadroomProjectMutation(baseOptions?: Apollo.MutationHookOptions<SaveHeadroomProjectMutation, SaveHeadroomProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveHeadroomProjectMutation, SaveHeadroomProjectMutationVariables>(SaveHeadroomProjectDocument, options);
      }
export type SaveHeadroomProjectMutationHookResult = ReturnType<typeof useSaveHeadroomProjectMutation>;
export type SaveHeadroomProjectMutationResult = Apollo.MutationResult<SaveHeadroomProjectMutation>;
export type SaveHeadroomProjectMutationOptions = Apollo.BaseMutationOptions<SaveHeadroomProjectMutation, SaveHeadroomProjectMutationVariables>;
export const SaveHeadroomSegmentationDataDocument = gql`
    mutation SaveHeadroomSegmentationData($input: SaveHeadroomSegmentationDataInput!) {
  saveHeadroomSegmentationData(input: $input) {
    success
    errorMessage
    isUpdate
  }
}
    `;
export type SaveHeadroomSegmentationDataMutationFn = Apollo.MutationFunction<SaveHeadroomSegmentationDataMutation, SaveHeadroomSegmentationDataMutationVariables>;

/**
 * __useSaveHeadroomSegmentationDataMutation__
 *
 * To run a mutation, you first call `useSaveHeadroomSegmentationDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveHeadroomSegmentationDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveHeadroomSegmentationDataMutation, { data, loading, error }] = useSaveHeadroomSegmentationDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveHeadroomSegmentationDataMutation(baseOptions?: Apollo.MutationHookOptions<SaveHeadroomSegmentationDataMutation, SaveHeadroomSegmentationDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveHeadroomSegmentationDataMutation, SaveHeadroomSegmentationDataMutationVariables>(SaveHeadroomSegmentationDataDocument, options);
      }
export type SaveHeadroomSegmentationDataMutationHookResult = ReturnType<typeof useSaveHeadroomSegmentationDataMutation>;
export type SaveHeadroomSegmentationDataMutationResult = Apollo.MutationResult<SaveHeadroomSegmentationDataMutation>;
export type SaveHeadroomSegmentationDataMutationOptions = Apollo.BaseMutationOptions<SaveHeadroomSegmentationDataMutation, SaveHeadroomSegmentationDataMutationVariables>;
export const SignInDocument = gql`
    mutation SignIn($email: String!, $password: String!) {
  signIn(email: $email, password: $password)
}
    `;
export type SignInMutationFn = Apollo.MutationFunction<SignInMutation, SignInMutationVariables>;

/**
 * __useSignInMutation__
 *
 * To run a mutation, you first call `useSignInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInMutation, { data, loading, error }] = useSignInMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useSignInMutation(baseOptions?: Apollo.MutationHookOptions<SignInMutation, SignInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignInMutation, SignInMutationVariables>(SignInDocument, options);
      }
export type SignInMutationHookResult = ReturnType<typeof useSignInMutation>;
export type SignInMutationResult = Apollo.MutationResult<SignInMutation>;
export type SignInMutationOptions = Apollo.BaseMutationOptions<SignInMutation, SignInMutationVariables>;
export const SignOutDocument = gql`
    mutation SignOut {
  signOut {
    id
    cruxyId
    email
    role
    iat
    exp
  }
}
    `;
export type SignOutMutationFn = Apollo.MutationFunction<SignOutMutation, SignOutMutationVariables>;

/**
 * __useSignOutMutation__
 *
 * To run a mutation, you first call `useSignOutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignOutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signOutMutation, { data, loading, error }] = useSignOutMutation({
 *   variables: {
 *   },
 * });
 */
export function useSignOutMutation(baseOptions?: Apollo.MutationHookOptions<SignOutMutation, SignOutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignOutMutation, SignOutMutationVariables>(SignOutDocument, options);
      }
export type SignOutMutationHookResult = ReturnType<typeof useSignOutMutation>;
export type SignOutMutationResult = Apollo.MutationResult<SignOutMutation>;
export type SignOutMutationOptions = Apollo.BaseMutationOptions<SignOutMutation, SignOutMutationVariables>;
export const SignUpDocument = gql`
    mutation SignUp($email: String!, $password: String!, $role: UserRole!, $cruxyId: String!) {
  signUp(email: $email, password: $password, role: $role, cruxyId: $cruxyId)
}
    `;
export type SignUpMutationFn = Apollo.MutationFunction<SignUpMutation, SignUpMutationVariables>;

/**
 * __useSignUpMutation__
 *
 * To run a mutation, you first call `useSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpMutation, { data, loading, error }] = useSignUpMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      role: // value for 'role'
 *      cruxyId: // value for 'cruxyId'
 *   },
 * });
 */
export function useSignUpMutation(baseOptions?: Apollo.MutationHookOptions<SignUpMutation, SignUpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignUpMutation, SignUpMutationVariables>(SignUpDocument, options);
      }
export type SignUpMutationHookResult = ReturnType<typeof useSignUpMutation>;
export type SignUpMutationResult = Apollo.MutationResult<SignUpMutation>;
export type SignUpMutationOptions = Apollo.BaseMutationOptions<SignUpMutation, SignUpMutationVariables>;
export const InitTableForAzureDocument = gql`
    mutation InitTableForAzure($cubeName: String!, $headers: [String!]!) {
  initTableForAzure(cubeName: $cubeName, headers: $headers)
}
    `;
export type InitTableForAzureMutationFn = Apollo.MutationFunction<InitTableForAzureMutation, InitTableForAzureMutationVariables>;

/**
 * __useInitTableForAzureMutation__
 *
 * To run a mutation, you first call `useInitTableForAzureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitTableForAzureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initTableForAzureMutation, { data, loading, error }] = useInitTableForAzureMutation({
 *   variables: {
 *      cubeName: // value for 'cubeName'
 *      headers: // value for 'headers'
 *   },
 * });
 */
export function useInitTableForAzureMutation(baseOptions?: Apollo.MutationHookOptions<InitTableForAzureMutation, InitTableForAzureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitTableForAzureMutation, InitTableForAzureMutationVariables>(InitTableForAzureDocument, options);
      }
export type InitTableForAzureMutationHookResult = ReturnType<typeof useInitTableForAzureMutation>;
export type InitTableForAzureMutationResult = Apollo.MutationResult<InitTableForAzureMutation>;
export type InitTableForAzureMutationOptions = Apollo.BaseMutationOptions<InitTableForAzureMutation, InitTableForAzureMutationVariables>;
export const ForceIngestTableDocument = gql`
    mutation ForceIngestTable($datasetId: String!, $fileName: String!, $tableUuid: String!, $cubeId: String!) {
  forceIngestTable(
    datasetId: $datasetId
    fileName: $fileName
    tableUuid: $tableUuid
    cubeId: $cubeId
  )
}
    `;
export type ForceIngestTableMutationFn = Apollo.MutationFunction<ForceIngestTableMutation, ForceIngestTableMutationVariables>;

/**
 * __useForceIngestTableMutation__
 *
 * To run a mutation, you first call `useForceIngestTableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForceIngestTableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forceIngestTableMutation, { data, loading, error }] = useForceIngestTableMutation({
 *   variables: {
 *      datasetId: // value for 'datasetId'
 *      fileName: // value for 'fileName'
 *      tableUuid: // value for 'tableUuid'
 *      cubeId: // value for 'cubeId'
 *   },
 * });
 */
export function useForceIngestTableMutation(baseOptions?: Apollo.MutationHookOptions<ForceIngestTableMutation, ForceIngestTableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForceIngestTableMutation, ForceIngestTableMutationVariables>(ForceIngestTableDocument, options);
      }
export type ForceIngestTableMutationHookResult = ReturnType<typeof useForceIngestTableMutation>;
export type ForceIngestTableMutationResult = Apollo.MutationResult<ForceIngestTableMutation>;
export type ForceIngestTableMutationOptions = Apollo.BaseMutationOptions<ForceIngestTableMutation, ForceIngestTableMutationVariables>;
export const ForceIngestTableForMatcherDataDocument = gql`
    mutation ForceIngestTableForMatcherData($fileName: String!, $tableUuid: String!, $viewName: String!, $cubeId: String!) {
  forceIngestTableForMatcherData(
    fileName: $fileName
    tableUuid: $tableUuid
    viewName: $viewName
    cubeId: $cubeId
  )
}
    `;
export type ForceIngestTableForMatcherDataMutationFn = Apollo.MutationFunction<ForceIngestTableForMatcherDataMutation, ForceIngestTableForMatcherDataMutationVariables>;

/**
 * __useForceIngestTableForMatcherDataMutation__
 *
 * To run a mutation, you first call `useForceIngestTableForMatcherDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForceIngestTableForMatcherDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forceIngestTableForMatcherDataMutation, { data, loading, error }] = useForceIngestTableForMatcherDataMutation({
 *   variables: {
 *      fileName: // value for 'fileName'
 *      tableUuid: // value for 'tableUuid'
 *      viewName: // value for 'viewName'
 *      cubeId: // value for 'cubeId'
 *   },
 * });
 */
export function useForceIngestTableForMatcherDataMutation(baseOptions?: Apollo.MutationHookOptions<ForceIngestTableForMatcherDataMutation, ForceIngestTableForMatcherDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForceIngestTableForMatcherDataMutation, ForceIngestTableForMatcherDataMutationVariables>(ForceIngestTableForMatcherDataDocument, options);
      }
export type ForceIngestTableForMatcherDataMutationHookResult = ReturnType<typeof useForceIngestTableForMatcherDataMutation>;
export type ForceIngestTableForMatcherDataMutationResult = Apollo.MutationResult<ForceIngestTableForMatcherDataMutation>;
export type ForceIngestTableForMatcherDataMutationOptions = Apollo.BaseMutationOptions<ForceIngestTableForMatcherDataMutation, ForceIngestTableForMatcherDataMutationVariables>;
export const InitTableForMatcherDataDocument = gql`
    mutation InitTableForMatcherData($headers: [String!]!) {
  initTableForMatcherData(headers: $headers)
}
    `;
export type InitTableForMatcherDataMutationFn = Apollo.MutationFunction<InitTableForMatcherDataMutation, InitTableForMatcherDataMutationVariables>;

/**
 * __useInitTableForMatcherDataMutation__
 *
 * To run a mutation, you first call `useInitTableForMatcherDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitTableForMatcherDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initTableForMatcherDataMutation, { data, loading, error }] = useInitTableForMatcherDataMutation({
 *   variables: {
 *      headers: // value for 'headers'
 *   },
 * });
 */
export function useInitTableForMatcherDataMutation(baseOptions?: Apollo.MutationHookOptions<InitTableForMatcherDataMutation, InitTableForMatcherDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitTableForMatcherDataMutation, InitTableForMatcherDataMutationVariables>(InitTableForMatcherDataDocument, options);
      }
export type InitTableForMatcherDataMutationHookResult = ReturnType<typeof useInitTableForMatcherDataMutation>;
export type InitTableForMatcherDataMutationResult = Apollo.MutationResult<InitTableForMatcherDataMutation>;
export type InitTableForMatcherDataMutationOptions = Apollo.BaseMutationOptions<InitTableForMatcherDataMutation, InitTableForMatcherDataMutationVariables>;
export const UnmatchProcessedDocument = gql`
    mutation UnmatchProcessed($tableName: String!, $identifier: String!, $ids: [String!]!) {
  unmatchProcessed(tableName: $tableName, identifier: $identifier, ids: $ids) {
    success
    error
  }
}
    `;
export type UnmatchProcessedMutationFn = Apollo.MutationFunction<UnmatchProcessedMutation, UnmatchProcessedMutationVariables>;

/**
 * __useUnmatchProcessedMutation__
 *
 * To run a mutation, you first call `useUnmatchProcessedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnmatchProcessedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unmatchProcessedMutation, { data, loading, error }] = useUnmatchProcessedMutation({
 *   variables: {
 *      tableName: // value for 'tableName'
 *      identifier: // value for 'identifier'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useUnmatchProcessedMutation(baseOptions?: Apollo.MutationHookOptions<UnmatchProcessedMutation, UnmatchProcessedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnmatchProcessedMutation, UnmatchProcessedMutationVariables>(UnmatchProcessedDocument, options);
      }
export type UnmatchProcessedMutationHookResult = ReturnType<typeof useUnmatchProcessedMutation>;
export type UnmatchProcessedMutationResult = Apollo.MutationResult<UnmatchProcessedMutation>;
export type UnmatchProcessedMutationOptions = Apollo.BaseMutationOptions<UnmatchProcessedMutation, UnmatchProcessedMutationVariables>;
export const UpsertPipelineTagDocument = gql`
    mutation UpsertPipelineTag($upsertPipelineTagId: String, $name: String!, $cruxyId: String) {
  upsertPipelineTag(id: $upsertPipelineTagId, name: $name, cruxyId: $cruxyId)
}
    `;
export type UpsertPipelineTagMutationFn = Apollo.MutationFunction<UpsertPipelineTagMutation, UpsertPipelineTagMutationVariables>;

/**
 * __useUpsertPipelineTagMutation__
 *
 * To run a mutation, you first call `useUpsertPipelineTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPipelineTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPipelineTagMutation, { data, loading, error }] = useUpsertPipelineTagMutation({
 *   variables: {
 *      upsertPipelineTagId: // value for 'upsertPipelineTagId'
 *      name: // value for 'name'
 *      cruxyId: // value for 'cruxyId'
 *   },
 * });
 */
export function useUpsertPipelineTagMutation(baseOptions?: Apollo.MutationHookOptions<UpsertPipelineTagMutation, UpsertPipelineTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertPipelineTagMutation, UpsertPipelineTagMutationVariables>(UpsertPipelineTagDocument, options);
      }
export type UpsertPipelineTagMutationHookResult = ReturnType<typeof useUpsertPipelineTagMutation>;
export type UpsertPipelineTagMutationResult = Apollo.MutationResult<UpsertPipelineTagMutation>;
export type UpsertPipelineTagMutationOptions = Apollo.BaseMutationOptions<UpsertPipelineTagMutation, UpsertPipelineTagMutationVariables>;
export const UpsertColumnDocument = gql`
    mutation upsertColumn($input: UpsertColumnInput!, $upsertColumnId: ID) {
  upsertColumn(input: $input, id: $upsertColumnId)
}
    `;
export type UpsertColumnMutationFn = Apollo.MutationFunction<UpsertColumnMutation, UpsertColumnMutationVariables>;

/**
 * __useUpsertColumnMutation__
 *
 * To run a mutation, you first call `useUpsertColumnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertColumnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertColumnMutation, { data, loading, error }] = useUpsertColumnMutation({
 *   variables: {
 *      input: // value for 'input'
 *      upsertColumnId: // value for 'upsertColumnId'
 *   },
 * });
 */
export function useUpsertColumnMutation(baseOptions?: Apollo.MutationHookOptions<UpsertColumnMutation, UpsertColumnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertColumnMutation, UpsertColumnMutationVariables>(UpsertColumnDocument, options);
      }
export type UpsertColumnMutationHookResult = ReturnType<typeof useUpsertColumnMutation>;
export type UpsertColumnMutationResult = Apollo.MutationResult<UpsertColumnMutation>;
export type UpsertColumnMutationOptions = Apollo.BaseMutationOptions<UpsertColumnMutation, UpsertColumnMutationVariables>;
export const UpsertFormulaDocument = gql`
    mutation UpsertFormula($input: UpsertFormulaInput!, $upsertFormulaId: String) {
  upsertFormula(input: $input, id: $upsertFormulaId) {
    columnId
    conditionFormula
    id
    valueFormula
    cruxyId
  }
}
    `;
export type UpsertFormulaMutationFn = Apollo.MutationFunction<UpsertFormulaMutation, UpsertFormulaMutationVariables>;

/**
 * __useUpsertFormulaMutation__
 *
 * To run a mutation, you first call `useUpsertFormulaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertFormulaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertFormulaMutation, { data, loading, error }] = useUpsertFormulaMutation({
 *   variables: {
 *      input: // value for 'input'
 *      upsertFormulaId: // value for 'upsertFormulaId'
 *   },
 * });
 */
export function useUpsertFormulaMutation(baseOptions?: Apollo.MutationHookOptions<UpsertFormulaMutation, UpsertFormulaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertFormulaMutation, UpsertFormulaMutationVariables>(UpsertFormulaDocument, options);
      }
export type UpsertFormulaMutationHookResult = ReturnType<typeof useUpsertFormulaMutation>;
export type UpsertFormulaMutationResult = Apollo.MutationResult<UpsertFormulaMutation>;
export type UpsertFormulaMutationOptions = Apollo.BaseMutationOptions<UpsertFormulaMutation, UpsertFormulaMutationVariables>;
export const UpsertPipelineDocument = gql`
    mutation UpsertPipeline($input: UpsertPipelineInput!, $pipelineId: String!, $columnId: String!, $basePipelineId: String!) {
  upsertPipeline(
    input: $input
    pipelineId: $pipelineId
    columnId: $columnId
    basePipelineId: $basePipelineId
  ) {
    basePipelineId
    columnId
    schema {
      stages {
        id
        name
        orderNumber
      }
      pipelineInstances {
        id
        name
        averageAmount
        orderNumber
        numberOfClosedWons
      }
    }
    durations {
      pipelineInstanceId
      stageId
      duration
      conversionRate
      numberOfDeals
    }
  }
}
    `;
export type UpsertPipelineMutationFn = Apollo.MutationFunction<UpsertPipelineMutation, UpsertPipelineMutationVariables>;

/**
 * __useUpsertPipelineMutation__
 *
 * To run a mutation, you first call `useUpsertPipelineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPipelineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPipelineMutation, { data, loading, error }] = useUpsertPipelineMutation({
 *   variables: {
 *      input: // value for 'input'
 *      pipelineId: // value for 'pipelineId'
 *      columnId: // value for 'columnId'
 *      basePipelineId: // value for 'basePipelineId'
 *   },
 * });
 */
export function useUpsertPipelineMutation(baseOptions?: Apollo.MutationHookOptions<UpsertPipelineMutation, UpsertPipelineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertPipelineMutation, UpsertPipelineMutationVariables>(UpsertPipelineDocument, options);
      }
export type UpsertPipelineMutationHookResult = ReturnType<typeof useUpsertPipelineMutation>;
export type UpsertPipelineMutationResult = Apollo.MutationResult<UpsertPipelineMutation>;
export type UpsertPipelineMutationOptions = Apollo.BaseMutationOptions<UpsertPipelineMutation, UpsertPipelineMutationVariables>;
export const InstancesDocument = gql`
    query Instances($columnId: String!) {
  instances(columnId: $columnId) {
    name
    averageAmount
  }
}
    `;

/**
 * __useInstancesQuery__
 *
 * To run a query within a React component, call `useInstancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInstancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInstancesQuery({
 *   variables: {
 *      columnId: // value for 'columnId'
 *   },
 * });
 */
export function useInstancesQuery(baseOptions: Apollo.QueryHookOptions<InstancesQuery, InstancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InstancesQuery, InstancesQueryVariables>(InstancesDocument, options);
      }
export function useInstancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InstancesQuery, InstancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InstancesQuery, InstancesQueryVariables>(InstancesDocument, options);
        }
export type InstancesQueryHookResult = ReturnType<typeof useInstancesQuery>;
export type InstancesLazyQueryHookResult = ReturnType<typeof useInstancesLazyQuery>;
export type InstancesQueryResult = Apollo.QueryResult<InstancesQuery, InstancesQueryVariables>;
export const ClientsDocument = gql`
    query Clients($filter: ClientsFilter) {
  clients(filter: $filter) {
    cruxyId
    name
  }
}
    `;

/**
 * __useClientsQuery__
 *
 * To run a query within a React component, call `useClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useClientsQuery(baseOptions?: Apollo.QueryHookOptions<ClientsQuery, ClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientsQuery, ClientsQueryVariables>(ClientsDocument, options);
      }
export function useClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientsQuery, ClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientsQuery, ClientsQueryVariables>(ClientsDocument, options);
        }
export type ClientsQueryHookResult = ReturnType<typeof useClientsQuery>;
export type ClientsLazyQueryHookResult = ReturnType<typeof useClientsLazyQuery>;
export type ClientsQueryResult = Apollo.QueryResult<ClientsQuery, ClientsQueryVariables>;
export const CustomColumnsDocument = gql`
    query CustomColumns($filter: CustomColumnFilters!) {
  customColumns(filter: $filter) {
    columnId
    columnName
    cruxyId
    tableId
  }
}
    `;

/**
 * __useCustomColumnsQuery__
 *
 * To run a query within a React component, call `useCustomColumnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomColumnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomColumnsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCustomColumnsQuery(baseOptions: Apollo.QueryHookOptions<CustomColumnsQuery, CustomColumnsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomColumnsQuery, CustomColumnsQueryVariables>(CustomColumnsDocument, options);
      }
export function useCustomColumnsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomColumnsQuery, CustomColumnsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomColumnsQuery, CustomColumnsQueryVariables>(CustomColumnsDocument, options);
        }
export type CustomColumnsQueryHookResult = ReturnType<typeof useCustomColumnsQuery>;
export type CustomColumnsLazyQueryHookResult = ReturnType<typeof useCustomColumnsLazyQuery>;
export type CustomColumnsQueryResult = Apollo.QueryResult<CustomColumnsQuery, CustomColumnsQueryVariables>;
export const CompaniesDocument = gql`
    query Companies($limit: Int, $offset: Int, $filter: CompaniesFilter!) {
  companies(limit: $limit, offset: $offset, filter: $filter) {
    totalCount
    edges {
      id
      name
      parentCompanyId
      type
      cruxyId
      createdById
      createDate
      country
      annualRevenue
      industry
      customProperties
    }
  }
}
    `;

/**
 * __useCompaniesQuery__
 *
 * To run a query within a React component, call `useCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompaniesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCompaniesQuery(baseOptions: Apollo.QueryHookOptions<CompaniesQuery, CompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompaniesQuery, CompaniesQueryVariables>(CompaniesDocument, options);
      }
export function useCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompaniesQuery, CompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompaniesQuery, CompaniesQueryVariables>(CompaniesDocument, options);
        }
export type CompaniesQueryHookResult = ReturnType<typeof useCompaniesQuery>;
export type CompaniesLazyQueryHookResult = ReturnType<typeof useCompaniesLazyQuery>;
export type CompaniesQueryResult = Apollo.QueryResult<CompaniesQuery, CompaniesQueryVariables>;
export const ConversionRatesDocument = gql`
    query ConversionRates($pipelineId: String!) {
  conversionRates(pipelineId: $pipelineId) {
    conversionRate
    numberOfDeals
    stageId
    instanceId
  }
}
    `;

/**
 * __useConversionRatesQuery__
 *
 * To run a query within a React component, call `useConversionRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useConversionRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConversionRatesQuery({
 *   variables: {
 *      pipelineId: // value for 'pipelineId'
 *   },
 * });
 */
export function useConversionRatesQuery(baseOptions: Apollo.QueryHookOptions<ConversionRatesQuery, ConversionRatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConversionRatesQuery, ConversionRatesQueryVariables>(ConversionRatesDocument, options);
      }
export function useConversionRatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConversionRatesQuery, ConversionRatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConversionRatesQuery, ConversionRatesQueryVariables>(ConversionRatesDocument, options);
        }
export type ConversionRatesQueryHookResult = ReturnType<typeof useConversionRatesQuery>;
export type ConversionRatesLazyQueryHookResult = ReturnType<typeof useConversionRatesLazyQuery>;
export type ConversionRatesQueryResult = Apollo.QueryResult<ConversionRatesQuery, ConversionRatesQueryVariables>;
export const CrmColumnsDocument = gql`
    query CrmColumns($crmColumnsId: String!) {
  crmColumns(id: $crmColumnsId)
}
    `;

/**
 * __useCrmColumnsQuery__
 *
 * To run a query within a React component, call `useCrmColumnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrmColumnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrmColumnsQuery({
 *   variables: {
 *      crmColumnsId: // value for 'crmColumnsId'
 *   },
 * });
 */
export function useCrmColumnsQuery(baseOptions: Apollo.QueryHookOptions<CrmColumnsQuery, CrmColumnsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CrmColumnsQuery, CrmColumnsQueryVariables>(CrmColumnsDocument, options);
      }
export function useCrmColumnsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrmColumnsQuery, CrmColumnsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CrmColumnsQuery, CrmColumnsQueryVariables>(CrmColumnsDocument, options);
        }
export type CrmColumnsQueryHookResult = ReturnType<typeof useCrmColumnsQuery>;
export type CrmColumnsLazyQueryHookResult = ReturnType<typeof useCrmColumnsLazyQuery>;
export type CrmColumnsQueryResult = Apollo.QueryResult<CrmColumnsQuery, CrmColumnsQueryVariables>;
export const CrmPipelinesDocument = gql`
    query CrmPipelines($cruxyId: String!) {
  crmPipelines(cruxyId: $cruxyId) {
    id
    name
    displayOrder
  }
}
    `;

/**
 * __useCrmPipelinesQuery__
 *
 * To run a query within a React component, call `useCrmPipelinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrmPipelinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrmPipelinesQuery({
 *   variables: {
 *      cruxyId: // value for 'cruxyId'
 *   },
 * });
 */
export function useCrmPipelinesQuery(baseOptions: Apollo.QueryHookOptions<CrmPipelinesQuery, CrmPipelinesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CrmPipelinesQuery, CrmPipelinesQueryVariables>(CrmPipelinesDocument, options);
      }
export function useCrmPipelinesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrmPipelinesQuery, CrmPipelinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CrmPipelinesQuery, CrmPipelinesQueryVariables>(CrmPipelinesDocument, options);
        }
export type CrmPipelinesQueryHookResult = ReturnType<typeof useCrmPipelinesQuery>;
export type CrmPipelinesLazyQueryHookResult = ReturnType<typeof useCrmPipelinesLazyQuery>;
export type CrmPipelinesQueryResult = Apollo.QueryResult<CrmPipelinesQuery, CrmPipelinesQueryVariables>;
export const CubesDocument = gql`
    query Cubes($filter: CubesFilter) {
  cubes(filter: $filter) {
    cubeId
    name
  }
}
    `;

/**
 * __useCubesQuery__
 *
 * To run a query within a React component, call `useCubesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCubesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCubesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCubesQuery(baseOptions?: Apollo.QueryHookOptions<CubesQuery, CubesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CubesQuery, CubesQueryVariables>(CubesDocument, options);
      }
export function useCubesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CubesQuery, CubesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CubesQuery, CubesQueryVariables>(CubesDocument, options);
        }
export type CubesQueryHookResult = ReturnType<typeof useCubesQuery>;
export type CubesLazyQueryHookResult = ReturnType<typeof useCubesLazyQuery>;
export type CubesQueryResult = Apollo.QueryResult<CubesQuery, CubesQueryVariables>;
export const CurrentCubeDocument = gql`
    query CurrentCube {
  currentCube {
    cubeId
    name
  }
}
    `;

/**
 * __useCurrentCubeQuery__
 *
 * To run a query within a React component, call `useCurrentCubeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentCubeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentCubeQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentCubeQuery(baseOptions?: Apollo.QueryHookOptions<CurrentCubeQuery, CurrentCubeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentCubeQuery, CurrentCubeQueryVariables>(CurrentCubeDocument, options);
      }
export function useCurrentCubeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentCubeQuery, CurrentCubeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentCubeQuery, CurrentCubeQueryVariables>(CurrentCubeDocument, options);
        }
export type CurrentCubeQueryHookResult = ReturnType<typeof useCurrentCubeQuery>;
export type CurrentCubeLazyQueryHookResult = ReturnType<typeof useCurrentCubeLazyQuery>;
export type CurrentCubeQueryResult = Apollo.QueryResult<CurrentCubeQuery, CurrentCubeQueryVariables>;
export const DealsDocument = gql`
    query Deals($filter: DealsFilter!, $limit: Int, $offset: Int) {
  deals(filter: $filter, limit: $limit, offset: $offset) {
    totalCount
    edges {
      id
      dealName
      dealStage
      createDate
      closeDate
      dealOwnerId
      amount
      analyticsLatestSource
      associatedCompany {
        id
        name
        createDate
        createdById
        country
      }
      pipeline
      associatedContact {
        id
        firstName
        lastName
      }
      fiscalYear
      type
      dealCurrencyCode
      createdById
      arr
      amountInHomeCurrency
      acv
      customProperties
    }
  }
}
    `;

/**
 * __useDealsQuery__
 *
 * To run a query within a React component, call `useDealsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDealsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDealsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useDealsQuery(baseOptions: Apollo.QueryHookOptions<DealsQuery, DealsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DealsQuery, DealsQueryVariables>(DealsDocument, options);
      }
export function useDealsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DealsQuery, DealsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DealsQuery, DealsQueryVariables>(DealsDocument, options);
        }
export type DealsQueryHookResult = ReturnType<typeof useDealsQuery>;
export type DealsLazyQueryHookResult = ReturnType<typeof useDealsLazyQuery>;
export type DealsQueryResult = Apollo.QueryResult<DealsQuery, DealsQueryVariables>;
export const ExpectationDocument = gql`
    query Expectation($cruxyId: String!, $pipelineId: String!) {
  expectations(cruxyId: $cruxyId, pipelineId: $pipelineId) {
    amount
    amountConverted
    cruxyId
    dateOfCalculation
    dateOfProjection
    instanceName
    minimumStage
    numberOfDeals
    numberOfDealsConverted
    pipelineId
  }
}
    `;

/**
 * __useExpectationQuery__
 *
 * To run a query within a React component, call `useExpectationQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpectationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpectationQuery({
 *   variables: {
 *      cruxyId: // value for 'cruxyId'
 *      pipelineId: // value for 'pipelineId'
 *   },
 * });
 */
export function useExpectationQuery(baseOptions: Apollo.QueryHookOptions<ExpectationQuery, ExpectationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExpectationQuery, ExpectationQueryVariables>(ExpectationDocument, options);
      }
export function useExpectationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpectationQuery, ExpectationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExpectationQuery, ExpectationQueryVariables>(ExpectationDocument, options);
        }
export type ExpectationQueryHookResult = ReturnType<typeof useExpectationQuery>;
export type ExpectationLazyQueryHookResult = ReturnType<typeof useExpectationLazyQuery>;
export type ExpectationQueryResult = Apollo.QueryResult<ExpectationQuery, ExpectationQueryVariables>;
export const FormulasDocument = gql`
    query Formulas($columnId: String!) {
  formulas(columnId: $columnId) {
    id
    columnId
    conditionFormula
    valueFormula
  }
}
    `;

/**
 * __useFormulasQuery__
 *
 * To run a query within a React component, call `useFormulasQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormulasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormulasQuery({
 *   variables: {
 *      columnId: // value for 'columnId'
 *   },
 * });
 */
export function useFormulasQuery(baseOptions: Apollo.QueryHookOptions<FormulasQuery, FormulasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormulasQuery, FormulasQueryVariables>(FormulasDocument, options);
      }
export function useFormulasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormulasQuery, FormulasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormulasQuery, FormulasQueryVariables>(FormulasDocument, options);
        }
export type FormulasQueryHookResult = ReturnType<typeof useFormulasQuery>;
export type FormulasLazyQueryHookResult = ReturnType<typeof useFormulasLazyQuery>;
export type FormulasQueryResult = Apollo.QueryResult<FormulasQuery, FormulasQueryVariables>;
export const GetAllHeadroomProjectsDocument = gql`
    query GetAllHeadroomProjects($cubeId: String!, $limit: Int!, $offset: Int!) {
  getAllHeadroomProjects(cubeId: $cubeId, limit: $limit, offset: $offset) {
    edges {
      name
    }
    totalCount
    hasNextPage
    hasPreviousPage
  }
}
    `;

/**
 * __useGetAllHeadroomProjectsQuery__
 *
 * To run a query within a React component, call `useGetAllHeadroomProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllHeadroomProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllHeadroomProjectsQuery({
 *   variables: {
 *      cubeId: // value for 'cubeId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetAllHeadroomProjectsQuery(baseOptions: Apollo.QueryHookOptions<GetAllHeadroomProjectsQuery, GetAllHeadroomProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllHeadroomProjectsQuery, GetAllHeadroomProjectsQueryVariables>(GetAllHeadroomProjectsDocument, options);
      }
export function useGetAllHeadroomProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllHeadroomProjectsQuery, GetAllHeadroomProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllHeadroomProjectsQuery, GetAllHeadroomProjectsQueryVariables>(GetAllHeadroomProjectsDocument, options);
        }
export type GetAllHeadroomProjectsQueryHookResult = ReturnType<typeof useGetAllHeadroomProjectsQuery>;
export type GetAllHeadroomProjectsLazyQueryHookResult = ReturnType<typeof useGetAllHeadroomProjectsLazyQuery>;
export type GetAllHeadroomProjectsQueryResult = Apollo.QueryResult<GetAllHeadroomProjectsQuery, GetAllHeadroomProjectsQueryVariables>;
export const DataFromTablesByDatasetIdDocument = gql`
    query DataFromTablesByDatasetId($cubeName: String!, $datasetId: String!, $includeAlreadyMerged: Boolean!) {
  dataFromTablesByDatasetId(
    cubeName: $cubeName
    datasetId: $datasetId
    includeAlreadyMerged: $includeAlreadyMerged
  ) {
    uniqueFilenames
    columnNames
  }
}
    `;

/**
 * __useDataFromTablesByDatasetIdQuery__
 *
 * To run a query within a React component, call `useDataFromTablesByDatasetIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataFromTablesByDatasetIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataFromTablesByDatasetIdQuery({
 *   variables: {
 *      cubeName: // value for 'cubeName'
 *      datasetId: // value for 'datasetId'
 *      includeAlreadyMerged: // value for 'includeAlreadyMerged'
 *   },
 * });
 */
export function useDataFromTablesByDatasetIdQuery(baseOptions: Apollo.QueryHookOptions<DataFromTablesByDatasetIdQuery, DataFromTablesByDatasetIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataFromTablesByDatasetIdQuery, DataFromTablesByDatasetIdQueryVariables>(DataFromTablesByDatasetIdDocument, options);
      }
export function useDataFromTablesByDatasetIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataFromTablesByDatasetIdQuery, DataFromTablesByDatasetIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataFromTablesByDatasetIdQuery, DataFromTablesByDatasetIdQueryVariables>(DataFromTablesByDatasetIdDocument, options);
        }
export type DataFromTablesByDatasetIdQueryHookResult = ReturnType<typeof useDataFromTablesByDatasetIdQuery>;
export type DataFromTablesByDatasetIdLazyQueryHookResult = ReturnType<typeof useDataFromTablesByDatasetIdLazyQuery>;
export type DataFromTablesByDatasetIdQueryResult = Apollo.QueryResult<DataFromTablesByDatasetIdQuery, DataFromTablesByDatasetIdQueryVariables>;
export const DatasetsByCubeIdDocument = gql`
    query DatasetsByCubeId($cubeId: String!, $includeAlreadyMerged: Boolean!) {
  datasetsByCubeId(cubeId: $cubeId, includeAlreadyMerged: $includeAlreadyMerged) {
    id
    name
    cubeId
  }
}
    `;

/**
 * __useDatasetsByCubeIdQuery__
 *
 * To run a query within a React component, call `useDatasetsByCubeIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useDatasetsByCubeIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDatasetsByCubeIdQuery({
 *   variables: {
 *      cubeId: // value for 'cubeId'
 *      includeAlreadyMerged: // value for 'includeAlreadyMerged'
 *   },
 * });
 */
export function useDatasetsByCubeIdQuery(baseOptions: Apollo.QueryHookOptions<DatasetsByCubeIdQuery, DatasetsByCubeIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DatasetsByCubeIdQuery, DatasetsByCubeIdQueryVariables>(DatasetsByCubeIdDocument, options);
      }
export function useDatasetsByCubeIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DatasetsByCubeIdQuery, DatasetsByCubeIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DatasetsByCubeIdQuery, DatasetsByCubeIdQueryVariables>(DatasetsByCubeIdDocument, options);
        }
export type DatasetsByCubeIdQueryHookResult = ReturnType<typeof useDatasetsByCubeIdQuery>;
export type DatasetsByCubeIdLazyQueryHookResult = ReturnType<typeof useDatasetsByCubeIdLazyQuery>;
export type DatasetsByCubeIdQueryResult = Apollo.QueryResult<DatasetsByCubeIdQuery, DatasetsByCubeIdQueryVariables>;
export const GetHeadroomFinalResultsDocument = gql`
    query GetHeadroomFinalResults($projectName: String!, $tableName: String!, $segmentGroups: [SegmentGroupInput!]!, $customerColumn: String!, $driverDenominatorColumn: String!, $driverMode: DriverMode!, $driverNumeratorColumn: String, $increasedPenetration: Float, $limit: Int, $offset: Int) {
  getHeadroomFinalResults(
    projectName: $projectName
    tableName: $tableName
    segmentGroups: $segmentGroups
    customerColumn: $customerColumn
    driverDenominatorColumn: $driverDenominatorColumn
    driverMode: $driverMode
    driverNumeratorColumn: $driverNumeratorColumn
    increasedPenetration: $increasedPenetration
    limit: $limit
    offset: $offset
  ) {
    edges {
      segment
      segmentValue
      segmentRange
      totalCustomers
      totalProspects
      penetration
      driverInitial
      driverFinal
      headroom
      increasedPenetration
      totalCustomersAfter
      totalDriverInitial
      totalDriverFinal
      totalHeadroom
      headroomPercent
      FxUniqueRowUuid
    }
    totalCount
    hasNextPage
    hasPreviousPage
    totals {
      totalCustomers
      totalProspects
      driverInitial
      driverFinal
      headroom
      totalCustomersAfter
      totalDriverInitial
      totalDriverFinal
      totalHeadroom
      penetration
      headroomPercent
      increasedPenetration
    }
  }
}
    `;

/**
 * __useGetHeadroomFinalResultsQuery__
 *
 * To run a query within a React component, call `useGetHeadroomFinalResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHeadroomFinalResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHeadroomFinalResultsQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      tableName: // value for 'tableName'
 *      segmentGroups: // value for 'segmentGroups'
 *      customerColumn: // value for 'customerColumn'
 *      driverDenominatorColumn: // value for 'driverDenominatorColumn'
 *      driverMode: // value for 'driverMode'
 *      driverNumeratorColumn: // value for 'driverNumeratorColumn'
 *      increasedPenetration: // value for 'increasedPenetration'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetHeadroomFinalResultsQuery(baseOptions: Apollo.QueryHookOptions<GetHeadroomFinalResultsQuery, GetHeadroomFinalResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHeadroomFinalResultsQuery, GetHeadroomFinalResultsQueryVariables>(GetHeadroomFinalResultsDocument, options);
      }
export function useGetHeadroomFinalResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHeadroomFinalResultsQuery, GetHeadroomFinalResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHeadroomFinalResultsQuery, GetHeadroomFinalResultsQueryVariables>(GetHeadroomFinalResultsDocument, options);
        }
export type GetHeadroomFinalResultsQueryHookResult = ReturnType<typeof useGetHeadroomFinalResultsQuery>;
export type GetHeadroomFinalResultsLazyQueryHookResult = ReturnType<typeof useGetHeadroomFinalResultsLazyQuery>;
export type GetHeadroomFinalResultsQueryResult = Apollo.QueryResult<GetHeadroomFinalResultsQuery, GetHeadroomFinalResultsQueryVariables>;
export const GetHeadroomProjectByNameDocument = gql`
    query GetHeadroomProjectByName($projectName: String!, $cubeId: String!) {
  getHeadroomProjectByName(projectName: $projectName, cubeId: $cubeId) {
    projectName
    tableName
    segmentGroups {
      index
      type
      method
      segments {
        id
        minValue
        maxValue
      }
      rangeColumn
    }
    driver1Type
    driver2Type
    driver1NumeratorType
    driver2NumeratorType
    driver1Mode
    driver2Mode
    count1Column
    count2Column
    customerColumn
    driver1Percentile
    driver2Percentile
    headroomDriver
    headroomPercentile
    cubeId
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetHeadroomProjectByNameQuery__
 *
 * To run a query within a React component, call `useGetHeadroomProjectByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHeadroomProjectByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHeadroomProjectByNameQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      cubeId: // value for 'cubeId'
 *   },
 * });
 */
export function useGetHeadroomProjectByNameQuery(baseOptions: Apollo.QueryHookOptions<GetHeadroomProjectByNameQuery, GetHeadroomProjectByNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHeadroomProjectByNameQuery, GetHeadroomProjectByNameQueryVariables>(GetHeadroomProjectByNameDocument, options);
      }
export function useGetHeadroomProjectByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHeadroomProjectByNameQuery, GetHeadroomProjectByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHeadroomProjectByNameQuery, GetHeadroomProjectByNameQueryVariables>(GetHeadroomProjectByNameDocument, options);
        }
export type GetHeadroomProjectByNameQueryHookResult = ReturnType<typeof useGetHeadroomProjectByNameQuery>;
export type GetHeadroomProjectByNameLazyQueryHookResult = ReturnType<typeof useGetHeadroomProjectByNameLazyQuery>;
export type GetHeadroomProjectByNameQueryResult = Apollo.QueryResult<GetHeadroomProjectByNameQuery, GetHeadroomProjectByNameQueryVariables>;
export const SegmentedDataDocument = gql`
    query SegmentedData($tableName: String!, $segmentGroups: [SegmentGroupInput!]!, $count1Column: String!, $count2Column: String, $driver1DenominatorColumn: String!, $driver1Mode: DriverMode!, $driver2DenominatorColumn: String!, $driver2Mode: DriverMode!, $driver1NumeratorColumn: String, $driver2NumeratorColumn: String, $limit: Int, $offset: Int) {
  segmentedData(
    tableName: $tableName
    segmentGroups: $segmentGroups
    count1Column: $count1Column
    count2Column: $count2Column
    driver1DenominatorColumn: $driver1DenominatorColumn
    driver1Mode: $driver1Mode
    driver2DenominatorColumn: $driver2DenominatorColumn
    driver2Mode: $driver2Mode
    driver1NumeratorColumn: $driver1NumeratorColumn
    driver2NumeratorColumn: $driver2NumeratorColumn
    limit: $limit
    offset: $offset
  ) {
    edges {
      segment
      segmentValue
      segmentRange
      count1
      count2
      driver1Metrics {
        min
        percentile25
        percentile50
        percentile75
        max
      }
      driver2Metrics {
        min
        percentile25
        percentile50
        percentile75
        max
      }
      total
      numerator
      FxUniqueRowUuid
    }
    totalCount
    hasNextPage
    hasPreviousPage
  }
}
    `;

/**
 * __useSegmentedDataQuery__
 *
 * To run a query within a React component, call `useSegmentedDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useSegmentedDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSegmentedDataQuery({
 *   variables: {
 *      tableName: // value for 'tableName'
 *      segmentGroups: // value for 'segmentGroups'
 *      count1Column: // value for 'count1Column'
 *      count2Column: // value for 'count2Column'
 *      driver1DenominatorColumn: // value for 'driver1DenominatorColumn'
 *      driver1Mode: // value for 'driver1Mode'
 *      driver2DenominatorColumn: // value for 'driver2DenominatorColumn'
 *      driver2Mode: // value for 'driver2Mode'
 *      driver1NumeratorColumn: // value for 'driver1NumeratorColumn'
 *      driver2NumeratorColumn: // value for 'driver2NumeratorColumn'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useSegmentedDataQuery(baseOptions: Apollo.QueryHookOptions<SegmentedDataQuery, SegmentedDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SegmentedDataQuery, SegmentedDataQueryVariables>(SegmentedDataDocument, options);
      }
export function useSegmentedDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SegmentedDataQuery, SegmentedDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SegmentedDataQuery, SegmentedDataQueryVariables>(SegmentedDataDocument, options);
        }
export type SegmentedDataQueryHookResult = ReturnType<typeof useSegmentedDataQuery>;
export type SegmentedDataLazyQueryHookResult = ReturnType<typeof useSegmentedDataLazyQuery>;
export type SegmentedDataQueryResult = Apollo.QueryResult<SegmentedDataQuery, SegmentedDataQueryVariables>;
export const SegmentedDriverMetricsDocument = gql`
    query SegmentedDriverMetrics($tableName: String!, $segmentGroups: [SegmentGroupInput!]!, $customerColumn: String!, $driver1NumeratorColumn: String, $driver1DenominatorColumn: String, $driver1Mode: DriverMode, $driver1Percentile: Int, $driver2NumeratorColumn: String, $driver2DenominatorColumn: String, $driver2Mode: DriverMode, $driver2Percentile: Int, $limit: Int, $offset: Int) {
  segmentedDriverMetrics(
    tableName: $tableName
    segmentGroups: $segmentGroups
    customerColumn: $customerColumn
    driver1NumeratorColumn: $driver1NumeratorColumn
    driver1DenominatorColumn: $driver1DenominatorColumn
    driver1Mode: $driver1Mode
    driver1Percentile: $driver1Percentile
    driver2NumeratorColumn: $driver2NumeratorColumn
    driver2DenominatorColumn: $driver2DenominatorColumn
    driver2Mode: $driver2Mode
    driver2Percentile: $driver2Percentile
    limit: $limit
    offset: $offset
  ) {
    edges {
      segment
      segmentValue
      segmentRange
      rangeLower
      rangeUpper
      driver1Median
      driver1Avg
      driver1Percentile
      driver1Denominator
      driver2Median
      driver2Avg
      driver2Percentile
      driver2Denominator
      FxUniqueRowUuid
    }
    totalCount
    hasNextPage
    hasPreviousPage
  }
}
    `;

/**
 * __useSegmentedDriverMetricsQuery__
 *
 * To run a query within a React component, call `useSegmentedDriverMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSegmentedDriverMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSegmentedDriverMetricsQuery({
 *   variables: {
 *      tableName: // value for 'tableName'
 *      segmentGroups: // value for 'segmentGroups'
 *      customerColumn: // value for 'customerColumn'
 *      driver1NumeratorColumn: // value for 'driver1NumeratorColumn'
 *      driver1DenominatorColumn: // value for 'driver1DenominatorColumn'
 *      driver1Mode: // value for 'driver1Mode'
 *      driver1Percentile: // value for 'driver1Percentile'
 *      driver2NumeratorColumn: // value for 'driver2NumeratorColumn'
 *      driver2DenominatorColumn: // value for 'driver2DenominatorColumn'
 *      driver2Mode: // value for 'driver2Mode'
 *      driver2Percentile: // value for 'driver2Percentile'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useSegmentedDriverMetricsQuery(baseOptions: Apollo.QueryHookOptions<SegmentedDriverMetricsQuery, SegmentedDriverMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SegmentedDriverMetricsQuery, SegmentedDriverMetricsQueryVariables>(SegmentedDriverMetricsDocument, options);
      }
export function useSegmentedDriverMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SegmentedDriverMetricsQuery, SegmentedDriverMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SegmentedDriverMetricsQuery, SegmentedDriverMetricsQueryVariables>(SegmentedDriverMetricsDocument, options);
        }
export type SegmentedDriverMetricsQueryHookResult = ReturnType<typeof useSegmentedDriverMetricsQuery>;
export type SegmentedDriverMetricsLazyQueryHookResult = ReturnType<typeof useSegmentedDriverMetricsLazyQuery>;
export type SegmentedDriverMetricsQueryResult = Apollo.QueryResult<SegmentedDriverMetricsQuery, SegmentedDriverMetricsQueryVariables>;
export const ProcessedDataTableHeadersDocument = gql`
    query processedDataTableHeaders($tableName: String!) {
  processedDataTableHeaders(tableName: $tableName) {
    columns {
      name
      isNumeric
      min
      max
    }
  }
}
    `;

/**
 * __useProcessedDataTableHeadersQuery__
 *
 * To run a query within a React component, call `useProcessedDataTableHeadersQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessedDataTableHeadersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessedDataTableHeadersQuery({
 *   variables: {
 *      tableName: // value for 'tableName'
 *   },
 * });
 */
export function useProcessedDataTableHeadersQuery(baseOptions: Apollo.QueryHookOptions<ProcessedDataTableHeadersQuery, ProcessedDataTableHeadersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessedDataTableHeadersQuery, ProcessedDataTableHeadersQueryVariables>(ProcessedDataTableHeadersDocument, options);
      }
export function useProcessedDataTableHeadersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessedDataTableHeadersQuery, ProcessedDataTableHeadersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessedDataTableHeadersQuery, ProcessedDataTableHeadersQueryVariables>(ProcessedDataTableHeadersDocument, options);
        }
export type ProcessedDataTableHeadersQueryHookResult = ReturnType<typeof useProcessedDataTableHeadersQuery>;
export type ProcessedDataTableHeadersLazyQueryHookResult = ReturnType<typeof useProcessedDataTableHeadersLazyQuery>;
export type ProcessedDataTableHeadersQueryResult = Apollo.QueryResult<ProcessedDataTableHeadersQuery, ProcessedDataTableHeadersQueryVariables>;
export const InvoiceLogDatesDocument = gql`
    query InvoiceLogDates($cruxyId: String!) {
  invoiceLogDates(cruxyId: $cruxyId)
}
    `;

/**
 * __useInvoiceLogDatesQuery__
 *
 * To run a query within a React component, call `useInvoiceLogDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceLogDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceLogDatesQuery({
 *   variables: {
 *      cruxyId: // value for 'cruxyId'
 *   },
 * });
 */
export function useInvoiceLogDatesQuery(baseOptions: Apollo.QueryHookOptions<InvoiceLogDatesQuery, InvoiceLogDatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoiceLogDatesQuery, InvoiceLogDatesQueryVariables>(InvoiceLogDatesDocument, options);
      }
export function useInvoiceLogDatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceLogDatesQuery, InvoiceLogDatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoiceLogDatesQuery, InvoiceLogDatesQueryVariables>(InvoiceLogDatesDocument, options);
        }
export type InvoiceLogDatesQueryHookResult = ReturnType<typeof useInvoiceLogDatesQuery>;
export type InvoiceLogDatesLazyQueryHookResult = ReturnType<typeof useInvoiceLogDatesLazyQuery>;
export type InvoiceLogDatesQueryResult = Apollo.QueryResult<InvoiceLogDatesQuery, InvoiceLogDatesQueryVariables>;
export const InvoiceLogsDocument = gql`
    query InvoiceLogs($cruxyId: String!, $date: String!) {
  invoiceLogs(cruxyId: $cruxyId, date: $date) {
    cruxyId
    companies {
      invoiceName
      matchName
      matchId
      changes {
        name {
          from
          to
        }
        country {
          from
          to
        }
        industry {
          from
          to
        }
      }
      numberOfDealsHidden
      idsOfDealsHidden
      newDealID
      insertedNow
    }
  }
}
    `;

/**
 * __useInvoiceLogsQuery__
 *
 * To run a query within a React component, call `useInvoiceLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceLogsQuery({
 *   variables: {
 *      cruxyId: // value for 'cruxyId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useInvoiceLogsQuery(baseOptions: Apollo.QueryHookOptions<InvoiceLogsQuery, InvoiceLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoiceLogsQuery, InvoiceLogsQueryVariables>(InvoiceLogsDocument, options);
      }
export function useInvoiceLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceLogsQuery, InvoiceLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoiceLogsQuery, InvoiceLogsQueryVariables>(InvoiceLogsDocument, options);
        }
export type InvoiceLogsQueryHookResult = ReturnType<typeof useInvoiceLogsQuery>;
export type InvoiceLogsLazyQueryHookResult = ReturnType<typeof useInvoiceLogsLazyQuery>;
export type InvoiceLogsQueryResult = Apollo.QueryResult<InvoiceLogsQuery, InvoiceLogsQueryVariables>;
export const InvoicesDocument = gql`
    query Invoices($filter: InvoicesFilter!, $limit: Int, $offset: Int) {
  invoices(filter: $filter, limit: $limit, offset: $offset) {
    totalCount
    edges {
      invoiceNumber
      accountName
      accountLegalName
      accountStatus
      accountId
      check
      annualisedConverted
      annualisedValue
      contractType
      creditGbp
      cruxyId
      currency
      currentMonth
      date
      debitGbp
      description
      endDate
      exchangeRate
      id
      industry
      industryPrimarySegment
      industrySubsegment
      invoiceLengthMonths
      keyStakeholderTitleOrPosition
      mrr
      productSold
      reference
      salesLastYear
      sourceOfInvoiceData
      startDate
      country
    }
  }
}
    `;

/**
 * __useInvoicesQuery__
 *
 * To run a query within a React component, call `useInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useInvoicesQuery(baseOptions: Apollo.QueryHookOptions<InvoicesQuery, InvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoicesQuery, InvoicesQueryVariables>(InvoicesDocument, options);
      }
export function useInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoicesQuery, InvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoicesQuery, InvoicesQueryVariables>(InvoicesDocument, options);
        }
export type InvoicesQueryHookResult = ReturnType<typeof useInvoicesQuery>;
export type InvoicesLazyQueryHookResult = ReturnType<typeof useInvoicesLazyQuery>;
export type InvoicesQueryResult = Apollo.QueryResult<InvoicesQuery, InvoicesQueryVariables>;
export const GetApplyInvoicesPlanDocument = gql`
    query GetApplyInvoicesPlan($cruxyId: String!) {
  getApplyInvoicesPlan(cruxyId: $cruxyId) {
    cruxyId
    companies {
      invoiceName
      matchName
      matchId
      changes {
        name {
          from
          to
        }
        country {
          from
          to
        }
        industry {
          from
          to
        }
      }
      idsOfDealsHidden
      numberOfDealsHidden
      newDealID
      insertedNow
    }
  }
}
    `;

/**
 * __useGetApplyInvoicesPlanQuery__
 *
 * To run a query within a React component, call `useGetApplyInvoicesPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApplyInvoicesPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApplyInvoicesPlanQuery({
 *   variables: {
 *      cruxyId: // value for 'cruxyId'
 *   },
 * });
 */
export function useGetApplyInvoicesPlanQuery(baseOptions: Apollo.QueryHookOptions<GetApplyInvoicesPlanQuery, GetApplyInvoicesPlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApplyInvoicesPlanQuery, GetApplyInvoicesPlanQueryVariables>(GetApplyInvoicesPlanDocument, options);
      }
export function useGetApplyInvoicesPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApplyInvoicesPlanQuery, GetApplyInvoicesPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApplyInvoicesPlanQuery, GetApplyInvoicesPlanQueryVariables>(GetApplyInvoicesPlanDocument, options);
        }
export type GetApplyInvoicesPlanQueryHookResult = ReturnType<typeof useGetApplyInvoicesPlanQuery>;
export type GetApplyInvoicesPlanLazyQueryHookResult = ReturnType<typeof useGetApplyInvoicesPlanLazyQuery>;
export type GetApplyInvoicesPlanQueryResult = Apollo.QueryResult<GetApplyInvoicesPlanQuery, GetApplyInvoicesPlanQueryVariables>;
export const UserDocument = gql`
    query User {
  me {
    cruxyId
    id
    role
    azure_sas_token
  }
}
    `;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserQuery(baseOptions?: Apollo.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const MyViewsDocument = gql`
    query MyViews($cubeId: String!, $limit: Int, $offset: Int) {
  myViews(cubeId: $cubeId, limit: $limit, offset: $offset) {
    edges
    totalCount
    hasNextPage
    hasPreviousPage
  }
}
    `;

/**
 * __useMyViewsQuery__
 *
 * To run a query within a React component, call `useMyViewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyViewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyViewsQuery({
 *   variables: {
 *      cubeId: // value for 'cubeId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useMyViewsQuery(baseOptions: Apollo.QueryHookOptions<MyViewsQuery, MyViewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyViewsQuery, MyViewsQueryVariables>(MyViewsDocument, options);
      }
export function useMyViewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyViewsQuery, MyViewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyViewsQuery, MyViewsQueryVariables>(MyViewsDocument, options);
        }
export type MyViewsQueryHookResult = ReturnType<typeof useMyViewsQuery>;
export type MyViewsLazyQueryHookResult = ReturnType<typeof useMyViewsLazyQuery>;
export type MyViewsQueryResult = Apollo.QueryResult<MyViewsQuery, MyViewsQueryVariables>;
export const OperatorsDocument = gql`
    query Operators {
  operators {
    symbol
    text
  }
}
    `;

/**
 * __useOperatorsQuery__
 *
 * To run a query within a React component, call `useOperatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOperatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOperatorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOperatorsQuery(baseOptions?: Apollo.QueryHookOptions<OperatorsQuery, OperatorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OperatorsQuery, OperatorsQueryVariables>(OperatorsDocument, options);
      }
export function useOperatorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OperatorsQuery, OperatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OperatorsQuery, OperatorsQueryVariables>(OperatorsDocument, options);
        }
export type OperatorsQueryHookResult = ReturnType<typeof useOperatorsQuery>;
export type OperatorsLazyQueryHookResult = ReturnType<typeof useOperatorsLazyQuery>;
export type OperatorsQueryResult = Apollo.QueryResult<OperatorsQuery, OperatorsQueryVariables>;
export const PipelinesDocument = gql`
    query Pipelines($cruxyId: String!) {
  pipelines(cruxyId: $cruxyId) {
    id
    name
    data {
      basePipelineId
      columnId
      durations {
        duration
        pipelineInstanceId
        stageId
        conversionRate
        numberOfDeals
      }
      schema {
        pipelineInstances {
          averageAmount
          id
          name
          orderNumber
          numberOfClosedWons
        }
        stages {
          id
          name
          orderNumber
        }
      }
    }
  }
}
    `;

/**
 * __usePipelinesQuery__
 *
 * To run a query within a React component, call `usePipelinesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePipelinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePipelinesQuery({
 *   variables: {
 *      cruxyId: // value for 'cruxyId'
 *   },
 * });
 */
export function usePipelinesQuery(baseOptions: Apollo.QueryHookOptions<PipelinesQuery, PipelinesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PipelinesQuery, PipelinesQueryVariables>(PipelinesDocument, options);
      }
export function usePipelinesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PipelinesQuery, PipelinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PipelinesQuery, PipelinesQueryVariables>(PipelinesDocument, options);
        }
export type PipelinesQueryHookResult = ReturnType<typeof usePipelinesQuery>;
export type PipelinesLazyQueryHookResult = ReturnType<typeof usePipelinesLazyQuery>;
export type PipelinesQueryResult = Apollo.QueryResult<PipelinesQuery, PipelinesQueryVariables>;
export const DatasetPreviewDocument = gql`
    query DatasetPreview($filter: DatasetPreviewFilter) {
  datasetPreview(filter: $filter) {
    dataset
    totalCount
  }
}
    `;

/**
 * __useDatasetPreviewQuery__
 *
 * To run a query within a React component, call `useDatasetPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useDatasetPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDatasetPreviewQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDatasetPreviewQuery(baseOptions?: Apollo.QueryHookOptions<DatasetPreviewQuery, DatasetPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DatasetPreviewQuery, DatasetPreviewQueryVariables>(DatasetPreviewDocument, options);
      }
export function useDatasetPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DatasetPreviewQuery, DatasetPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DatasetPreviewQuery, DatasetPreviewQueryVariables>(DatasetPreviewDocument, options);
        }
export type DatasetPreviewQueryHookResult = ReturnType<typeof useDatasetPreviewQuery>;
export type DatasetPreviewLazyQueryHookResult = ReturnType<typeof useDatasetPreviewLazyQuery>;
export type DatasetPreviewQueryResult = Apollo.QueryResult<DatasetPreviewQuery, DatasetPreviewQueryVariables>;
export const ProcessedDataAndCountPreviewDocument = gql`
    query ProcessedDataAndCountPreview($filter: ProcessedDataPreviewFilter) {
  processedDataAndCountPreview(filter: $filter) {
    data
    totalCount
  }
}
    `;

/**
 * __useProcessedDataAndCountPreviewQuery__
 *
 * To run a query within a React component, call `useProcessedDataAndCountPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessedDataAndCountPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessedDataAndCountPreviewQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useProcessedDataAndCountPreviewQuery(baseOptions?: Apollo.QueryHookOptions<ProcessedDataAndCountPreviewQuery, ProcessedDataAndCountPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessedDataAndCountPreviewQuery, ProcessedDataAndCountPreviewQueryVariables>(ProcessedDataAndCountPreviewDocument, options);
      }
export function useProcessedDataAndCountPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessedDataAndCountPreviewQuery, ProcessedDataAndCountPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessedDataAndCountPreviewQuery, ProcessedDataAndCountPreviewQueryVariables>(ProcessedDataAndCountPreviewDocument, options);
        }
export type ProcessedDataAndCountPreviewQueryHookResult = ReturnType<typeof useProcessedDataAndCountPreviewQuery>;
export type ProcessedDataAndCountPreviewLazyQueryHookResult = ReturnType<typeof useProcessedDataAndCountPreviewLazyQuery>;
export type ProcessedDataAndCountPreviewQueryResult = Apollo.QueryResult<ProcessedDataAndCountPreviewQuery, ProcessedDataAndCountPreviewQueryVariables>;
export const QueryProcessedDataViewsDocument = gql`
    query QueryProcessedDataViews($cubeId: String!, $includeHeadroomData: Boolean, $limit: Int, $offset: Int) {
  queryProcessedDataViews(
    cubeId: $cubeId
    includeHeadroomData: $includeHeadroomData
    limit: $limit
    offset: $offset
  ) {
    edges {
      name
      createdAt
    }
    totalCount
    hasNextPage
    hasPreviousPage
    success
    error
  }
}
    `;

/**
 * __useQueryProcessedDataViewsQuery__
 *
 * To run a query within a React component, call `useQueryProcessedDataViewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryProcessedDataViewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryProcessedDataViewsQuery({
 *   variables: {
 *      cubeId: // value for 'cubeId'
 *      includeHeadroomData: // value for 'includeHeadroomData'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useQueryProcessedDataViewsQuery(baseOptions: Apollo.QueryHookOptions<QueryProcessedDataViewsQuery, QueryProcessedDataViewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryProcessedDataViewsQuery, QueryProcessedDataViewsQueryVariables>(QueryProcessedDataViewsDocument, options);
      }
export function useQueryProcessedDataViewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryProcessedDataViewsQuery, QueryProcessedDataViewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryProcessedDataViewsQuery, QueryProcessedDataViewsQueryVariables>(QueryProcessedDataViewsDocument, options);
        }
export type QueryProcessedDataViewsQueryHookResult = ReturnType<typeof useQueryProcessedDataViewsQuery>;
export type QueryProcessedDataViewsLazyQueryHookResult = ReturnType<typeof useQueryProcessedDataViewsLazyQuery>;
export type QueryProcessedDataViewsQueryResult = Apollo.QueryResult<QueryProcessedDataViewsQuery, QueryProcessedDataViewsQueryVariables>;
export const QueryProcessedViewsDataDocument = gql`
    query QueryProcessedViewsData($cubeId: String!, $filter: ViewDataFilter!, $limit: Int, $offset: Int, $identifier: String, $includeMatched: Boolean) {
  queryProcessedViewsData(
    cubeId: $cubeId
    filter: $filter
    limit: $limit
    offset: $offset
    identifier: $identifier
    includeMatched: $includeMatched
  ) {
    edges
    totalCount
    hasNextPage
    hasPreviousPage
    success
    error
  }
}
    `;

/**
 * __useQueryProcessedViewsDataQuery__
 *
 * To run a query within a React component, call `useQueryProcessedViewsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryProcessedViewsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryProcessedViewsDataQuery({
 *   variables: {
 *      cubeId: // value for 'cubeId'
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      identifier: // value for 'identifier'
 *      includeMatched: // value for 'includeMatched'
 *   },
 * });
 */
export function useQueryProcessedViewsDataQuery(baseOptions: Apollo.QueryHookOptions<QueryProcessedViewsDataQuery, QueryProcessedViewsDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryProcessedViewsDataQuery, QueryProcessedViewsDataQueryVariables>(QueryProcessedViewsDataDocument, options);
      }
export function useQueryProcessedViewsDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryProcessedViewsDataQuery, QueryProcessedViewsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryProcessedViewsDataQuery, QueryProcessedViewsDataQueryVariables>(QueryProcessedViewsDataDocument, options);
        }
export type QueryProcessedViewsDataQueryHookResult = ReturnType<typeof useQueryProcessedViewsDataQuery>;
export type QueryProcessedViewsDataLazyQueryHookResult = ReturnType<typeof useQueryProcessedViewsDataLazyQuery>;
export type QueryProcessedViewsDataQueryResult = Apollo.QueryResult<QueryProcessedViewsDataQuery, QueryProcessedViewsDataQueryVariables>;
export const QueryMatchedViewsPhaseDataDocument = gql`
    query QueryMatchedViewsPhaseData($cubeName: String!, $identifier: String!, $phase: Int!, $viewName: String!, $limit: Int, $offset: Int) {
  queryMatchedViewsPhaseData(
    cubeName: $cubeName
    identifier: $identifier
    phase: $phase
    viewName: $viewName
    limit: $limit
    offset: $offset
  ) {
    edges
    totalCount
    hasNextPage
    hasPreviousPage
    success
    error
  }
}
    `;

/**
 * __useQueryMatchedViewsPhaseDataQuery__
 *
 * To run a query within a React component, call `useQueryMatchedViewsPhaseDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryMatchedViewsPhaseDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryMatchedViewsPhaseDataQuery({
 *   variables: {
 *      cubeName: // value for 'cubeName'
 *      identifier: // value for 'identifier'
 *      phase: // value for 'phase'
 *      viewName: // value for 'viewName'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useQueryMatchedViewsPhaseDataQuery(baseOptions: Apollo.QueryHookOptions<QueryMatchedViewsPhaseDataQuery, QueryMatchedViewsPhaseDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryMatchedViewsPhaseDataQuery, QueryMatchedViewsPhaseDataQueryVariables>(QueryMatchedViewsPhaseDataDocument, options);
      }
export function useQueryMatchedViewsPhaseDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryMatchedViewsPhaseDataQuery, QueryMatchedViewsPhaseDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryMatchedViewsPhaseDataQuery, QueryMatchedViewsPhaseDataQueryVariables>(QueryMatchedViewsPhaseDataDocument, options);
        }
export type QueryMatchedViewsPhaseDataQueryHookResult = ReturnType<typeof useQueryMatchedViewsPhaseDataQuery>;
export type QueryMatchedViewsPhaseDataLazyQueryHookResult = ReturnType<typeof useQueryMatchedViewsPhaseDataLazyQuery>;
export type QueryMatchedViewsPhaseDataQueryResult = Apollo.QueryResult<QueryMatchedViewsPhaseDataQuery, QueryMatchedViewsPhaseDataQueryVariables>;
export const QueryProcessedTableMatcherTableNameDocument = gql`
    query QueryProcessedTableMatcherTableName($tableName: String!) {
  queryProcessedTableMatcherTableName(tableName: $tableName) {
    success
    matcherTable
    identifier
    error
  }
}
    `;

/**
 * __useQueryProcessedTableMatcherTableNameQuery__
 *
 * To run a query within a React component, call `useQueryProcessedTableMatcherTableNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryProcessedTableMatcherTableNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryProcessedTableMatcherTableNameQuery({
 *   variables: {
 *      tableName: // value for 'tableName'
 *   },
 * });
 */
export function useQueryProcessedTableMatcherTableNameQuery(baseOptions: Apollo.QueryHookOptions<QueryProcessedTableMatcherTableNameQuery, QueryProcessedTableMatcherTableNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryProcessedTableMatcherTableNameQuery, QueryProcessedTableMatcherTableNameQueryVariables>(QueryProcessedTableMatcherTableNameDocument, options);
      }
export function useQueryProcessedTableMatcherTableNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryProcessedTableMatcherTableNameQuery, QueryProcessedTableMatcherTableNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryProcessedTableMatcherTableNameQuery, QueryProcessedTableMatcherTableNameQueryVariables>(QueryProcessedTableMatcherTableNameDocument, options);
        }
export type QueryProcessedTableMatcherTableNameQueryHookResult = ReturnType<typeof useQueryProcessedTableMatcherTableNameQuery>;
export type QueryProcessedTableMatcherTableNameLazyQueryHookResult = ReturnType<typeof useQueryProcessedTableMatcherTableNameLazyQuery>;
export type QueryProcessedTableMatcherTableNameQueryResult = Apollo.QueryResult<QueryProcessedTableMatcherTableNameQuery, QueryProcessedTableMatcherTableNameQueryVariables>;
export const RealityDocument = gql`
    query Reality($cruxyId: String!, $pipelineId: String!) {
  reality(cruxyId: $cruxyId, pipelineId: $pipelineId) {
    cruxyId
    pipelineId
    instanceName
    minimumStage
    numberOfDeals
    numberOfDealsConverted
    amount
    amountConverted
    dateOfCalculation
    dateOfProjection
  }
}
    `;

/**
 * __useRealityQuery__
 *
 * To run a query within a React component, call `useRealityQuery` and pass it any options that fit your needs.
 * When your component renders, `useRealityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRealityQuery({
 *   variables: {
 *      cruxyId: // value for 'cruxyId'
 *      pipelineId: // value for 'pipelineId'
 *   },
 * });
 */
export function useRealityQuery(baseOptions: Apollo.QueryHookOptions<RealityQuery, RealityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RealityQuery, RealityQueryVariables>(RealityDocument, options);
      }
export function useRealityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RealityQuery, RealityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RealityQuery, RealityQueryVariables>(RealityDocument, options);
        }
export type RealityQueryHookResult = ReturnType<typeof useRealityQuery>;
export type RealityLazyQueryHookResult = ReturnType<typeof useRealityLazyQuery>;
export type RealityQueryResult = Apollo.QueryResult<RealityQuery, RealityQueryVariables>;
export const RolesDocument = gql`
    query Roles {
  roles
}
    `;

/**
 * __useRolesQuery__
 *
 * To run a query within a React component, call `useRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useRolesQuery(baseOptions?: Apollo.QueryHookOptions<RolesQuery, RolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RolesQuery, RolesQueryVariables>(RolesDocument, options);
      }
export function useRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RolesQuery, RolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RolesQuery, RolesQueryVariables>(RolesDocument, options);
        }
export type RolesQueryHookResult = ReturnType<typeof useRolesQuery>;
export type RolesLazyQueryHookResult = ReturnType<typeof useRolesLazyQuery>;
export type RolesQueryResult = Apollo.QueryResult<RolesQuery, RolesQueryVariables>;
export const GroupedCountsByColumnDocument = gql`
    query GroupedCountsByColumn($input: GroupedCountsInput!) {
  groupedCountsByColumn(input: $input) {
    groupCounts {
      groupValue
      count
    }
  }
}
    `;

/**
 * __useGroupedCountsByColumnQuery__
 *
 * To run a query within a React component, call `useGroupedCountsByColumnQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupedCountsByColumnQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupedCountsByColumnQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGroupedCountsByColumnQuery(baseOptions: Apollo.QueryHookOptions<GroupedCountsByColumnQuery, GroupedCountsByColumnQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupedCountsByColumnQuery, GroupedCountsByColumnQueryVariables>(GroupedCountsByColumnDocument, options);
      }
export function useGroupedCountsByColumnLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupedCountsByColumnQuery, GroupedCountsByColumnQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupedCountsByColumnQuery, GroupedCountsByColumnQueryVariables>(GroupedCountsByColumnDocument, options);
        }
export type GroupedCountsByColumnQueryHookResult = ReturnType<typeof useGroupedCountsByColumnQuery>;
export type GroupedCountsByColumnLazyQueryHookResult = ReturnType<typeof useGroupedCountsByColumnLazyQuery>;
export type GroupedCountsByColumnQueryResult = Apollo.QueryResult<GroupedCountsByColumnQuery, GroupedCountsByColumnQueryVariables>;
export const StagesDocument = gql`
    query Stages($pipelineId: String!) {
  stages(pipelineId: $pipelineId) {
    id
    label
    displayOrder
  }
}
    `;

/**
 * __useStagesQuery__
 *
 * To run a query within a React component, call `useStagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStagesQuery({
 *   variables: {
 *      pipelineId: // value for 'pipelineId'
 *   },
 * });
 */
export function useStagesQuery(baseOptions: Apollo.QueryHookOptions<StagesQuery, StagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StagesQuery, StagesQueryVariables>(StagesDocument, options);
      }
export function useStagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StagesQuery, StagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StagesQuery, StagesQueryVariables>(StagesDocument, options);
        }
export type StagesQueryHookResult = ReturnType<typeof useStagesQuery>;
export type StagesLazyQueryHookResult = ReturnType<typeof useStagesLazyQuery>;
export type StagesQueryResult = Apollo.QueryResult<StagesQuery, StagesQueryVariables>;
export const CrmTablesDocument = gql`
    query CrmTables {
  crmTables {
    id
    name
    path
  }
}
    `;

/**
 * __useCrmTablesQuery__
 *
 * To run a query within a React component, call `useCrmTablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrmTablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrmTablesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCrmTablesQuery(baseOptions?: Apollo.QueryHookOptions<CrmTablesQuery, CrmTablesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CrmTablesQuery, CrmTablesQueryVariables>(CrmTablesDocument, options);
      }
export function useCrmTablesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrmTablesQuery, CrmTablesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CrmTablesQuery, CrmTablesQueryVariables>(CrmTablesDocument, options);
        }
export type CrmTablesQueryHookResult = ReturnType<typeof useCrmTablesQuery>;
export type CrmTablesLazyQueryHookResult = ReturnType<typeof useCrmTablesLazyQuery>;
export type CrmTablesQueryResult = Apollo.QueryResult<CrmTablesQuery, CrmTablesQueryVariables>;
export const MatcherTablesDocument = gql`
    query MatcherTables($limit: Int, $offset: Int, $cubeId: String!) {
  matcherTables(limit: $limit, offset: $offset, cubeId: $cubeId) {
    edges
    totalCount
    hasNextPage
    hasPreviousPage
  }
}
    `;

/**
 * __useMatcherTablesQuery__
 *
 * To run a query within a React component, call `useMatcherTablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatcherTablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatcherTablesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      cubeId: // value for 'cubeId'
 *   },
 * });
 */
export function useMatcherTablesQuery(baseOptions: Apollo.QueryHookOptions<MatcherTablesQuery, MatcherTablesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatcherTablesQuery, MatcherTablesQueryVariables>(MatcherTablesDocument, options);
      }
export function useMatcherTablesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatcherTablesQuery, MatcherTablesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatcherTablesQuery, MatcherTablesQueryVariables>(MatcherTablesDocument, options);
        }
export type MatcherTablesQueryHookResult = ReturnType<typeof useMatcherTablesQuery>;
export type MatcherTablesLazyQueryHookResult = ReturnType<typeof useMatcherTablesLazyQuery>;
export type MatcherTablesQueryResult = Apollo.QueryResult<MatcherTablesQuery, MatcherTablesQueryVariables>;
export const MatcherTableHeadersDocument = gql`
    query MatcherTableHeaders($tableName: String!, $cubeId: String!) {
  matcherTableHeaders(tableName: $tableName, cubeId: $cubeId)
}
    `;

/**
 * __useMatcherTableHeadersQuery__
 *
 * To run a query within a React component, call `useMatcherTableHeadersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatcherTableHeadersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatcherTableHeadersQuery({
 *   variables: {
 *      tableName: // value for 'tableName'
 *      cubeId: // value for 'cubeId'
 *   },
 * });
 */
export function useMatcherTableHeadersQuery(baseOptions: Apollo.QueryHookOptions<MatcherTableHeadersQuery, MatcherTableHeadersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatcherTableHeadersQuery, MatcherTableHeadersQueryVariables>(MatcherTableHeadersDocument, options);
      }
export function useMatcherTableHeadersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatcherTableHeadersQuery, MatcherTableHeadersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatcherTableHeadersQuery, MatcherTableHeadersQueryVariables>(MatcherTableHeadersDocument, options);
        }
export type MatcherTableHeadersQueryHookResult = ReturnType<typeof useMatcherTableHeadersQuery>;
export type MatcherTableHeadersLazyQueryHookResult = ReturnType<typeof useMatcherTableHeadersLazyQuery>;
export type MatcherTableHeadersQueryResult = Apollo.QueryResult<MatcherTableHeadersQuery, MatcherTableHeadersQueryVariables>;
export const MatcherTableDataDocument = gql`
    query MatcherTableData($tableName: String!, $cubeId: String!, $limit: Int, $offset: Int, $columnName: String, $keyword: String, $filter: MatcherTableFilter) {
  matcherTableData(
    tableName: $tableName
    cubeId: $cubeId
    limit: $limit
    offset: $offset
    columnName: $columnName
    keyword: $keyword
    filter: $filter
  ) {
    edges
    totalCount
    hasNextPage
    hasPreviousPage
  }
}
    `;

/**
 * __useMatcherTableDataQuery__
 *
 * To run a query within a React component, call `useMatcherTableDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatcherTableDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatcherTableDataQuery({
 *   variables: {
 *      tableName: // value for 'tableName'
 *      cubeId: // value for 'cubeId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      columnName: // value for 'columnName'
 *      keyword: // value for 'keyword'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMatcherTableDataQuery(baseOptions: Apollo.QueryHookOptions<MatcherTableDataQuery, MatcherTableDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatcherTableDataQuery, MatcherTableDataQueryVariables>(MatcherTableDataDocument, options);
      }
export function useMatcherTableDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatcherTableDataQuery, MatcherTableDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatcherTableDataQuery, MatcherTableDataQueryVariables>(MatcherTableDataDocument, options);
        }
export type MatcherTableDataQueryHookResult = ReturnType<typeof useMatcherTableDataQuery>;
export type MatcherTableDataLazyQueryHookResult = ReturnType<typeof useMatcherTableDataLazyQuery>;
export type MatcherTableDataQueryResult = Apollo.QueryResult<MatcherTableDataQuery, MatcherTableDataQueryVariables>;
export const UsersDocument = gql`
    query Users($filter: UsersFilter) {
  users(filter: $filter) {
    id
    role
    email
    cruxyId
    azure_sas_token
  }
}
    `;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUsersQuery(baseOptions?: Apollo.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
      }
export function useUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>;
export const ViewsDocument = gql`
    query Views($filter: ViewsFilter!, $limit: Int, $offset: Int) {
  views(filter: $filter, limit: $limit, offset: $offset) {
    edges
    totalCount
    hasNextPage
    hasPreviousPage
  }
}
    `;

/**
 * __useViewsQuery__
 *
 * To run a query within a React component, call `useViewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useViewsQuery(baseOptions: Apollo.QueryHookOptions<ViewsQuery, ViewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewsQuery, ViewsQueryVariables>(ViewsDocument, options);
      }
export function useViewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewsQuery, ViewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewsQuery, ViewsQueryVariables>(ViewsDocument, options);
        }
export type ViewsQueryHookResult = ReturnType<typeof useViewsQuery>;
export type ViewsLazyQueryHookResult = ReturnType<typeof useViewsLazyQuery>;
export type ViewsQueryResult = Apollo.QueryResult<ViewsQuery, ViewsQueryVariables>;
export const ViewHeadersDocument = gql`
    query ViewHeaders($cubeId: String!, $viewName: String!) {
  viewHeaders(cubeId: $cubeId, viewName: $viewName)
}
    `;

/**
 * __useViewHeadersQuery__
 *
 * To run a query within a React component, call `useViewHeadersQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewHeadersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewHeadersQuery({
 *   variables: {
 *      cubeId: // value for 'cubeId'
 *      viewName: // value for 'viewName'
 *   },
 * });
 */
export function useViewHeadersQuery(baseOptions: Apollo.QueryHookOptions<ViewHeadersQuery, ViewHeadersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewHeadersQuery, ViewHeadersQueryVariables>(ViewHeadersDocument, options);
      }
export function useViewHeadersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewHeadersQuery, ViewHeadersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewHeadersQuery, ViewHeadersQueryVariables>(ViewHeadersDocument, options);
        }
export type ViewHeadersQueryHookResult = ReturnType<typeof useViewHeadersQuery>;
export type ViewHeadersLazyQueryHookResult = ReturnType<typeof useViewHeadersLazyQuery>;
export type ViewHeadersQueryResult = Apollo.QueryResult<ViewHeadersQuery, ViewHeadersQueryVariables>;
export const ViewDataDocument = gql`
    query ViewData($cubeId: String!, $filter: ViewDataFilter!, $limit: Int, $offset: Int) {
  viewData(cubeId: $cubeId, filter: $filter, limit: $limit, offset: $offset) {
    edges
    totalCount
    hasNextPage
    hasPreviousPage
  }
}
    `;

/**
 * __useViewDataQuery__
 *
 * To run a query within a React component, call `useViewDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewDataQuery({
 *   variables: {
 *      cubeId: // value for 'cubeId'
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useViewDataQuery(baseOptions: Apollo.QueryHookOptions<ViewDataQuery, ViewDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewDataQuery, ViewDataQueryVariables>(ViewDataDocument, options);
      }
export function useViewDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewDataQuery, ViewDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewDataQuery, ViewDataQueryVariables>(ViewDataDocument, options);
        }
export type ViewDataQueryHookResult = ReturnType<typeof useViewDataQuery>;
export type ViewDataLazyQueryHookResult = ReturnType<typeof useViewDataLazyQuery>;
export type ViewDataQueryResult = Apollo.QueryResult<ViewDataQuery, ViewDataQueryVariables>;